/* eslint-disable no-undef */
/* eslint-disable react/jsx-key */
const constants = {
	AppName: "RoyCares & Associates",
	LoginHeader: "Login to",
	RegisterHeader: "Register to",
	AnyoneRecover: "Anyone can recover!",
	Tagline: "Renew, Restart, Reset & Refocus",
	AlreadyRegisteredMessage:[<b>You have already registered with RoyCares & Associates. <br/><a rel = "noreferrer" target="_blank" href={process.env.REACT_APP_URLS_FOR_BASE + "/login"}>Click here</a> to login now with the same email address you entered during registration. <br/>Forgot your password? <a rel = "noreferrer" target="_blank" href={process.env.REACT_APP_URLS_FOR_BASE + "/forgot-password"}>Click here</a> to reset your password.</b>],
	ForgotPsdTitle:"Forgot your password? Don't Panic!",
	ForgotPsdSubTitle:"Type the email address linked to your account and we'll send your password reset instructions. The email might end up in your spam folder, so make sure to check there as well.",
	AccountActivation:"Account Activation",
	Profile:"Edit Profile",
	EditEnquiry:"Edit Enquiry",
	MyProfileText:"My Profile",
	MyWorkbook:"My Workbook",
	AdminWorkbook:"Workbook",
	MasterWk: "Master Workbook",
	MasterDocs: "Master Docs",
	// LinkExpired:["This link has expired. Click",<Button className="px-2" type="link" href="/">here</Button>,"to generate a new link for activation."],
	ClientList:"Clients",
	RegistrationLinkText:"Registration Links",
	ParentConsentText:"Parent Consent",
	PaymentAgreement: "Payment Agreement",
	LinkExpired:"This link has expired.",
	ActivationLintGenerate:"to generate a new link for activation.",
	// Labels 
	Username: "Username",
	Password: "Password",
	RegPassword: "Set your unique Password",
	RegConfirmPassword: "Confirm your unique Password",
	NewPsd:"New Password",
	ConfirmNewPsd:"Confirm New Password",
	ResetPsd:"Reset Password",
	FirstName: "First Name",
	Name: "Name",
	LastName: "Last Name",
	ConfirmPsd: "Confirm Password",
	Email: "E-mail Address",
	EmailPlaceholder: "your.email@mail.com",
	country: "Country",
	state: "State",
	city: "City",
	Age:"Age",
	PaidBy:"Paid By",
	phone: "Phone Number (WhatsApp)",
	NotesVisible : "View other's Notes",
	AddNote: "Add Note",
	EditNote: "Edit Note",
	Gender:"Gender",
	dob:"Date of Birth",
	Doe:"Date of Enquiry",
	AssessmentTitle: "Please fill out the Self-Assessment form below as completely as possible.",
	InitialAssessmentGeneral:"Initial Assessment General",
	Startdt: "Start date",
	Enddt: "End Date",
	occupation: "Occupation",
	addict: "Addict/Gambler",
	NotAnAddict: "Non-Addict",
	FullCost:"Full cost",
	Male:"Male",
	Female:"Female",
	Scholarship:"Scholarship",
	FriendsAndFamily:"Friends And Family",
	FamilyAndFriends: "Family And Friends",
	BriefAssessment: "Brief Assessment",
	SpclScholarship:"Special Scholarship",
	Adult:"Adult",
	Minor:"Minor",
	PasswordNotMatch: "The two passwords that you entered do not match!",
	PsdTip: "Password should be more than 2 characters.",
	PasswordNoSpace: "No space allowed",
	Subtitle:"R.A.R.E. - RoyCares & Associates Amazing Readjustment Experience Workbook",
	sec:"Section",
	childDetailFormheader:"Minor's Details",
	clientDetailFormheader:"Client Details",
	otherDetailFormheader: "Other's Details",
	callerDetailFormheader: "Caller's Details",
	parentsName:"Parent's Name",
	parentsEmail:"Parent's Email",
	clientName:"Client Name",
	Payment:"Payment Info",
	ConfidentialInfo:"Confidential Info",
	Plan:"Plan",
	Program:"Program",
	EnableSection : "Enable Section",
	UnEnableSection : "UnEnable Section",
	EnableSectionDescription:"Are you sure you want to Enable Section",
	UnEnableSectionDescription:"Are you sure you want to UnEnable Section",
	ParentsDetails:"Parent's Details", 
	InterestIn: "Interested in",
	// personal_info:"Personal Info",
	//completing on section meessage
	complete:"Congratulations",
	complete2:"Thank you for completing Section",
	complete3:<div> After you discuss and process this section with your coach you will receive a message to enable you to move to the next section.</div>,
	complete4:<div>Thank you.</div>,
	RefresherCompletedMessage:"Thank you for completing Refresher Workbook.",
	sec1:"Section 1",
	sec2:"Section 2",
	sec3:"Section 3",
	sec4:"Section 4",
	sec5:"Section 5",
	sec6:"Section 6",
	sec7:"Section 7",
	sec8:"Section 8",
	ChangeJar: "Change Jar",
	ChangeJarPara: [<><p>We can’t allow these negative personality traits make us react to hurt instincts in a manner that aggravate the other party <i>(even though they are completely in the wrong)</i>, and make them act in a way that makes the situation worse, thus perpetuating the cycle of problems.</p>
		<ol><li value="2"><br /><br /></li></ol></>],
	GratitudeJar: "Gratitude Jar",
	sec1sub:"Identify the Addiction problems.",
	sec2sub: "Identify areas you may be struggling with",
	sec3sub: <>The Causes...<br />Relapse Prevention<br />Sober Strategies</>,
	sec4sub: "Review how we REACT with ANGER and how we ACT",
	sec5sub:"Review how we REACT with FEAR and how we ACT.",
	sec6sub: <>What’s holding me back?<br />Personality flaws and character disorders which may have harmed me or others.</>,
	sec7sub: "Relapse Prevention and Recovery living",
	sec8sub:"Ongoing Coaching",
	sec3MasterSub: "The Causes...Relapse Prevention.. Sober Strategies",
	sec6MasterSub: "What’s holding me back? Personality flaws and character disorders which may have harmed me or others.",
	weekSubtitles: [
		"Understanding My Patterns",
		"Ambivalence & Mixed Feelings",
		"Triggers & High-Risk Situations",
		"The Function of My Use",
		"Preparing for Change",
		"Urges, Cravings & Staying in Control",
		"Emotional Regulation & Distress Tolerance",
		"Relapse Prevention & Slip Management",
		"Health, Sleep & Physical Well-Being",
		"Relationships, Boundaries & Communication",
		"Identity, Values & Purpose",
		"Maintenance, Growth & The Next Chapter"
	],
	// Buttons & links
	ForgotPsdRedirectLink: "Forgot password?",
	LoginBTN: "Login",
	RegisterBTN: "Register",
	ContactEmail: "info@roycares.org",
	UsefulLinks:"Useful Links",
	SendIns:"Send Instructions",
	UpdateBtn:"Update",
	SendBtn:"Send",
	Cancel:"Cancel",
	ChangePsd:"Change Password",
	SaveClose:"Save & Close",
	BackBtn:"Back",
	CloseBtn:"Close",
	Resume:"Resume",
	Next: "Next",
	GoToPage: "Go To Page",
	Discussed:"Discussed",
	Save: "Save",
	Remove: "Remove",
	Submit:"Submit",
	Delete:"Delete",
	Previous: "Previous",
	Preview: "Preview",
	CancelBTN: "Cancel",
	Completed:"Completed",
	//Registration form validation
	FirstNameRegistration: "Enter first name",
	FillThisField: "Please fill out this field.",
	FirstNameInvalid:"Invalid first name",
	NameInvalid:"Invalid name",
	parentInvalid:"Invalid parent name",
	selctclientType:"Select Workbook Type",
	SelectPaymentBy:"Select Paid By",
	LastNameRegistration: "Enter last name",
	LastNameInvalid:"Invalid last name",
	CountryRegistration: "Select Country",
	StateRegistration: "Select State",
	CityRegistration: "Enter City",
	EmailRegistration: "Enter email",
	emailVaidationError:"Email should be unique and valid",
	endDateValidationError: "Enter a valid End Date",
	PhoneNoRegistration: "Enter Phone Number (WhatsApp)",
	RequiredField:"This field is required",
	GenderVaidationMessage: "Select Gender",
	ParentPhoneNoRegistration: "Enter Parent Phone Number (WhatsApp)",
	PasswordRegistration: "Enter password",
	enterdob: "Enter Date of Birth",
	//API environment constants
	Pdfurl:process.env.REACT_APP_BASE_URL,
	ApiUrl: process.env.REACT_APP_API_URL,
	BaseUrl: process.env.REACT_APP_URLS_FOR_BASE,
	AdminApiUrl: process.env.REACT_APP_API_ADMIN_URL,
	// RegisterSuccess: "Registration completed successfully",
	RegisterSuccess: "Thank you for registering for the RARE Program - RoyCares Amazing Recovery Experience! Please click the NEXT button to take you to complete the Coaching Agreement we discussed, so that we can begin. ",
	PasswordValidation:"Password length should be minimum 8 characters. It must contain at least 1 uppercase letter, 1 lowercase letter, a number, any special character and no spaces.",
	RegisterSuccessEmailMessage: ["Your account is almost ready. Please click the link in your email to activate the account.",
		<br key={0}/>,
		"If you do not find the email in your Inbox, make sure to check your Spam folder."],
	//Message Time
	MessageDisplayLong:8,
	//Login
	LoginEmailValid:"Enter Username",
	LoginPasswordValid:"Enter Password",
	LoginRestriction:"Roy Cares application was opened in another window.",
	LoginRestrictionPart2:'Click "Use Here" button to continue using the application in this window.',
	ValidationMessage:"Please select an answer for all the questions.",
	//date formate
	dateformat:"ll",
	//esign popup message
	EsignPopupMessageConsentForm:["Thank you for signing the Coaching Agreement!",<br/>,"Please click the OK button to complete the Consent Form."],
	EsignPopupMessage:["Thank you for signing the Consent Form.",<br/>,"Please click the OK button to complete the General Release Form."],
	//Workbook message
	WorkbookInstructionsText:"Welcome to the RoyCares! RARE program Section",
	WorkbookInstructionsTextRefresher:"Welcome to the RoyCares! RARE program Refresher Workbook",
	WorkbookInstructionsText2:[<br/>,"Please begin this section and complete as thoroughly as possible.",<br/>,"Feel free to message me if you have any doubts or questions and we will discuss it.",<br/>,"There are NO FOOLISH QUESTIONS.",<br/>,"We are here to answer them all."],
	WorkbookHeaderText:"Get Started",
	// DashboardWelcomeMessage:"Welcome to RoyCares!. Please contact your coach to commence your sessions.",
	DashboardWelcomePayment: [<b>Thank you for signing up for RARE Program - RoyCares Amazing Recovery Experience!</b>, <br />, <b> Kindly contact your coach to enable the Section(s).</b>],
	DashboardWelcomeMessage:[<b>Thank you so much for completing the Coaching Agreement and Consent Forms.</b>,<br/>,<b>Please complete the payment to commence your sessions.</b>],
	DashboardWelcomeMessageFamilyMember:[<b>Thank you so much for completing the Coaching Agreement and Consent Forms.</b>],
	DashboardWelcomeMessageMinor: [<b>Thank you so much for completing the Coaching Agreement and Consent Forms.</b>, <br />, <b>Once your parent(s) complete the payment, a coach will contact you.</b>],
	DashboardWelcomeRefresher:[<b>{"Thank you so much for completing the Refresher's Coaching Agreement and Consent Forms."}</b>],
	DashboardSelfAssessmentComMessage:[<b>{"Thank you so much for completing the Self Assessment form."}</b>],
	// DashboardMinorWelcomeMessage:["Thanks you so much for completing the profile form.",<br/>,"Your parent/guardian needs to give consent to proceed further.",<br/>,"Thank you."],
	ParentConsentMessage:[<b>Thank you so much for completing the Parent Consent Form.</b>,<br/>,<b>Please complete the payment. A RoyCares coach will contact your child thereafter.</b>,<br/>],
	ParentConsentMessage2 :[<b>Click <a rel = "noreferrer" target="_blank" href="https://roycares.org/">roycares.org</a> to learn more about our services.</b>],
	CallerMessage: [<b>Thank you so much for completing the Payment Agreement.</b>, <br />, <b>Please complete the payment. A RoyCares coach will contact the Client thereafter.</b>, <br />],
	PlanHeading : "Choose plan for selected",
	//checkbox table values
	GeneralOptions : [
		{
			label: 'Annoyed',
			value: 'Annoyed',
			tooltip: ''
		},
		{
			label: 'Bored',
			value: 'Bored',
			tooltip: ''
		},
		{
			label: 'Burned-up',
			value: 'Burned-up',
			tooltip: ''
		},
		{
			label: 'Contemptuous',
			value: 'Contemptuous',
			tooltip: ''
		},
		{
			label: 'Discontented',
			value: 'Discontented',
			tooltip: ''
		},
		{
			label: 'Dissatisfied',
			value: 'Dissatisfied',
			tooltip: ''
		},
		{
			label: 'Dishonest',
			value: 'Dishonest',
			tooltip: ''
		},
		{
			label: 'Enraged',
			value: 'Enraged',
			tooltip: ''
		},
		{
			label: 'Envious',
			value: 'Envious',
			tooltip: 'Envy is when you want what someone else has'
		},
		{
			label: 'Fearful',
			value: 'Fearful',
			tooltip: ''
		},
		{
			label: 'Frustrated',
			value: 'Frustrated',
			tooltip: ''
		},
		{
			label: 'Grumpy',
			value: 'Grumpy',
			tooltip: ''
		},
		{
			label: 'Hateful',
			value: 'Hateful',
			tooltip: ''
		},
		{
			label: 'Irritated',
			value: 'Irritated',
			tooltip: ''
		},
		{
			label: 'Intolerant',
			value: 'Intolerant',
			tooltip: ''
		},
		{
			label: 'Impatient',
			value: 'Impatient',
			tooltip: ''
		},
		{
			label: 'Judgmental',
			value: 'Judgmental',
			tooltip: ''
		},
		{
			label: 'Jealous',
			value: 'Jealous',
			tooltip: "Jealousy is when you're worried someone's trying to take what you have."
		},
		{
			label: 'Laziness',
			value: 'Laziness',
			tooltip: ''
		},
		{
			label: 'Lonely',
			value: 'Lonely',
			tooltip: ''
		},
		{
			label: 'Resentment',
			value: 'Resentment',
			tooltip: ''
		},
		{
			label: 'Restless',
			value: 'Restless',
			tooltip: ''
		},
		{
			label: 'Self-pity',
			value: 'Self-pity',
			tooltip: ''
		},
		{
			label: 'Sore',
			value: 'Sore',
			tooltip: ''
		},
		{
			label: 'Selfishness',
			value: 'Selfishness',
			tooltip: ''
		},
		{
			label: 'Sarcastic',
			value: 'Sarcastic',
			tooltip: ''
		},
		{
			label: 'Spiteful',
			value: 'Spiteful',
			tooltip: ''
		},
		{
			label: 'Unforgiving',
			value: 'Unforgiving',
			tooltip: ''
		},
		{
			label: 'Vengeful',
			value: 'Vengeful',
			tooltip: ''
		},
		{
			label: 'Vanity',
			value: 'Vanity',
			tooltip: ''
		},
	],
	BuddhismOptions : [
		{
			label: 'Ignorance',
			value: 'Ignorance',
			tooltip: ''
		},
		{
			label: 'Attachment',
			value: 'Attachment',
			tooltip: ''
		},
		{
			label: 'Aversion',
			value: 'Aversion',
			tooltip: ''
		},
		{
			label: 'Pride',
			value: 'Pride',
			tooltip: ''
		},
		{
			label: 'Jealously',
			value: 'Jealously',
			tooltip: ''
		},
	],
	ChristianityOptions:[
		{
			label: 'Lust',
			value: 'Lust',
			tooltip: ''
		},
		{
			label: 'Gluttony',
			value: 'Gluttony',
			tooltip: ''
		},
		{
			label: 'Greed',
			value: 'Greed',
			tooltip: ''
		},
		{
			label: 'Sloth',
			value: 'Sloth',
			tooltip: ''
		},
		{
			label: 'Wrath',
			value: 'Wrath',
			tooltip: ''
		},
		{
			label: 'Envy',
			value: 'Envy',
			tooltip: ''
		},
		{
			label: 'Pride',
			value: 'Pride2',
			tooltip: ''
		},
	],
	SpiritualOptions:[
		{
			label: 'Politics Without Principles',
			value: 'Politics Without Principles',
			tooltip: ''
		},
		{
			label: 'Wealth Without Work',
			value: 'Wealth Without Work',
			tooltip: ''
		},
		{
			label: 'Commerce Without Morality',
			value: 'Commerce Without Morality',
			tooltip: ''
		},
		{
			label: 'Education Without Character',
			value: 'Education Without Character',
			tooltip: ''
		},
		{
			label: 'Pleasure Without Conscience',
			value: 'Pleasure Without Conscience',
			tooltip: ''
		},
		{
			label: 'Science Without Humanity',
			value: 'Science Without Humanity',
			tooltip: ''
		},
		{
			label: 'Worship Without Sacrifice',
			value: 'Worship Without Sacrifice',
			tooltip: ''
		},
	],
	HinduismOptions:[
		{
			label: 'Kama (lust)',
			value: 'Kama (lust)',
			tooltip: ''
		},
		{
			label: 'Krodha (Anger)',
			value: 'Krodha (Anger)',
			tooltip: ''
		},
		{
			label: 'Lobha (Greed)',
			value: 'Lobha (Greed)',
			tooltip: ''
		},
		{
			label: 'Moha (Delusion)',
			value: 'Moha (Delusion)',
			tooltip: ''
		},
		{
			label: 'Mada (Pride)',
			value: 'Mada (Pride)',
			tooltip: ''
		},
		{
			label: 'Matsarya (Jealously)',
			value: 'Matsarya (Jealously)',
			tooltip: ''
		},
	],
	SikhismOptions : [
		{
			label: 'Kam-excessive desire for sex',
			value: 'Kam-excessive desire for sex',
			tooltip: ''
		},
		{
			label: 'Krodh-excessive Anger',
			value: 'Krodh-excessive Anger',
			tooltip: ''
		},
		{
			label: 'Lob-excessive materialistic Desire',
			value: 'Lob-excessive materialistic Desire',
			tooltip: ''
		},
		{
			label: 'Moh-lack of knowledge',
			value: 'Moh-lack of knowledge',
			tooltip: ''
		},
		{
			label: 'Ahankar-Ego',
			value: 'Ahankar-Ego',
			tooltip: ''
		},
	],
	IslamOptions:[
		{
			label: 'Drinking',
			value: 'Drinking',
			tooltip: ''
		},
		{
			label: 'Gambling',
			value: 'Gambling',
			tooltip: ''
		},
		{
			label: 'Adultery',
			value: 'Adultery',
			tooltip: ''
		},
		{
			label: 'Murder',
			value: 'Murder',
			tooltip: ''
		},
		{
			label: 'Theft',
			value: 'Theft',
			tooltip: ''
		},
		{
			label: 'Slander',
			value: 'Slander',
			tooltip: ''
		},
		{
			label: 'Lying',
			value: 'Lying',
			tooltip: ''
		},
		{
			label: 'Showing off',
			value: 'Showing off',
			tooltip: ''
		},
		{
			label: 'Flirting',
			value: 'Flirting',
			tooltip: ''
		},
		{
			label: 'Swearing',
			value: 'Swearing',
			tooltip: ''
		},
		{
			label: 'Backbiting',
			value: 'Backbiting',
			tooltip: ''
		},
	],
	dobdateFormat:"MM/DD/YYYY",
	SectionZeroPart:{
		welcome:1,
		coachingAgreementpageone:2,
		coachingAgreementpagetwo:3,
		suicidelForm:4,
		releaseFormpageone:5,
		releaseFormpagetwo:6
	},
	ProfileForm:"Profile Form",
	ConsentForm:"Consent Form",
	BioForm: "Bio Form",
	SuicideForm: "Suicidal Ideation Form",
	PreAssessment: "Pre Assessment",
	SelfAssessment: "Self Assessment",
	Details:"Details",
	WelcomePage:"Welcome Page",
	CoachingAgreement:"Coaching Agreement",
	ReleaseForm:"Release Form",
	profileUpdate:"Profile updated successfully",
	DownloadAgrementBtn: "View Agreement",
	DownloadParentAgrement: "View Parent's Consent",
	DownloadPDF: "Download PDF",
	Uploadfile: "Upload File",
	downloadargrementText:"Click the Download Agreement button to view a copy of the Coaching Agreement signed by your child.",
	uploadText:"Please attach proof of relationship to child – Govt. issued document with both names ie birth certificate or passport, etc.",
	commitmentToPayitemId:"684",
	commitmentToPayVM:"Please enter the amount.",
	SpecialCost:"Special Cost",
	ageProofVM:"Please upload age proof.",
	signVM:"Please sign the Coaching Agreement.",
	signPA: "Please sign the Payment Agreement.",
	signVMCF:"Please sign the Consent Form.",
	signMedicalVM:"Please sign the General Release Form.",
	section0VM:"Please fill an answer for the questions.",
	section0VMCF:"Please fill all the details.",
	notesVM:"Please save your Notes.",
	ageproofV:"View Age Proof",
	ViewNotes:"View Notes",
	ImageList:"Daily Images",
	DocumentList:"Documents",
	AllDocs: "All Documents",
	ClientNotes: "Client Notes",
	Notes: "Notes",
	NotesEditClientField: "Notes to be displayed on Coaching/Counseling Agreement",
	ClientDocs: "Client Docs",
	DocsSigned: "Documents Signed",
	PaymentStatement:"Payment Statement",
	MedicalInfo:"Medical Info Release",
	AddDocument:"Upload Document",
	ClientEL:"Enquiries",
	UploadImages:"Upload Images",
	UploadVideo:"Upload Video",
	paginationConfig :{ 
		pageSize: 25,
		pageSizeOptions:[10,25,50,100]
	},
	DocumentTypeOption : [
		{
			value: "2",
			label: "Discharge Report",
		},
		{
			value: "1",
			label: "Medical Info Release",
		},
		{
			value: "3",
			label: "Medical Report",
		},
		{
			value: "4",
			label: "Prescription",
		},
		{
			value: "7",
			label: "Others",
		}
	],
	HeaderRegistrationLinkPopupM:"Request for Parent Consent",
	HeaderRegistrationLinkPopupA:"Send link for Registration",
	HeaderCoachingAgreementLinkPopup:"Send Coaching Agreement",
	RefresherHeader:"Send link for Refresher",
	PlanCompleted:"Plan Completed",
	Refresher:"Refresher",
	RefresherWorkSheet:"Refresher Worksheet",
	AssignTo:"Assign To",
	AssignedTo:"Assigned To",
	SevenDays:"In-Person/Online",
	ThirtyDays:"Online",
	OneDay:"Refresher",
	Unlimited:"General Coaching",
	Family:"Family",
	Self:"Self",
	Other:"Other",
	Source:"Source",
	SourcePlaceHolder:"Please choose an option",
	SourceOption : [
		{
			value: "1",
			label: "Website",
		},
		{
			value: "2",
			label: "Linkedin",
		},
		{
			value: "3",
			label: "YouTube",
		},
		{
			value: "4",
			label: "WhatsApp",
		},
		{
			value: "5",
			label: "Facebook",
		},
		{
			value: "6",
			label: "Instagram",
		},
		{
			value: "7",
			label: "Twitter",
		},
		{
			value: "8",
			label: "Friends/Professional",
		},
		{
			value: "9",
			label: "Others",
		},
		{
			value: "10",
			label: "Rehab",
		}
	],
	MoreDetails:"More Details",
	OtherDetails:"Other Details",
	General:"General",
	Associates : "Associates",
	DemoClient : "Demo Client",
	AddAssociates : "Add Associates",
	AddAssociateDetails: "Add Associate Details",
	EditAssociateDetails: "Edit Associate Details",
	Add:"Add",
	Esign:"E-sign",
	Sign:"Sign",
	GamblingValidateMessage: "Your result - You answered No to both the options. You are doing well. We suggest that you go over the options again with a loved one or best friend to be sure you have been honest in your responses.",
	Caller:"Caller",
	Parent: "Parent",
	Client:"Client",
	Status1Ttip:"Status when you started the program",
	Status2Ttip:"Status when you last completed the program",
	Status3Ttip:"Status when you are completing the program",
	SectionOptions : [
		{
			value: "1",
			label: "Section 1",
		},
		{
			value: "2",
			label: "Section 2",
		},
		{
			value: "3",
			label: "Section 3",
		},
		{
			value: "4",
			label: "Section 4",
		},
		{
			value: "5",
			label: "Section 5",
		},
		{
			value: "6",
			label: "Section 6",
		},
		{
			value: "7",
			label: "Section 7",
		},
		{
			value: "8",
			label: "Section 8",
		},
		{
			value: "100",
			label: "Refresher",
		},
		{
			value: "none-of-the-above",
			label: "None of the above",
		}
	],
	ExportToWord:"Export to Excel",
	RearrangeEnq: "Rearrange Enquiry",
	Filter:"Filter",
	SectionBackNavigationMessage:"If you click the OK button, the section will be automatically saved. You will be able to resume it later. Click Cancel if you wish to continue answering the session.",
	Session:"Session",
	Sessions: "Session (s)",
	PlanCost: "Plan Cost",
	SessionCost: "Per Session Cost",
	TotalCost: "Total Plan Cost",
	DisplayCostMsg: "Display Payment on Coaching Agreement.",
	DisplayFamSess: "Display Family Session on Coaching Agreement.",
	DisplayPsychAssess: "Display Psych Assessment on Coaching Agreement.",
	AgreementsNo: "No Agreements available for the selected Associate.",
	ShareWith: "Share With",
	SharedWith: "Shared With",
	Services: "Services",
	AddFnF: "Add Family and Friends",
	EditFnF: "Edit Family and Friends",
	SendFamilyAgg: "Send Family Agreement",
	Relation: "Relation",
	Trauma:"Trauma",
	YouthAndWomen:"Youth & Women",
	All:"All",
	TransferTo: "Transferred to",
	DeleteDescription: "Please provide the enquiry ID to perform deletion.",
	DeleteModal: "Are you sure you want to delete Enquiry",
	//General plan options
	GeneralPlanOptions : [
    { value: "3", label: "All" },
    { value: "1", label: "Trauma" },
    { value: "2", label: "Youth & Women" }
  ],
	AgreementOptions :[
	{ value: 30, label: "Online" },
    { value: 7, label: "In-person/Online" },
    { value: 1, label: "Refresher" },
    { value: 0, label: "General" },
		//setting value 100 for family agreement.
	{ value: 100, label: "Family" },
  ],
  AddictAgreementOptions :[
	{ value: 30, label: "Online" },
    { value: 7, label: "In-person/Online" },
    { value: 1, label: "Refresher" },
    { value: 0, label: "General" },
  ],
  NonAddictAgreementOptions :[
    { value: 0, label: "General" },
		//setting value 100 for family agreement.
	{ value: 100, label: "Family" },
  ],
	Enquiry:"Enquiry",
	SectionApprovalMessage:"Please click Submit and discuss the topic(s) with your Coach at your next session.",
	WbContents:"Wb Contents",
	ClientAnswers:"Client Answers",
	// anger sheet table values
	Sec4FutureOptions: [
		"Taking out the heat",
		"Distraction",
		"Self-talk and good thinking",
		"Assertiveness and practice",
		"Consider Whether My Anger Is Helpful or Unhelpful",
		"Talk Through My Feelings",
		"Get in a Quick Workout",
		"Focus on the Facts",
		"Acknowledge My Underlying Emotion",
		"Avoid Suppressing My Anger",
		'Create a "Calm-Down" Kit',
		"Get Advice",
		"Check myself",
		"Don't dwell",
		"Change the way I think",
		'Avoid words like "never" or "always"',
		"Translate expectations into desires",
		"Focused breathing",
		"Get Active",
		"Regular physical exercise",
		"Recognize (and avoid) my triggers",
		"Think before I speak",
		"Once I'm calm, express my concerns",
		"Take a timeout",
		"Identify Possible Solutions",
		"Stick with 'I' statements",
		"Don't hold a grudge",
		"Use humor to release tension",
		"Practice relaxation skills",
		"Know when to seek help",
	],
	Sec5FutureOptions: [
		"Distraction",
		"Self-talk and good thinking",
		"Assertiveness and practice",
		"Consider Whether My Fear is real or imagined",
		"Get in a Quick Workout",
		"Focus on the Facts",
		'Create a "Calm-Down" Kit',
		"Get Advice",
		"Check myself",
		"Don't dwell",
		"Change the way I think",
		"Physical exercise",
		"Identify possible solutions",
		"Take some time out",
		"Remember that anxiety isn't harmful",
		"Challenge unhelpful thoughts",
		"Don't try to be perfect",
		"Visualise a happy place",
		"Talk about it",
		"Mindfulness",
		"Try progressive muscle relaxation",
		"Find humor in the situation",
		"Seek professional help",
		"Make an action plan to face my Fears",
		"Practice deep breathing",
		"Figure out what is causing the anxiety",
		"Reward myself",
		"Avoid negative self-talk",
		"Aromatherapy",
		"Spend time outside",
		"Take care of my basic needs",
		"Relax",
		"Learn to say No",
		"Journal it out",
	],
	Sec6Options: [
		'Aromatherapy',
		'Acknowledge My Underlying Emotion',
		'Assertiveness and practice',
		'Avoid Suppressing My Anger',
		'Avoid negative self-talk',
		'Avoid words like "never" or "always"',
		'Challenge unhelpful thoughts',
		'Change the way I think',
		'Check myself',
		'Consider Whether My Anger Is Helpful or Unhelpful',
		'Consider Whether My Fear is real or imagined',
		'Create a "Calm-Down" Kit',
		'Distraction',
		"Don't hold a grudge",
		"Don't dwell",
		"Don't try to be perfect",
		'Figure out what is causing the anxiety',
		'Use humor to release tension',
		'Focus on the Facts',
		'Get Advice',
		'Get in a Quick Workout',
		'Identify possible solutions',
		'Journal it out',
		'Learn to say No',
		'Make an action plan to face my Fears',
		'Mindfulness',
		"Once I'm calm, express my concerns",
		'Physical exercise',
		'Practice deep breathing',
		'Relax',
		'Recognize (and avoid) my triggers',
		"Remember that anxiety isn't harmful",
		'Reward myself',
		'Seek professional help',
		'Self-talk and good thinking',
		'Spend time outside',
		"Stick with 'I' statements",
		'Take care of my basic needs',
		'Take some time out',
		'Taking out the heat',
		'Talk about it',
		'Talk Through My Feelings',
		'Think before I speak',
		'Try progressive muscle relaxation',
		'Visualise a happy place',
		'Translate expectations into desires',
	],
	AddRow: "Add Row",
	Type1: [
		{
			label: 'Sleep Deprivation',
			value: 'Sleep Deprivation'
		},
		{
			label: 'Occupational Hazards',
			value: 'Occupational Hazards'
		},
		{
			label: 'Aging',
			value: 'Aging'
		},
		{
			label: 'Chronic Illness',
			value: 'Chronic Illness'
		},
		{
			label: 'Disability',
			value: 'Disability'
		},
		{
			label: 'Living in a Violent Area',
			value: 'Living in a Violent Area'
		},
		{
			label: 'Lack of Access to Healthcare',
			value: 'Lack of Access to Healthcare'
		},
		{
			label: 'Living in Hazard-Prone Areas',
			value: 'Living in Hazard-Prone Areas'
		},
		{
			label: 'Living near an Industrial Zones',
			value: 'Living near an Industrial Zones'
		},
		{
			label: 'Relapse',
			value: 'Relapse'
		}
	],
	Type2: [
		{
			label: 'Job Insecurity',
			value: 'Job Insecurity'
		},
		{
			label: 'High Debt Levels',
			value: 'High Debt Levels'
		},
		{
			label: 'Lack of Savings or Emergency funds',
			value: 'Lack of Savings or Emergency funds'
		},
		{
			label: 'Single Income Stream',
			value: 'Single Income Stream'
		},
		{
			label: 'Low Income',
			value: 'Low Income'
		},
		{
			label: 'Lack of Insurance Coverage',
			value: 'Lack of Insurance Coverage'
		},
		{
			label: 'Lack of Finacial Literacy',
			value: 'Lack of Finacial Literacy'
		},
		{
			label: 'Economic Recession',
			value: 'Economic Recession'
		},
		{
			label: 'Underemployment',
			value: 'Underemployment'
		},
		{
			label: 'Lack of Access to Credit',
			value: 'Lack of Access to Credit'
		}
	],
	Type3: [
		{
			label: 'Isolation or Lack of Community or Peer Support',
			value: 'Isolation or Lack of Community or Peer Support'
		},
		{
			label: 'Being part of a Marginalized Group (Relapsers)',
			value: 'Being part of a Marginalized Group (Relapsers)'
		},
		{
			label: 'Being a Target of Discrimination or Prejudice (Gender/Religion)',
			value: 'Being a Target of Discrimination or Prejudice (Gender/Religion)'
		},
		{
			label: 'Language Barriers',
			value: 'Language Barriers'
		},
		{
			label: 'Poverty',
			value: 'Poverty'
		},
		{
			label: 'Lack of Educational Opportunities',
			value: 'Lack of Educational Opportunities'
		},
		{
			label: 'Limited Mobility',
			value: 'Limited Mobility'
		},
		{
			label: 'Living in an area with High Crime Rates',
			value: 'Living in an area with High Crime Rates'
		},
		{
			label: 'Social Stigma Associated with Mental Illness',
			value: 'Social Stigma Associated with Mental Illness'
		}
	],
	Type4: [
		{
			label: 'Fear of Rejection',
			value: 'Fear of Rejection'
		},
		{
			label: 'Unresolved Trauma',
			value: 'Unresolved Trauma'
		},
		{
			label: 'Low Self Esteem',
			value: 'Low Self Esteem'
		},
		{
			label: 'Need for External Validation',
			value: 'Need for External Validation'
		},
		{
			label: 'Difficulty in Setting Boundaries',
			value: 'Difficulty in Setting Boundaries'
		},
		{
			label: 'Fear of Loneliness',
			value: 'Fear of Loneliness'
		},
		{
			label: 'Lack of Emotional Intelligence',
			value: 'Lack of Emotional Intelligence'
		},
		{
			label: 'Difficulty Trusting Others',
			value: 'Difficulty Trusting Others'
		},
		{
			label: 'Insecurity about Identity',
			value: 'Insecurity about Identity'
		},
		{
			label: 'High Dependency on Relationships',
			value: 'High Dependency on Relationships'
		}
	],
	Type5: [
		{
			label: 'Alcohol',
			value: 'Alcohol'
		},
		{
			label: 'Animals',
			value: 'Animals'
		},
		{
			label: 'Authority',
			value: 'Authority'
		},
		{
			label: 'Abandonment',
			value: 'Abandonment'
		},
		{
			label: 'Being Alone',
			value: 'Being Alone'
		},
		{
			label: 'Being Alive',
			value: 'Being Alive'
		},
		{
			label: 'Being Found Out',
			value: 'Being Found Out'
		},
		{
			label: 'Confrontation',
			value: 'Confrontation'
		},
		{
			label: 'Crying',
			value: 'Crying'
		},
		{
			label: 'Creditors',
			value: 'Creditors'
		},
		{
			label: 'Change',
			value: 'Change'
		},
		{
			label: 'Drugs',
			value: 'Drugs'
		},
		{
			label: 'Dying',
			value: 'Dying'
		},
		{
			label: 'Doctors',
			value: 'Doctors'
		},
		{
			label: 'Employment',
			value: 'Employment'
		},
		{
			label: 'Employer',
			value: 'Employer'
		},
		{
			label: 'Feelings',
			value: 'Feelings'
		},
		{
			label: 'Fear',
			value: 'Fear'
		},
		{
			label: 'Failure',
			value: 'Failure'
		},
		{
			label: 'God',
			value: 'God'
		},
		{
			label: 'Goons',
			value: 'Goons'
		},
		{
			label: 'Getting Old',
			value: 'Getting Old'
		},
		{
			label: 'Government',
			value: 'Government'
		},
		{
			label: 'Gangs',
			value: 'Gangs'
		},
		{
			label: 'Gossip',
			value: 'Gossip'
		},
		{
			label: 'Heights',
			value: 'Heights'
		},
		{
			label: 'Hospitals',
			value: 'Hospitals'
		},
		{
			label: 'Insanity',
			value: 'Insanity'
		},
		{
			label: 'Intimacy',
			value: 'Intimacy'
		},
		{
			label: 'Insects',
			value: 'Insects'
		},
		{
			label: 'Insecurity',
			value: 'Insecurity'
		},
		{
			label: 'Jail',
			value: 'Jail'
		},
		{
			label: 'kids',
			value: 'kids'
		},
		{
			label: 'Loneliness',
			value: 'Loneliness'
		},
		{
			label: 'Losing a Child',
			value: 'Losing a Child'
		},
		{
			label: 'Losing a Spouse',
			value: 'Losing a Spouse'
		},
		{
			label: 'Men',
			value: 'Men'
		},
		{
			label: 'Night',
			value: 'Night'
		},
		{
			label: 'Physical Pain',
			value: 'Physical Pain'
		},
		{
			label: 'Police',
			value: 'Police'
		},
		{
			label: 'Parents',
			value: 'Parents'
		},
		{
			label: 'Poverty',
			value: 'Poverty'
		},
		{
			label: 'People',
			value: 'People'
		},
		{
			label: 'Responstibilty',
			value: 'Responstibilty'
		},
		{
			label: 'Rejection',
			value: 'Rejection'
		},
		{
			label: 'Races',
			value: 'Races'
		},
		{
			label: 'Relapse',
			value: 'Relapse'
		},
		{
			label: 'Stealing',
			value: 'Stealing'
		},
		{
			label: 'Sex',
			value: 'Sex'
		},
		{
			label: 'Sin',
			value: 'Sin'
		},
		{
			label: 'Self- Expression',
			value: 'Self- Expression'
		},
		{
			label: 'Success',
			value: 'Success'
		},
		{
			label: 'Sobriety',
			value: 'Sobriety'
		},
		{
			label: 'Unemployment',
			value: 'Unemployment'
		},
		{
			label: 'The Unknown',
			value: 'The Unknown'
		},
		{
			label: 'Wealthy People',
			value: 'Wealthy People'
		},
		{
			label: 'Writing Inventory',
			value: 'Writing Inventory'
		},
		{
			label: 'Women',
			value: 'Women'
		},
		{
			label: 'Violence',
			value: 'Violence'
		}
	],
	ReactionResponses: ['FAWN', 'FIGHT', 'FLIGHT', 'FREEZE'],
	ReactionSigns: {
		FIGHT: ['Tight jaw', 'Grinding your teeth', 'Urge to punch something or someone', 'Fear of Loneliness', 'A feeling of intense anger', 'Need to stomp or kick', 'Crying in anger', 'A burning or knotted sensation in your stomach', 'Attacking the source of danger'],
		FLIGHT: ['Excessive exercising', 'Feeling fidgety, tense, or trapped', 'Constantly moving your legs, feet and arms', 'Restless body', 'Feeling of numbness in your arms and legs', 'Dilated, darting eyes'],
		FREEZE: ['Sense of dread', 'Pale skin, tense, or trapped', 'Feeling stiff, heavy, cold, and numb', 'Loud and pounding heart', 'Decreasing heart rate'],
		FAWN: ['Over-agreemnt', 'Trying to be overly helpful', 'Primary concern with making someone else happy'],
	},
	Status:"Status",
	Ethnicity: "Ethnicity",
	Religion:"Religion",
	ReferredBy:"Referred by",
	SelfAssessmentSummy: "Self Assessment Summary",
	PreAssessmentSummy: "Pre-Assessment Intake",
	EditPreAssessmentSummy: "Edit Pre-Assessment Intake",
	EditSelfAssessmentSummy: "Edit Self-Assessment Summary",
	Substances :[
		{
			key:"not_applicable",
			substances:"Not Applicable"
		},
		{
			key: "social_use",
			substances: "Social Use"
		},
		{
			key: "religious_use",
			substances: "Religious Use"
		},
		{
			key:"nicotine_vapes",
			substances:"Nicotine/Vapes",
			nicotineOptions:[
				{
					label:"Smoking",
					value:"smoking"
				},
				{
					label:"Chewing",
					value:"chewing"
				},
				{
					label:"Inhaling",
					value:"inhaling"
				},
				{
					label:"Vaping",
					value:"vaping"
				}
			]
		},
		{
			key:"alcohol",
			substances:"Alcohol"
		},
		{
			key:"amphetamine",
			substances:"Amphetamine"
		},
		{
			key:"benzodiazepines",
			substances:"Benzodiazepines"
		},
		{
			key:"cannabis",
			substances:"Cannabis (Marijuana)"
		},
		{
			key:"cocaine",
			substances:"Cocaine"
		},
		{
			key:"crack_cocaine",
			substances:"Crack Cocaine"
		},
		{
			key:"ecstasy",
			substances:"Ecstasy (MDMA)"
		},
		{
			key:"heroin",
			substances:"Heroin"
		},
		{
			key:"lsd",
			substances:"LSD (Acid)"
		},
		{
			key:"methamphetamine",
			substances:"Methamphetamine"
		},
		{
			key:"opioids",
			substances:"Opioids (Prescription Painkillers)"
		},
		{
			key:"other",
			substances:"Other"
		},
		{
			key: "gambling",
			substances: "Problem Gambling",
			gamblingOptions: [
				{
					label: "Have you ever felt the need to bet more and more money?",
					value: "gambling_option1",
					yes: "has felt the need to bet more and more money.",
					no: "has not felt the need to bet more and more money."
				},
				{
					label: "Have you ever had to lie to people important to you about how much you gambled?",
					value: "gambling_option2",
					yes: "has lied to people important to them about how much they gambled.",
					no: "has not lied to people important to them about how much they gambled."
				}
			]
		},
		{
			key: "social_gambling",
			substances: "Social Gambling"
		},
		{
			key: "no_gambling",
			substances: "No Gambling"
		},
	],
	OtherGamblingTypeOptions: ["Slots", "Video poker", "Blackjack", "Roulette", "Baccarat", "Craps", "Keno", "Lottery", "Casinos", "Horse racing", "Big Six", "Card games", "Classic Blackjack", "Five-card draw", "Flipping coins", "Texas hold 'em", "Scratch cards", "Seven-card stud", "Sic Bo", "Table games", "Sports betting", "Bingo", "Online gambling"],
	SubstancesAliases: {
		"nicotine_vapes": "Bidis, chew, chewing tobacco, cigars, cigarettes, coffin nails, fags, kreteks, snuff, spit, smokes, shisha, hookahs, e-cigs, vapes, e-hookahs, vape pens, mods, tanks",
		"alcohol": "Booze, Moonshine, Liquid Courage, Brew, Goof, Hooch, Cold One, Giggle Juice, Diesel, Hard Stuff, Poison, Petrol, Oil, Sauce",
		"amphetamine": "Bennies, Black Beauties, Hearts, Speed, Truck Drivers, Uppers",
		"benzodiazepines": "Barbs, Phennies, Red Birds, Reds, Tooies, Yellow Jackets, Yellows",
		"cocaine": "Blow, C, Charlie, Coke, Snow, Toot, Coca, Soda Cot",
		"crack_cocaine": "Crack",
		"ecstasy": "E, X, Molly",
		"heroin": "H, Smack, Junk, Brown Sugar, Dope",
		"lsd": "Acid, Blotter, Doses, Hits, Trips",
		"methamphetamine": "Crystal, Ice, Meth, Tina",
		"cannabis": "Weed, Pot, Grass, Mary Jane, Ganja",
		"opioids": "Oxy, Percs, Vikes, Hillbilly Heroin",
		"other": "",
		"gambling": ""
	},
	SubstancesDescriptions: {
		"nicotine_vapes": "",
		"alcohol": "",
		"amphetamine": "Description: Amphetamines are stimulants that increase alertness, and energy. They are sometimes used to treat attention deficit hyperactivity disorder (ADHD).",
		"benzodiazepines": "",
		"cocaine": "",
		"crack_cocaine": "",
		"ecstasy": "",
		"heroin": "",
		"lsd": "Description: LSD is a hallucinogenic drug that alters perception, mood, and cognition. It is usually taken as a small paper square (blotter) placed under the tongue.",
		"methamphetamine": "",
		"cannabis": "",
		"opioids": "Description: Opioids include prescription painkillers like oxycodone, hydrocodone, and fentanyl. They can lead to addiction and overdose.",
		"other": "",
		"gambling": ""
	},
	Reasons : [
		{
			key:"family",
			reason:"Family"
		},
		{
			key:"partner_spouse",
			reason:"Partner or Spouse"
		},
		{
			key:"health",
			reason:"Health"
		},
		{
			key:"employment",
			reason:"Employment"
		},
		{
			key:"finances",
			reason:"Finances"
		},
		{
			key:"school",
			reason:"School"
		},
		{
			key:"physically_dangerous_situations_like",
			reason:"Physically dangerous situations like"
		},
		{
			key:"legal_problems_like",
			reason:"Legal problems like"
		},
		{
			key:"social_interpersonal_problems",
			reason:"Social or interpersonal problems"
		},
		{
			key:"religious_beliefs",
			reason:"Religious beliefs"
		}
    ],
		AddictionFormLabels : [
		  {
				key: 'family_history',
				label: 'Family History of',
				options: [
					{
						key: 'substance_use',
						label: 'Substance Use',
					},
					{
						key: 'gambling_problems',
						label: 'Gambling Problems',
					},
				],
			},
			{
				key: 'prior_treatment',
				label: 'Previously Treated for Addiction?',
				options: [
					{
						key: 'rehab',
						label: 'Rehab',
						details: {
							key: 'rehab_details',
							label: 'Rehab Details',
							placeholder: 'Rehab Details',
						},
					},
					{
						key: 'therapist',
						label: 'Therapist',
						details: {
							key: 'therapist_details',
							label: 'Therapist Details',
							placeholder: 'Therapist Details',
						},
					},
				],
			},
			{
				key: 'recovering_friends',
				label: 'Has recovering friends',
			},
			{
				key: 'twelve_step_experience',
				label: 'Prior 12-step program experience',
			},
			{
				key: 'longest_abstinence',
				label: 'Longest period of abstinence',
				input: {
					key: 'longest_abstinence_input',
					placeholder: 'Enter duration (e.g., 6 months)',
				},
			},
		],
	CageScreening : [
		{
			key:"B",
			label:"Not Applicable",
			answer: "Not Applicable"
		},
		{
			key:"C",
			label:"Have you ever thought you should Cut down your drug or alcohol use?",
			answer: "Cut down your drug or alcohol"
		},
		{
			key:"A",
			label:"Have you ever felt Annoyed when people have commented on your drug or alcohol use?",
			answer: "felt Annoyed when people have commented on your drug or alcohol use"
		},
		{
			key:"G",
			label:"Have you ever felt Guilty or bad about your drug or alcohol use?",
			answer: "felt Guilty or bad about your drug or alcohol use"
		},
		{
			key:"E",
			label:"Have you ever used drugs to Ease withdrawal symptoms, or to avoid feeling low after using?",
			answer: "used drugs to Ease withdrawal symptoms, or to avoid feeling low after using"
		}
	],
	ReasonValues: {
		"family": ["parents", "siblings", "difference of opinion/arguments"],
		"partner_spouse": ["difference of opinion/arguments", "children"],
		"health": "",
		"employment": ["poor performance", "absences", "suspensions"],
		"finances": ["late bills", "missing payments"],
		"school": ["poor grades", "absences", "suspensions", "expulsions"],
		"physically_dangerous_situations_like": ["DWI (Driving While under Influence of substance)", "violence", "domestic violence"],
		"legal_problems_like": ["arrests", "order of protection"],
		"social_interpersonal_problems": "Friends (difference of opinion/arguments)",
		"religious_beliefs": "",
	},
	MentalHealth: [
		"None",
		"Anxiety",
		"Bipolar disorder",
		"Depression",
		"HI (Homicidal Ideation)",
		"Mood disorder",
		"SI (Suicidal Ideation)",
		"Panic attacks",
	],
	ReligionList: ['Hindu', 'Muslim', 'Christian', 'Buddhist', 'Jewish', 'Jain', 'Sikh', 'Non-Religious', 'Spiritual', 'Atheist', 'Agnostic'],
	EthnicityList:['Asian Indian', 'White', 'Black', 'Hispanic'],
	ReligionPlaceHolder:"Hindu/Muslim/Christian/Buddhist/Jewish/Sikhs/Non-Religious/Spiritual",
	Yes:"Yes",
	No:"No",
	YesNo:"Yes/No",
	Some: "Some",
	DietaryHabbits:[
		{
			key:"balanced diet",
			label:"Balanced diet"
		},
		{
			key:"junk food",
			label:"Junk food"
		},
		{
			key: "mixture of balanced diet and junk food",
			label: "Mixture of balanced diet and Junk food"
		}
	],
	DietaryHabbitsPlaceHolder: "Balanced diet/Junk food/Mixture of balanced diet and Junk food",
	FamilyMember:"Family Member",
	AddictsGamblers:"Addicts/Gamblers",
	Emotional:"Emotional",
	DisorderOption: [
		'Alcohol use disorder-Mild-305.00 (F10.10)',
		'Alcohol use disorder-Moderate-303.90 (F10.20)',
		'Alcohol use disorder-Severe-303.90 (F10.20)',
		'Amphetamine-type substance use disorder-Mild-305.70 (F15.10)',
		'Amphetamine-type substance use disorder-Moderate-304.40 (F15.20)',
		'Amphetamine-type substance use disorder-Severe-304.40 (F15.20)',
		'Adjustment disorder',
		'Alcohol intoxication-303',
		'Amphetamine or other stimulant intoxication-292.89',
		"Anorexia nervosa, Binge-eating/purging type (F50.02)",
		"Anorexia nervosa, Restricting type (F50.01)",
		"Anorexia nervosa-307.1",
		"Binge-eating disorder-307.51 (F50.8)",
		"Body dysmorphic disorder-300.7 (F45.22)",
		"Bulimia nervosa-307.51 (F50.2)",
		"Cannabis intoxication-292.89",
		"Cannabis use disorder, Mild-305.2 (F12.10)",
		"Cannabis use disorder, Moderate-304.3 (F12.20)",
		"Cannabis use disorder, Severe-304.3 (F12.20)",
		"Cocaine intoxication-292.89 ",
		'Adjustment disorder Unspecified-309.9 (F43.20)',
		'Adjustment disorder with anxiety-309.24 (F43.22)',
		'Adjustment disorder with depressed mood-309.0 (F43.21)',
		'Adjustment disorder with disturbance of conduct-309.3 (F43.24)',
		'Adjustment disorder with mixed anxiety and depressed mood-309.28 (F43.23)',
		'Adjustment disorder with mixed disturbance of emotions and conduct-309.4 (F43.25)',
		'Antisocial personality disorder-301.7',
		'Attention-deficit/hyperactivity disorder, Combined presentation-314.01 (F90.2)',
		'Attention-deficit/hyperactivity disorder, Predominantly hyperactive/impulsive presentation-314.01 (F90.1)',
		'Attention-deficit/hyperactivity disorder, Predominantly inattentive presentation-314.00 (F90.0)',
		'Avoidant personality disorder-301.82',
		'Bipolar I disorder, Current or most recent episode depressed, With psychotic features-296.54',
		'Bipolar I disorder, Current or most recent episode depressed-Mild-296.51 (F31.31)',
		'Bipolar I disorder, Current or most recent episode depressed-Moderate-296.52 (F31.32)',
		'Bipolar I disorder, Current or most recent episode depressed-Severe-296.53 (F31.4)',
		'Bipolar I disorder, Current or most recent episode depressed-Unspecified-296.50 (F31.9)',
		'Bipolar I disorder, Current or most recent episode hypomanic-296.40',
		'Bipolar I disorder, Current or most recent episode manic-Mild-296.41',
		'Bipolar I disorder, Current or most recent episode manic-Moderate-296.42',
		'Bipolar I disorder, Current or most recent episode manic-Severe-296.43',
		'Bipolar I disorder, Current or most recent episode unspecified-296.7',
		'Bipolar II Disorder-296.89 (F31.81)',
		'Borderline personality disorder-301.83 (F60.3)',
		'Dependent personality disorder-301.6',
		'Generalized anxiety disorder-300.02',
		'Histrionic personality disorder-301.50',
		'Major depressive disorder, Single episode, Unspecified-296.20',
		'Major depressive disorder, Single episode-Mild-296.21',
		'Major depressive disorder, Single episode-Moderate-296.22',
		'Major depressive disorder, Single episode-Severe-296.23',
		'Narcissistic personality disorder-301.81',
		'Obsessive-compulsive disorder-303.3 (F42)',
		'Obsessive-compulsive personality disorder-301.4',
		'Oppositional defiant disorder-313.81',
		"Other problem related to psychosocial circumstances-V15.49 (Z65.8)",
		'Other specified anxiety disorder-300.09 (F41.8)',
		'Other specified bipolar and related disorder-296.89',
		'Panic disorder-300.01 (F41.0)',
		'Paranoid personality disorder-301.0 (F60.0)',
		'Persistent depressive disorder (dysthymia)-300.4 (F34.1)',
		'Personal history of self-harm-V15.59 (Z91.5)',
		'Posttraumatic stress disorder-309.81 ',
		'Schizoid Personality Disorder-301.20 (F60.1)',
		'Schizophrenia-295.90 (F20.9)',
		'Schizotypal personality disorder-301.22',
		'Social anxiety disorder (social phobia)-300.23 (F40.10)',
		'Trichotillomania (hair-pulling disorder)-312.39',
		"Uncomplicated bereavement-V62.82 (Z63.4)",
		"Unspecified alcohol-related disorder-291.9 (F10.99)",
		"Unspecified amphetamine or other stimulant-related disorder (F15.99)",
		'Unspecified anxiety disorder-300.00 (F41.9)',
		'Unspecified attention-deficit/hyperactivity disorder-314.01 (F90.9)',
		'Unspecified bipolar and related disorder-296.80 (F31.9)',
		'Unspecified caffeine-related disorder-292.9 (F15.99)',
		'Unspecified cannabis-related disorder-292.9 (F12.99)',
		'Unspecified cocaine-related disorder (F14.99)',
		'Unspecified depressive disorder-311 (F32.9)',
		'Unspecified mental disorder-300.9 (F99)',
		'Unspecified personality disorder-301.9',
		'Cocaine use disorder-Mild-305.60',
		'Cocaine use disorder-Moderate-304.20',
		'Cocaine use disorder-Severe-304.20',
		'Inhalant use disorder-Mild-305.90',
		'Inhalant use disorder-Moderate-304.60',
		'Inhalant use disorder-Severe-304.60',
		'Other (or unknown) substance use disorder-Mild-305.90',
		'Other (or unknown) substance use disorder-Moderate-304.90',
		'Other (or unknown) substance use disorder-Severe-304.90',
		'Other hallucinogen use disorder-Mild-305.30',
		'Other hallucinogen use disorder-Moderate-304.50',
		'Other hallucinogen use disorder-Severe-304.50',
		'Other or unspecified stimulant use disorder-Mild-305.70',
		'Other or unspecified stimulant use disorder-Moderate-304.40',
		'Other or unspecified stimulant use disorder-Severe-304.40',
		'Sedative, hypnotic, or anxiolytic use disorder-Mild-305.40',
		'Sedative, hypnotic, or anxiolytic use disorder-Moderate-304.10',
		'Sedative, hypnotic, or anxiolytic use disorder-Severe-304.10',
		'Parent-Child Relational Problem-V61.20 (Z62.820)',
		'Sibling Relational Problem-V61.8 (Z62.891)',
		'Child Affected by Parental Relationship Distress-V61.29 (Z62.898)',
		'Relationship Distress With Spouse or Intimate Partner',
		'Academic or Educational Problem-V62.3 (Z55.9)',
		'Acute stress disorder-308.3 (F43.0)',
		'Acculturation difficulty-V62.4 (Z60.3)',
		'Phase of Life Problem',
		'Religious or Spiritual Problem-V62.89 (Z65.8)',
		'Other Personal History of Psychological Trauma-V15.49 (Z91.49)',
		'Overweight or Obesity-278 (E66.9)',
		"Personal history (past history) of neglect in childhood-V15.42 (Z62.812)",
		"Personal history (past history) of psychological abuse in childhood-V15.42 (Z62.811)",
		"Personal history (past history) of spouse or partner neglect-V15.42 (Z91.412)",
		"Personal history (past history) of spouse or partner psychological abuse-V15.42 (Z91.411)",
		"Personal history (past history) of spouse or partner violence, Physical-V15.41 (Z91.410)",
		"Personal history (past history) of spouse or partner violence, Sexual-V15.41 (Z91.410)",
		'Personal history (past history) of physical abuse in childhood-V15.41 (Z62.810)',
		'Personal history (past history) of sexual abuse in childhood-V15.41 (Z62.810)',
		"Disruption of family by separation or divorce-V61.03 (Z63.5)",
		"Gambling disorder-312.31 (F63.0)",
		"Inhalant intoxication-292.89",
		"Insomnia disorder-780.52 (G47.00)",
		"Opioid intoxication-292.89",
		"Opioid use disorder, Mild-305.5 (F11.10)",
		"Opioid use disorder, Moderate-304 (F11.20)",
		"Opioid use disorder, Severe-304 (F11.20)",
		"Other (or unknown) substance intoxication-292.89",
		"Other hallucinogen intoxication-292.89",
		"Other personal risk factors-V15.89 (Z91.89)",
		"Other problem related to employment-V62.29 (Z56.9)",
		"Phencyclidine intoxication-292.89",
		"Phencyclidine intoxication delirium-292.81",
		"Phencyclidine use disorder, Mild-305.9 (F16.10)",
		"Phencyclidine use disorder, Moderate-304.6 (F16.20)",
		"Phencyclidine use disorder, Severe-304.6 (F16.20)",
		"Problem related to lifestyle-V69.9 (Z72.9)",
		"Problem related to living alone-V60.3 (Z60.2)",
		"Separation anxiety disorder-309.21 (F93.0)",
		"Tobacco use disorder, Mild-305.1 (Z72.0)",
		"Tobacco use disorder, Moderate-305.1 (Z17.200)",
		"Tobacco use disorder, Severe-305.1 (Z17.200)",
		'Unspecified opioid-related disorder-292.9 (F11.99)',
		'Unspecified phencyclidine-related disorder-292.9 (F16.99)',
		'Unspecified stimulant-related disorder-292.9',
		'Unspecified tobacco-related disorder-292.9 (F17.209)',
	],
	SexualOrientation:"Sexual Orientation",
	SexualOrientationOption: [
		{
			value: "8",
			label: "Straight"
		},
		{
			value: "1",
			label: "Lesbian"
		},
		{
			value: "2",
			label: "Gay"
		},
		{
			value: "3",
			label: "Bisexual"
		},
		{
			value: "4",
			label: "Transgender"
		},
		{
			value: "5",
			label: "Queer or Questioning"
		},
		{
			value: "6",
			label: "Intersex"
		},
		{
			value: "7",
			label: "Asexual"
		}
	],
	Address:"Address",
	Apt:"Apt#",
	Pincode:"Pincode/Zipcode",
	PincodeErrorMessage: "Pincode/Zipcode cannot be more than 10 digits",
	AptErrorMessage: "Apt# cannot be more than 10 digits",
	ServiceText: `Ok to say yes to "RoyCares & Associates Services" when we call?`,
	ServiceTextYes: `agreed to receive calls from "RoyCares & Associates Services"`,
	ServiceTextNo: `declined to receive calls from "RoyCares & Associates Services"`,
	ModeMeet:"Mode of Meeting",
	IsSignedConsentForm:`Have you signed the Consent form?`,
	IsSignedConsentFormYes:`has signed the Consent form.`,
	IsSignedConsentFormNo:`has not signed the Consent form.`,
	EmergencyContactName: "Emergency Contact Name",
	RelationtoRecipient:"Relation to Recipient",
	ClientRequireNotes: 'Clients Requiring Notes',
	EnquiryRequireNotes: 'Enquiries Requiring Notes',
	RelationtoRecipientOptions:[
		{
			label:"Brother",
			value:"1"
		},
		{
			label:"Daughter",
			value:"10"
		},
		{
			label:"Doctor",
			value:"2"
		},
		{
			label:"Father",
			value:"3"
		},
		{
			label:"Friend",
			value:"4"
		},
		{
			label:"Grandfather",
			value:"18"
		},
		{
			label:"Grandmother",
			value:"17"
		},
		{
			label:"Lawyer",
			value:"5"
		},
		{
			label:"Mother",
			value:"6"
		},
		{
			label:"Rabbi",
			value:"7"
		},
		{
			label:"Significant Other",
			value:"14"
		},
		{
			label:"Sister",
			value:"16"
		},
		{
			label:"Son",
			value:"11"
		},
		{
			label:"Spouse",
			value:"12"
		},
		{
			label:"Step-father",
			value:"20"
		},
		{
			label:"Step-mother",
			value:"19"
		},
		{
			label:"Therapist",
			value:"8"
		},
		{
			label:"Others",
			value:"15"
		},
		{
			label:"Other Family",
			value:"9"
		}
	],
	ReasonForCall:"Reason for Call",
	ReasonForCallOptions:[
		{
			label:"Negative Substance Abuse experience",
			value:"1"
		},
		{
			label:"Negative Gambling Problem",
			value:"2"
		},
		{
			label:"Negative Screen Usage Problem",
			value:"10"
		},
		{
			label:"Calling on behalf of family members/friends Addiction/Gambling and requires information",
			value:"3"
		},
		{
			label:"Reports Anxiety/Depression from family members/friends Substance Abuse/Gambling",
			value:"4"
		},
		{
			label:"Experiencing Mental Health Problem",
			value:"5"
		},
		{
			label:"Experiencing Psychiatric Problem",
			value:"6"
		},
		{
			label:"Experiencing Emotional Problem",
			value:"7"
		},
		{
			label:"Experiencing Relationship Problem",
			value:"8"
		},
		{
			label:"Experiencing Lifestyle Problem",
			value:"11"
		},
		{
			label:"Other",
			value:"9"
		}
	],
	SourceOfInfo:[
		{
			label:"Facebook",
			value:"1"
		},
		{
			label:"Friend/Professional",
			value:"2"
		},
		{
			label:"Instagram",
			value:"3"
		},
		{
			label:"LinkedIn",
			value:"4"
		},
		{
			label:"Rehab",
			value:"5"
		},
		{
			label:"Twitter",
			value:"6"
		},
		{
			label:"Website",
			value:"7"
		},
		{
			label:"WhatsApp",
			value:"8"
		},
		{
			label:"YouTube",
			value:"9"
		},
		{
			label:"Other",
			value:"10"
		},
	],
	MaritalStatus:"Marital Status",
	MaritalStatusOption: [
		{
			label: "Divorced",
			value: "1"
		},
		{
			label: "Married",
			value: "3"
		},
		{
			label: "Never Married",
			value: "4"
		},
		{
			label: "Separated",
			value: "5"
		},
		{
			label: "Single",
			value: "7"
		},
		{
			label: "Widowed",
			value: "6"
		}
	],
	EducationOptions:[
		{
			label: "Client is currently not in education system due to Substance Abuse/Gambling",
			value: "0"
		},
		{
			label:"No education",
			value:"1"
		},
		{
			label:"1st",
			value:"2"
		},
		{
			label:"2nd",
			value:"3"
		},
		{
			label:"3rd",
			value:"4"
		},
		{
			label:"4th",
			value:"5"
		},
		{
			label:"5th",
			value:"6"
		},
		{
			label:"6th",
			value:"7"
		},
		{
			label:"7th",
			value:"8"
		},
		{
			label:"8th",
			value:"9"
		},
		{
			label:"9th",
			value:"10"
		},
		{
			label:"SSC",
			value:"11"
		},
		{
			label:"11th",
			value:"12"
		},
		{
			label:"HSSC",
			value:"13"
		},
		{
			label:"Vocational Cert w/o Diploma/GED",
			value:"14"
		},
		{
			label:"Vocational Cert w/ Diploma/GED",
			value:"15"
		},
		{
			label:"Some College-No degree",
			value:"16"
		},
		{
			label:"Bachelors Degree",
			value:"17"
		},
		{
			label:"Graduate Degree",
			value:"18"
		},
		{
			label:"Post Graduate Degree",
			value:"19"
		}
	],
	OccupationOptions:[
		{
			label:"Employed Full Time-35 hrs/wk",
			value:"1"
		},
		{
			label:"Employed in Sheltered Workshop",
			value:"2"
		},
		{
			label:"Employed Part Time-35- hrs/wk",
			value:"3"
		},
		{
			label:"Full-time Home Maker",
			value:"18"
		},
		{
			label:"Not in Labor Force, Child Care",
			value:"4"
		},
		{
			label:"Not in Labor Force, Disabled",
			value:"5"
		},
		{
			label:"Not in Labor Force, In  Training",
			value:"6"
		},
		{
			label:"Not in Labor Force, Inmate",
			value:"7"
		},
		{
			label:"Not in Labor Force, Other",
			value:"8"
		},
		{
			label:"Not in Labor Force, Retired",
			value:"9"
		},
		{
			label:"Not in Labor Force, Student",
			value:"10"
		},
		{
			label:"Part-time Home Maker",
			value:"19"
		},
		{
			label:"Self-employed",
			value:"17"
		},
		{
			label:"Soc Srvcs Determined, Not Employed/Able to Work",
			value:"11"
		},
		{
			label:"Soc Srvcs Determined, Unable to Work, Mandated Treatment",
			value:"12"
		},
		{
			label:"Soc Srvcs Work Exp Program",
			value:"13"
		},
		{
			label:"Unemployed, In Treatment",
			value:"14"
		},
		{
			label:"Unemployed, Looking for Work",
			value:"15"
		},
		{
			label:"Unemployed, Not Looking for Work",
			value:"16"
		},
	],
	MentalHealthOptions:[
		{
			label:"Pregnant",
			value:"pregnant"
		},
		{
			label:"Hearing Impairment",
			value:"hearing_impairment"
		},
		{
			label:"Mobility Impairment",
			value:"mobility_mpairment"
		},
		{
			label:"Speech Impairment",
			value:"speech_impairment"
		},
		{
			label:"Sight Impairment",
			value:"sight_impairment"
		},
		{
			label:"Other Major Physical Health Condition",
			value:"other_major_physical"
		}
	],
	MentalHealthTxt: "Have you experienced any of the following?",
	SiblingTxt: <>How many siblings do you have in your family? Please list all their names and ages, <u>including yours</u>, in the correct birth order (from oldest to youngest).</>,
	ChildrenTxt: "How many children do you have? Please list their names and ages in the correct birth order (from oldest to youngest).",
	ComprehensivePsychosocialOptions: [
		{
			topic: "Substance Dependence",
			key: 'chemical_type',
			objectivesList: [
				{ value: 1, label: "Attend a chemical dependence didactic series to increase knowledge of the patterns and effects of chemical dependence and to identify and process several key points attained from each didactic." },
				{ value: 2, label: "Attend group therapy that is focused on addiction issues; causes for, consequences of, feelings about, and alternatives to addiction." },
				{ value: 3, label: "Read substance abuse and self-help literature; process with the therapist five key points that were gained from the reading." },
				{ value: 4, label: "Complete a 12-step recovery program's Step One workbook, admitting to powerlessness over mood-altering chemicals, and present it in group or individual therapy for feedback." },
				{ value: 5, label: "Make a list of the ways in which chemical abuse has negatively impacted life; process the list with the therapist or group." },
				{ value: 6, label: "List reasons to stay in chemical dependence treatment and be abstinent from addiction." },
				{ value: 7, label: "Acknowledge how addiction was used to escape from stress, physical and emotional pain, and boredom; and confront the negative consequences of this pattern." },
				{ value: 8, label: "Acknowledge sense of shame, guilt, and low self-worth that have resulted from addictive behavior and its consequences." },
				{ value: 9, label: "Understand familial, emotional, and social factors that contributed to the development of chemical dependence." },
				{ value: 10, label: 'Practice healthy communication skills (e.g., using "I" messages, reflecting, active listening, empathy, being reinforcing, sharing).' },
				{ value: 11, label: "Practice how to solve problems in an organized fashion (i.e., write the problem, think accurately, list the options of action, evaluate alternatives, act, monitor results)." },
				{ value: 12, label: "Assign the recipient to complete a 12-step recovery program's Step Four inventory; make arrangements for him/her to share this with a clergyperson or someone else in recovery." },
				{ value: 13, label: "Using a 12-step recovery program's relapse prevention exercise, help the recipient uncover triggers for relapse." },
				{ value: 14, label: "Learn about high-risk situations (e.g., negative emotions, social pressure, interpersonal conflict, positive emotions, test of personal control); make written plan to cope with each high-risk situation." },
				{ value: 15, label: "Learn how to say no to alcohol and drugs; practice saying no in high-risk situations." },
				{ value: 16, label: "Develop a personal recovery plan that includes attending recovery group meetings regularly, getting a sponsor, aftercare, and helping others in recovery." },
				{ value: 17, label: "Confront the recipient's use of denial to minimize the severity of and negative consequences of substance use." },
				{ value: 18, label: "Assign the recipient to write a list of 10 reasons to be abstinent from addiction." },
				{ value: 19, label: "Help the recipient see the dishonesty that goes along with addiction; ask him/her to list 10 lies told to hide substance use." },
				{ value: 20, label: "Identify why honesty is essential to recovery." },
				{ value: 21, label: "Using progressive relaxation or biofeedback, teach the recipient how to relax, then assign him/her to relax twice a day for 10-20 minutes." },
				{ value: 22, label: "Encourage the recipient to share the fear, sadness, shame, and anger that feels about coming for treatment." },
				{ value: 23, label: "List number of negative consequences that have resulted from addictive behavior." },
				{ value: 24, label: "None." },
			],
			interventionmodalityList: [
				{
					value: 1,
					label: "Attend group therapy that is focused on addiction issues; causes for, consequences of, feelings about, and alternatives to addiction"
				},
				{
					value: 2,
					label: "Read substance abuse and self-help literature; process with the therapist five key points that were gained from the reading"
				},
				{
					value: 3,
					label: "Individual session."
				},
				{
					value: 4,
					label: "Group session."
				},
				{
					value: 5,
					label: "Family session."
				},
				{
					value: 6,
					label: "Spiritual session."
				}
			],
			questions: [
				{
					label: "Clinician's findings and conclusions in this functional area",
					name: "Chemical_Problem",
					placeholder: "Select Problem Statement",
					options: [
						{ key: 1, label: 'Recipient demonstrates a maladaptive pattern of substance use, manifested by increased tolerance and withdrawal.' },
						{ key: 2, label: 'Recipient fails to stop or cut down use of mood-altering drug once started, despite the verbalized desire to do so and the negative consequences continued use brings.' },
						{ key: 3, label: 'Recipient denies that chemical dependence is a problem, despite feedback from significant others that the use of the substance is negatively affecting them and others.' },
						{ key: 4, label: 'Recipient reports being unable to sustain abstinence.' },
						{ key: 5, label: 'Recipient identifies as being at risk for relapse.' },
						{ key: 6, label: 'Recipient has history of multiple relapses.' },
						{ key: 7, label: 'Recipient reports history of substance abuse resulting in legal problems.' },
						{ key: 8, label: 'Recipient reports substance abuse evidenced by DWI/DWAI arrest.' },
						{ key: 9, label: 'Recipient reports substance abuse in the family.' },
						{ key: 10, label: 'Recipient reports a family history of substance abuse.' },
						{ key: 11, label: 'Recipient is only externally motivated.' },
						{ key: 12, label: 'Recipient denies history of substance abuse.' },
						{ key: 13, label: 'Recipient substitutes a secondary problem as the focus of concern rather than admit that addiction is the primary problem.' },
						{ key: 14, label: 'Recipient has never worked a program of recovery long enough to maintain abstinence.' },
						{ key: 15, label: 'Recipient reports a history of multiple addiction treatment attempts and subsequent relapse.' },
					]
				},
				{
					label: "Recipient's identified needs in this functional area and level of motivation",
					name: "Chemical_Goal",
					placeholder: "Select Goal Statement",
					options: [
						{ key: 1, label: "Recipient gains understanding of addiction as a family disease and support family member's recovery in healthy way." },
						{ key: 2, label: 'Recipient accepts powerlessness and unmanageability over mood-altering substances, and participate in a recovery-based program.' },
						{ key: 3, label: 'Recipient understands the severity of and reasons for the substance use, and enter a program of recovery.' },
						{ key: 4, label: 'Recipient accepts the truth about the problems that addiction has caused, and enter a program of recovery.' },
						{ key: 5, label: 'Recipient learns the facts about addiction and about the treatment necessary to arrest it.' },
						{ key: 6, label: 'Recipient establishes a sustained recovery, free from the use of all mood-altering substances.' },
						{ key: 7, label: 'Recipient establishes and maintain total abstinence, while increasing knowledge of the disease and the process of recovery.' },
						{ key: 8, label: 'Recipient acquires the necessary self help skills to maintain long-term sobriety from all mood-altering substances, and live a life free of substance abuse.' },
						{ key: 9, label: 'Recipient improves quality of life by maintaining an ongoing abstinence from all mood-altering chemicals.' },
						{ key: 10, label: 'Recipient developes relapse prevention skills.' },
						{ key: 11, label: 'No intervention necessary: no problem indicated.' },
					]
				}
			]
		},
		{
			topic: "Gambling",
			key: 'problem_gambling_type',
			objectivesList: [
				{
					value: 1,
					label: "Assign the patient to attend a gambling didactic series to increase knowledge of the patterns and effects of gambling."
				},
				{
					value: 2,
					label: "Ask the patient to identify several key points attained from attending each didactic; process these points."
				},
				{
					value: 3,
					label: "Teach the patient about cross-tolerance (i.e., one drug or addictive behavior causes tolerance to develop for another); apply this to the patient's situation."
				},
				{
					value: 4,
					label: "Read the Gambler's Anonymous (GA) Combo Book and gather five key points; process the points in session."
				},
				{
					value: 5,
					label: "Assign the patient to attend group therapy that is focused on gambling and other addictions."
				},
				{
					value: 6,
					label: "Attend group therapy that facilitates the sharing of causes for, consequences of, feelings about, and alternatives to gambling."
				},
				{
					value: 7,
					label: "List the ways gambling has negatively impacted life and to process the list with the therapist or group."
				},
				{
					value: 8,
					label: "Complete a GA first-step paper admitting to powerlessness over gambling behavior and any other addictions, and present it in group therapy or to therapist for feedback."
				},
				{
					value: 9,
					label: "Explore how gambling was used to escape from stress, emotional pain, and/or boredom; highlight the negative consequences of this pattern of escapism."
				},
				{
					value: 10,
					label: "Probe the patient's sense of shame, guilt, and low self-worth that has resulted from gambling and its consequences."
				},
				{
					value: 11,
					label: "List of 10 reasons to be abstinent from gambling."
				},
				{
					value: 12,
					label: "List 10 lies told to hide gambling, teaching the patient why honesty is essential to recovery."
				},
				{
					value: 13,
					label: "Solve problems in an organized fashion (e.g., write the problem, list the options of action, evaluate alternatives, act, monitor results); apply this technique to problems caused by gambling."
				},
				{
					value: 14,
					label: "Clarify why he/her was gambling, and help him/her identify healthier ways to satisfy these needs."
				},
				{
					value: 15,
					label: "List the pleasurable activities plans to use in recovery to take the place of gambling."
				},
				{
					value: 16,
					label: "Using progressive relaxation, guided imagery, or biofeedback, teach the patient how to relax; assign him/her to relax twice a day for 10 to 20 minutes per session"
				},
				{
					value: 17,
					label: "Considering the patient's current physical fitness levels (clear strenuous exercise with the patient's physician), direct him/her to exercise three times a week, then increase the exercise by 10 percent a week, until he/she is exercising at a training heart rate."
				},
				{
					value: 18,
					label: "Assign the patient to complete a fourth-step inventory, then make arrangements for him/her to share this with a member of the clergy or someone else in recovery."
				},
				{
					value: 19,
					label: "Using a GA relapse prevention exercise, help the patient to uncover triggers for relapse into gambling."
				},
				{
					value: 20,
					label: "Identify high-risk situations (i.e., negative emotions, social pressure, interpersonal conflict, positive emotions, test personal control); make a written plan to cope with each high-risk situation."
				},
				{
					value: 21,
					label: "Practice how to say no to gambling and other addictive behaviors; also, practice saying no in high-risk situations."
				},
				{
					value: 22,
					label: "Develop a personal recovery plan that includes regular attendance at recovery group meetings, aftercare, getting a sponsor, and helping others in recovery."
				},
				{
					value: 23,
					label: "Explore the patient's use and abuse of mood-altering drugs and alcohol; assess the role of substance abuse in reinforcing gambling behavior."
				},
				{
					value: 24,
					label: "None."
				}
			],
			interventionmodalityList: [
				{
					value: 1,
					label: "Individual session."
				},
				{
					value: 2,
					label: "Group session."
				},
				{
					value: 3,
					label: "Family session."
				},
				{
					value: 4,
					label: "Spiritual session."
				}
			],
			questions: [
				{
					label: "Clinician's findings and conclusions in this functional area",
					name: "Gambling_Problem",
					placeholder: "Select Problem Statement",
					options: [
						{ key: 1, label: 'Recipient denies any history of gambling.' },
						{ key: 2, label: "Recipient reports family member involved in gambling." },
						{ key: 3, label: "Recipient reports pathological gambling." },
						{ key: 4, label: "Recipient reports an inability to maintain abstinence from gambling." },
						{ key: 5, label: "Recipient reports financial issues related to gambling." },
						{ key: 6, label: "Recipient reports occasionally participating in gambling activities." },
						{ key: 7, label: "Denies that gambling is a problem, despite feedback from significant others that gambling is negatively affecting them and others." },
						{ key: 8, label: "Experiences persistent physical, legal, financial, vocational, social, and/or relationship problems that are directly caused by gambling." },
						{ key: 9, label: "Has a history of arrests for gambling-related offenses (e.g., bad checks, forgery, embezzlement, theft)." },
						{ key: 10, label: "Invests large amounts of money, time, and activities to gamble." },
						{ key: 11, label: "Maintains a distorted belief that more gambling will certainly result in a financial windfall." },
						{ key: 12, label: "Reports a history of repeated unsuccessful attempts to stop or cut down on gambling, despite the verbalized desire to do so and the many negative consequences of continued gambling." },
						{ key: 13, label: "Reports frequent loss of time when gambling." },
						{ key: 14, label: "Substance abuse accompanies gambling behavior." },
						{ key: 15, label: "Does not meet criteria for gambling dependence." },
					]
				},
				{
					label: "Recipient's identified needs in this functional area and level of motivation",
					name: "Gambling_Goal",
					placeholder: "Select Goal Statement",
					options: [
						{ key: 1, label: 'No intervention necessary : no problem indicated.' },
						{ key: 2, label: "Accept the powerlessness and unmanageability over gambling and participate in a recovery-based program." },
						{ key: 3, label: "Accept the problem with gambling and begin to actively participate in a recovery program." },
						{ key: 4, label: "Withdraw from gambling emotionally and learn a new program of recovery, free from excessive stress and addictive behavior." },
						{ key: 5, label: "Acquire the necessary skills to maintain long-term abstinence from gambling." },
						{ key: 6, label: "Develop financial planning that will allow repayment of losses and established financial stability." },
					]
				}
			]
		},
		{
			topic: "Community",
			key: 'community_type',
			objectivesList: [
				{
					value: 1,
					label: "Recipient will connect with 12 step recovery in his community."
				},
				{
					value: 2,
					label: "None."
				},
			],
			interventionmodalityList: [
				{
					value: 1,
					label: "Recipient will find a sponsor and review the steps."
				},
				{
					value: 3,
					label: "Individual session."
				},
				{
					value: 4,
					label: "Group session."
				},
				{
					value: 5,
					label: "Family session."
				},
				{
					value: 6,
					label: "Spiritual session."
				}
			],
			questions: [
				{
					label: "Clinician's findings and conclusions in this functional area",
					name: "Community_Problem",
					placeholder: "Select Problem Statement",
					options: [
						{ key: 1, label: 'Reports healthy sober supports.' },
						{ key: 2, label: "Has distorted thinking with hanging out with old friends." },
						{ key: 3, label: "Lacks sober support system." },
						{ key: 4, label: "Associates with peer group members who are regular users/abusers of alcohol and/or drugs." },
						{ key: 5, label: "Experiencing significant social isolation, withdrawal from social life." },
						{ key: 6, label: "Has many friends or relatives who are addicted." },
						{ key: 7, label: "Lives in an environment in which there is a high risk for relapse." },
						{ key: 8, label: "Describes interpersonal conflicts, which increase the risk for relapse." },
						{ key: 9, label: "Frequently expresses negative emotions, increasing the risk for continued addiction." },
						{ key: 10, label: "Reports experiencing social pressure, which encourages substance abuse." },
						{ key: 11, label: "Engages in multiple superficial relationships, often with sexual intercourse, but without commitment or meaningful intimacy." },
						{ key: 12, label: "Has not established and maintained meaningful, intimate interpersonal relationships." },
						{ key: 13, label: "Has a history of substance abuse, leading to social isolation and withdrawal." },
					]
				},
				{
					label: "Recipient's identified needs in this functional area and level of motivation",
					name: "Community_Goal",
					placeholder: "Select Goal Statement",
					options: [
						{ key: 1, label: 'No intervention necessary: no problem indicated.' },
						{ key: 2, label: "Learn the importance of working a twelve-step program, and maintain a program of recovery from addiction and substance-induced disorders." },
						{ key: 3, label: "Develop a peer group that is supportive of recovery." },
						{ key: 4, label: "Develop coping skills to use when experiencing high-risk situations and/or craving." },
						{ key: 5, label: "Resolve interpersonal conflicts, and learn healthy communication skills." },
						{ key: 6, label: "Learn refusal skills for use when tempted into addictive behavior." },
						{ key: 7, label: "Practice a program of recovery that includes regular attendance at recovery group meetings, working with a sponsor, and helping others in recovery." },
					]
				}
			]
		},
		{
			topic: "Mental Health",
			key: 'mental_type',
			objectivesList: [
				{ value: 1, label: "Assess the recipient's potential for harm to self or others, and take precautionary steps if needed; encourage reporting to the staff any future thoughts of causing harm to self or others." },
				{ value: 2, label: "Keep a daily record of anxiety, including each situation that caused anxious feelings, the negative thoughts precipitating the anxiety, and a ranking of the severity of the anxiety from 1 to 100." },
				{ value: 3, label: "Read material on positive self-talk; process key ideas learned from the reading." },
				{ value: 4, label: "Assist each family member in developing a list of three things that he or she can do to assist the recipient in recovery; hold a family session to facilitate communication of the actions on the list." },
				{ value: 5, label: "Develop a list of ten positive statements to read to self several times per day, particularly with feeling anxious." },
				{ value: 6, label: "Understanding the irrational nature of thoughts that underlie fears." },
				{ value: 7, label: "Discuss with the family the connection between anxiety and addiction." },
				{ value: 8, label: "Encourage and support the recipient's verbal expression and clarification of feelings that are associated with past rejection experiences, harsh criticism, abandonment, or trauma." },
				{ value: 9, label: "Facilitate the recipient's use of logic and reasoning to challenge the irrational thoughts associated with unreasonable worries and to replace those thoughts with reasonable ones." },
				{ value: 10, label: "Develop a plan of engaging in pleasurable leisure activities (e.g., clubs, hobbies, church, sporting activities, social activities, games) that increase enjoyment of life and affirm self." },
				{ value: 11, label: "Acknowledge how anxiety and powerlessness over addiction have made life unmanageable." },
				{ value: 12, label: "Monitor the recipient's use of prescribed medication for effectiveness as well as for side effects." },
				{ value: 13, label: "Probe the recipient's family-of-origin experiences for fear-producing situations; help relate these past events to current anxious thoughts, feelings, and behaviors." },
				{ value: 14, label: "Provide the family members with information about anxiety disorders and the tools that are used to assist the recipient in recovery." },
				{ value: 15, label: "Reinforce the recipient's implementation of reality-based cognitive messages that will increase self-confidence in coping with fears and anxieties." },
				{ value: 16, label: "Reinforce the recipient's use of more realistic, positive messages to self in interpreting life events." },
				{ value: 17, label: "Review the recipient's implementation of turning anxieties over to a higher power; reinforce success and redirect for failure." },
				{ value: 18, label: "Practice assertiveness skills to communicate thoughts, feelings, and needs more openly and directly." },
				{ value: 19, label: "Acknowledge the relationship between anxiety and addiction (e.g., how the substance was used to treat the anxious symptoms and why more substance use became necessary)." },
				{ value: 20, label: "Use relaxation techniques (e.g., progressive relaxation, guided imagery, biofeedback) to learn how to completely relax twice per day for 10 to 20 minutes per session." },
				{ value: 21, label: "Increase exercise by 10 percent per week, until he or she is exercising three times per week at a training heart rate for at least 20 minutes." },
				{ value: 22, label: "Explore how depression is experienced in day-to-day living." },
				{ value: 23, label: "Share feelings of depression in order to clarify them and gain insight as to its causes." },
				{ value: 24, label: "List of what recipient is depressed about; process the list with the therapist." },
				{ value: 25, label: "Process healthier, more constructive means of coping with depression (e.g., sharing pain with others, attending 12-step recovery program meetings, developing positive cognitions, taking medication, turning conflicts over to a higher power)." },
				{ value: 26, label: "Acknowledge addictive behavior as a means of coping with depression; identifying the self-defeating, negative consequences of this behavior." },
				{ value: 27, label: "Reinforce positive statements regarding life and the future." },
				{ value: 28, label: "Monitor suicide potential, arranging for suicide precautions, if necessary." },
				{ value: 29, label: "Identify dysfunctional thoughts that trigger depression." },
				{ value: 30, label: "Keep a daily record of dysfunctional thinking that includes listing each situation associated with depressed feelings, and the dysfunctional thinking about that situation that triggered depression." },
				{ value: 31, label: "Using logic and reality, challenge each of the recipient's dysfunctional thoughts for accuracy, replacing dysfunctional thinking with positive, accurate thoughts." },
				{ value: 32, label: "Identify grief issues and develop a written plan for resolving grief (e.g., visit the grave, write a goodbye letter, attend a support group, begin social activities, and volunteer to help others)." },
				{ value: 33, label: "Verify the positive and negative elements of the relationship with the deceased individual." },
				{ value: 34, label: "Probe the recipient's grief and help him/her to say goodbye in a letter to the person who has died or broken a relationship." },
				{ value: 35, label: "Develop a list of 10 accurate, self-enhancing statements to read each morning." },
				{ value: 36, label: "Learn the importance of helping others to build their own sense of self-worth and self-esteem." },
				{ value: 37, label: "Write down five things for which grateful each day." },
				{ value: 38, label: "Attend group therapy sessions and share feelings of depression, allowing for feedback of empathy, acceptance, and affirmation from group members." },
				{ value: 39, label: "Discuss with family members the connection between depression and addictive behavior." },
				{ value: 40, label: "In a family session, review what each member can do to assist the recipient in recovery. Provide the family members with information about depression (e.g., recommend reading What to Do When Someone You Love is Depressed by Golant or When Someone You Love is Depressed by Laura Epstein Rosen and Xavier Francisco Amador)." },
				{ value: 41, label: "Keep a log of situations that precipitate angry feelings, noting the thoughts, feelings, and depth of anger (rate on a scale from 1 to 100); process the anger log and assist in identifying those dysfunctional thoughts that trigger anger." },
				{ value: 42, label: "List painful experiences of life that have led to anger and resentment." },
				{ value: 43, label: "Explore family of origin to see how these experiences led to a tendency to see people and situations as dangerous and threatening." },
				{ value: 44, label: "Learn how anger blocks the awareness of pain, discharges uncomfortable feelings, erases guilt, and places the blame for problems on others." },
				{ value: 45, label: "Learn how aggressive behavior has had negative consequences on others (e.g., spouse, children) who have been the targets of or witness to violence." },
				{ value: 46, label: "List positive traits and accomplishments whenever they are apparent to describe self." },
				{ value: 47, label: "Implement assertiveness in place of aggressiveness in daily life; reinforce success and redirect for failure." },
				{ value: 48, label: "Develop a list of positive, self-enhancing statements to use daily in building a positive and accurate self-image to demonstrate implementation of positive self-talk." },
				{ value: 49, label: "Begin the process of forgiving perpetrators of pain; reinforce success and assess its impact on anger reduction." },
				{ value: 50, label: "Acknowledge tendency to engage in addictive behavior as a means of relieving uncomfortable feelings; develop a list of several instances of occurrence." },
				{ value: 51, label: "List high-risk situations of strong negative emotions, social pressure, interpersonal conflict, strong positive emotions, and testing personal control; discuss how anger, as a strong negative emotion, places him/her at a high risk for addiction." },
				{ value: 52, label: "Identifying who to forgive, and educate self as to the long-term process that is involved in forgiveness versus a magical single event; recommend reading books on forgiveness (e.g., Forgive and Forget by Smedes)." },
				{ value: 53, label: "Learn how the thoughts of abandonment and rejection trigger feelings of worthlessness, hurt, and then anger." },
				{ value: 54, label: "Identify a list of distorted thoughts that trigger feelings of anger; learn to replace such thoughts with positive, realistic thoughts." },
				{ value: 55, label: "Practice progressive relaxation skills, and encourage their utilization twice a day for 10 to 20 minutes." },
				{ value: 56, label: "Review application of relaxation skills; reinforce success and redirect for failure." },
				{ value: 57, label: "Explore benefits of regular physical exercise; assign a program of implementation." },
				{ value: 58, label: "Develop a list of pleasurable leisure activities to reduce stress and increase enjoyment of life; engage in one or two such activities per week." },
				{ value: 59, label: "List needs and wishes and the personal actions necessary to attain these, rather than being angry with others for not meeting needs and wishes." },
				{ value: 60, label: 'Learn the impulse control skill of "stop, look, listen, think, and plan" before reacting with anger.' },
				{ value: 61, label: "Stop the impulse to react with anger (e.g., relax muscles; use positive, comforting self-talk; implement a time out procedure; and speak softly in frustrating, threatening, or hurtful situations)." },
				{ value: 62, label: "Practice a time out procedure to interrupt escalating angry interactions between the recipient and significant other; role-play, applying the time out procedure in five different anger-producing situations, and keep a log of implementation of the technique" },
				{ value: 63, label: "Read books on coping with anger (e.g., Of Course You're Angry by Rosellini and Worden; The Angry Book by Rubin; Anger Work-Out Book by Weisinger); process implementation of coping techniques, reinforcing success and redirecting for failure." },
				{ value: 64, label: "None." },
			],
			interventionmodalityList: [
				{
					value: 1,
					label: "Individual session."
				},
				{
					value: 2,
					label: "Group session."
				},
				{
					value: 3,
					label: "Family session."
				},
				{
					value: 4,
					label: "Spiritual session."
				}
			],
			questions: [
				{
					label: "Clinician's findings and conclusions in this functional area",
					name: "Mental_Problem",
					placeholder: "Select Problem Statement",
					options: [
						{ key: 1, label: 'Abuses substances in an attempt to control anxiety symptoms.' },
						{ key: 2, label: 'Constantly worries about family, job, social interactions, and/or health.' },
						{ key: 3, label: "Demonstrates excessive fear and worry regarding several life circumstances, which has no factual or logical basis." },
						{ key: 4, label: "Demonstrates low self-esteem." },
						{ key: 5, label: "Engages in addictive behavior as a means of escaping from feelings of sadness, worthlessness, and helplessness." },
						{ key: 6, label: "Expresses a fear of saying or doing something foolish in a social situation due to a lack of confidence in social skills." },
						{ key: 7, label: "Has a history of mental illness, increasing risk for relapse." },
						{ key: 8, label: "Recipient denies history of mental health issues." },
						{ key: 9, label: "Recipient is currently under the care of a psychiatrist." },
						{ key: 10, label: "Recipient reports feelings of anxiety and depression." },
						{ key: 11, label: "Recipient reports history of mental health treatment." },
						{ key: 12, label: "Verbalizes persistent feelings of helplessness, hopelessness, worthlessness, and/or guilt." },
					]
				},
				{
					label: "Recipient's identified needs in this functional area and level of motivation",
					name: "Mental_Goal",
					placeholder: "Select Goal Statement",
					options: [
						{ key: 1, label: 'Decrease anxious thoughts and increase positive, self-enhancing self-talk.' },
						{ key: 2, label: 'Decrease dysfunctional thinking and increase positive, self-enhancing self-talk.' },
						{ key: 3, label: "Elevate mood and develop a program of recovery free from addiction." },
						{ key: 4, label: "End addiction as a means of escaping anxiety and practice constructive coping behaviors." },
						{ key: 5, label: 'Learn to relax and think accurately and logically about events.' },
						{ key: 6, label: "Maintain a program of recovery, free from addiction and excessive anxiety." },
						{ key: 7, label: "No intervention necessary : no problem indicated" },
						{ key: 8, label: "Reduce anxiety symptoms significantly, and abstain from addictive behavior." },
						{ key: 9, label: "Reduce overall stress levels, reducing excessive worry and muscle tension." },
						{ key: 10, label: "Resolve the conflict that is at the source of anxiety." },
					]
				}
			]
		},
		{
			topic: "Physical Health",
			key: 'physical_type',
			objectivesList: [
				{ value: 1, label: "Complete physical exam." },
				{ value: 2, label: "Keep all appointments with physician to monitor the effectiveness and side effects of medication, titrating as necessary." },
				{ value: 3, label: "Learn how to get good things out of life without mood-altering substances." },
				{ value: 4, label: "List the pleasurable activities that the recipient plans to pursue in recovery." },
				{ value: 5, label: "Learn how to relax twice a day for 10 to 20 minutes." },
				{ value: 6, label: "None." },
			],
			interventionmodalityList: [
				{
					value: 1,
					label: "Individual session."
				},
				{
					value: 2,
					label: "Group session."
				},
				{
					value: 3,
					label: "Family session."
				},
				{
					value: 4,
					label: "Spiritual session."
				}
			],
			questions: [
				{
					label: "Clinician's findings and conclusions in this functional area",
					name: "Physical_Problem",
					placeholder: "Select Problem Statement",
					options: [
						{ key: 1, label: 'Recipient is in good health.' },
						{ key: 2, label: 'Recipient requires medical screening and physical exam/PPD.' },
					]
				},
				{
					label: "Recipient's identified needs in this functional area and level of motivation",
					name: "Physical_Goal",
					placeholder: "Select Goal Statement",
					options: [
						{ key: 1, label: 'Continue current medical regimen and provide updates as requested.' },
						{ key: 2, label: 'Develop a program of recovery that includes healthy exercise, relaxation, and eating and sleeping habits.' },
						{ key: 3, label: 'No intervention necessary : no problem indicated' },
						{ key: 4, label: 'Participate in medical management of substance-induced disorder and addiction.' },
					]
				}
			]
		},
		{
			topic: "Social/Leisure",
			key: 'social_type',
			objectivesList: [
				{
					value: 1,
					label: "Acknowledge the importance of finding pleasure in life without using mood-altering substances."
				},
				{
					value: 2,
					label: "Developing a list of pleasurable activities; assign engagement in selected activities daily."
				},
				{
					value: 3,
					label: "Establish a daily routine of physical exercise to build stamina, improve self-esteem, and reduce depression."
				},
				{
					value: 4,
					label: "Write a chemical use history, describing attempts at recovery and the situations surrounding relapse"
				},
				{
					value: 5,
					label: "List high-risk situations that lead to relapse (e.g., negative emotions, social pressure, interpersonal conflict, positive emotions, tests of personal control)."
				},
				{
					value: 6,
					label: "Understand reasons for repeated relapse (e.g., failure to work a daily recovery program, failure to go to meetings, poor coping skills for high-risk situation, mental illness, interpersonal problems, poor recovery environment)."
				},
				{
					value: 7,
					label: "Understand the importance of implementing a daily recovery program to maintain abstinence."
				},
				{
					value: 8,
					label: "Develop a plan to increase rewards from attending recovery groups (e.g., concentrate on helping others, go for coffee after the meeting, socialize, stick with the winners)."
				},
				{
					value: 9,
					label: "Make a written plan that details the coping skills (e.g., go to a meeting, call a sponsor, call the 12-step recovery program hotline, call the counselor, talk to someone) to use when in a high-risk situation (e.g., negative emotions, social pressure, interpersonal conflict, cravings, or overconfidence)."
				},
				{
					value: 10,
					label: "Implement coping skills for high-risk situations in daily life; reinforce success and redirect for failure."
				},
				{
					value: 11,
					label: "Teach the patient healthy communication skills (e.g., active listening, using 'I' messages, reflecting, sharing feelings)."
				},
				{
					value: 12,
					label: "Learn how to say no to alcohol/drugs; practice refusal in several high-risk situations."
				},
				{
					value: 13,
					label: "Make an emergency card to carry at all times that has the phone numbers of people to call when at high risk for relapse."
				},
				{
					value: 14,
					label: "Explore continuing care placement that is structured enough to help maintain abstinence (e.g., halfway house, group home, outpatient treatment, day care, partial hospitalization)."
				},
				{
					value: 15,
					label: "Develop a written continuing care plan that includes honesty, attending recovery group meetings regularly, getting a sponsor, and any other treatment that is needed to maintain abstinence."
				},
				{
					value: 16,
					label: "Discuss with family members the connection between relapse proneness and addictive behavior."
				},
				{
					value: 17,
					label: "In a family session, review what each member can do to assist the patient in recovery."
				},
				{
					value: 18,
					label: "None."
				}
			],
			interventionmodalityList: [
				{
					value: 1,
					label: "Acknowledge the importance of getting pleasure out of life without using mood-altering substances."
				},
				{
					value: 2,
					label: "Establish a daily routine of physical exercise to build body stamina, self-esteem, and reduce depression."
				},
				{
					value: 3,
					label: "Individual session."
				},
				{
					value: 4,
					label: "Group session."
				},
				{
					value: 5,
					label: "Family session."
				},
				{
					value: 6,
					label: "Spiritual session."
				}
			],
			questions: [
				{
					label: "Clinician's findings and conclusions in this functional area",
					name: "Social_Problem",
					placeholder: "Select Problem Statement",
					options: [
						{ key: 1, label: 'Recipient has distorted thinking with hanging out with old friends.' },
						{ key: 2, label: "Recipient lacks sober support system." },
						{ key: 3, label: "Recipient reports healthy sober supports." },
						{ key: 4, label: "Recipient associates with peer group members who are regular users/abusers of alcohol and/or drugs." },
						{ key: 5, label: "Recipient experiencing significant social isolation, withdrawal from social life." },
						{ key: 6, label: "Recipient has many friends or relatives who are addicted." },
						{ key: 7, label: "Recipient lives in an environment in which there is a high risk for relapse." },
						{ key: 8, label: "Recipient describes interpersonal conflicts, which increase the risk for relapse." },
						{ key: 9, label: "Recipient frequently expresses negative emotions, increasing the risk for continued addiction." },
						{ key: 10, label: 'Recipient experiencing social pressure, which encourages substance abuse.' },
						{ key: 11, label: "Recipient engages in multiple superficial relationships, often with sexual intercourse, but without commitment or meaningful intimacy." },
						{ key: 12, label: "Recipient has not established and maintained meaningful, intimate interpersonal relationships." },
						{ key: 13, label: "Recipient has a history of substance abuse, leading to social isolation and withdrawal." },
						{ key: 14, label: "Has healthy social leisure activities." },
						{ key: 15, label: "Has no physical activities at all." },
						{ key: 16, label: "Lacks social support group." },
						{ key: 17, label: "Isolates and over indulges in electronic use." },
					]
				},
				{
					label: "Recipient's identified needs in this functional area and level of motivation",
					name: "Social_Goal",
					placeholder: "Select Goal Statement",
					options: [
						{ key: 1, label: 'Recipient learn the importance of working a self-help program, and maintain a program of recovery from addiction and substance-induced disorders.' },
						{ key: 2, label: "Recipient develop a peer group that is supportive of recovery." },
						{ key: 3, label: "Recipient develop coping skills to use when experiencing high-risk situations and/or craving." },
						{ key: 4, label: "Recipient resolve interpersonal conflicts, and learn healthy communication skills." },
						{ key: 5, label: "Recipient learn refusal skills for use when tempted into addictive behavior." },
						{ key: 6, label: "Recipient practice a program of recovery that includes regular attendance at recovery group meetings, working with a sponsor, and helping others in recovery." },
						{ key: 7, label: "Identify and participate in at least one healthy social leisure activity." },
						{ key: 8, label: "Identify and participate in one physical activity." },
						{ key: 9, label: "Will seek out and develop a social support group." },
						{ key: 10, label: "Will limit isolation and indulge in electronic use for two hours." },
					]
				}
			]
		},
		{
			topic: "Family",
			key: 'family_type',
			objectivesList: [
				{ value: 1, label: "Write a letter to each significant other sharing the problem with addiction, how the living environment has fostered the addiction, and the plan for recovery." },
				{ value: 2, label: "Meet with family members to teach them about addiction, discuss the living environment deficiencies, and make plans for support of the recipient's recovery." },
				{ value: 3, label: "Develop a plan as to how to deal with family members who are addicted." },
				{ value: 4, label: "Discuss with family members the connection between living environment deficiencies and addictive behavior." },
				{ value: 5, label: "In a family session, review what each member can do to assist the recipient in recovery." },
				{ value: 6, label: "Direct the recipient's family to attend Self-Help meetings." },
				{ value: 7, label: "Educate the recipient's family in the dynamics of enabling." },
				{ value: 8, label: "Ask the recipient's family to attend the family education component of the treatment program." },
				{ value: 9, label: "Encourage the family members to write letters of support to the recipient; have him/her read the letters." },
				{ value: 10, label: "Teach the family members the family aspects of the addiction process and the recovery process." },
				{ value: 11, label: "Assign appropriate reading that will increase the family members' knowledge of the disease and recovery process (e.g., Bradshaw on the Family by Bradshaw, Adult Children of Alcoholics by Woititz, or It Will Never Happen to Me by Black)." },
				{ value: 12, label: "In a family session, explain the connection between substance-induced disorder and addictive behavior." },
				{ value: 13, label: "Help the recipient to see the powerlessness and unmanageability that have resulted from using addiction to cope with family conflicts." },
				{ value: 14, label: "Help the recipient to see the relationship between the family of origin childhood conflicts and current family conflicts." },
				{ value: 15, label: "Assist each family member in identifying what to do to reduce family conflicts and heal wounds of the past." },
				{ value: 16, label: "Develop a written contract that outlines what each family member will do to resolve family conflicts." },
				{ value: 17, label: "Help the family members understand how family conflict increases the probability of addictive behavior and how addictive behavior increases the probability of family conflict." },
				{ value: 18, label: "Write a letter to each family member, taking responsibility for problems in the past, sharing feelings, and asking for what they would like from each family member to support recovery." },
				{ value: 19, label: "Encourage recipient not to blame others and accept responsibility for own role in the family conflict." },
				{ value: 20, label: "Help each family member write a letter to the recipient stating how they feel, and asking for what they would like from him/her during recovery; ask each member to read the letter to the recipient in a family session." },
				{ value: 21, label: "Review the recipient's implementation of conflict resolution skills; reinforce success, confront the projection of blame, and redirect him/her for failure." },
				{ value: 22, label: 'Use the assertive communication formula "I feel____ when you____. I would prefer it if____;" practice the formula in role-playing current family conflict situations.' },
				{ value: 23, label: "Explore the nature and history of the recipient's parent-child conflicts; compare these to conflicts the parent may have had with parents." },
				{ value: 24, label: "List instances when addictive behavior led to parent-child relationship conflicts." },
				{ value: 25, label: "Ask the recipient to list occasions when parent-child conflicts triggered addictive behavior." },
				{ value: 26, label: "Accept the responsibility for role in relationship problems, and for choosing addiction as a reaction to the conflicts." },
				{ value: 27, label: "Acknowledge how addiction has caused parent-child conflicts, and how conflicts have precipitated addictive behavior." },
				{ value: 28, label: "List five positive and five negative aspects of the parent-child relationship." },
				{ value: 29, label: "Assist the recipient and other family members in identifying the causes for past and present conflicts between them." },
				{ value: 30, label: "List the behavioral changes that need to be made and the changes that other family members need to make to restore the relationship." },
				{ value: 31, label: "In a family session, obtain a written commitment from each member as to what behaviors each will attempt to change." },
				{ value: 32, label: "Utilize family session with the focus on improving communication skills." },
				{ value: 33, label: "Develop a written plan as to the time, place, and amount of time that will be devoted to private, one-to-one communication with each family member each day." },
				{ value: 34, label: "List the pleasurable activities that they would like to do together; help them to make plans to become involved in at least one activity each week." },
				{ value: 35, label: "Write a letter to each family member sharing feelings, and suggesting pleasurable activities that they could engage in together during recovery." },
				{ value: 36, label: "Build new social relationships that will meet emotional needs, increase satisfaction with life, replace addictive behavior, and reinforce social skills." },
				{ value: 37, label: "Explore the recipient's perspective on the nature of and causes of conflicts with partner." },
				{ value: 38, label: "Explore the recipient's partner's perspective on the nature of and causes of the conflicts between them." },
				{ value: 39, label: "Acknowledge how addiction has caused relationship conflicts, and how relationship conflicts have precipitated addiction." },
				{ value: 40, label: "List instances when addiction has led to relationship conflict." },
				{ value: 41, label: "Accept responsibility for role in the relationship problems, and for choosing addiction as a reaction to the conflicts." },
				{ value: 42, label: "List the positive and negative aspects of the relationship; if possible, ask the partner to also list the positive and negative aspects of the relationship." },
				{ value: 43, label: "List occasions when relationship conflicts have led to addiction." },
				{ value: 44, label: "List the behavioral changes that need to be made and the changes significant other needs to make, to restore the relationship." },
				{ value: 45, label: "Obtain a commitment from each partner as to what behaviors each will attempt to change." },
				{ value: 46, label: "Develop a written plan as to the time, place, and amount of time that will be devoted to private, one-to-one communication with partner each day." },
				{ value: 47, label: "Facilitate a session with the focus on improving communication skills." },
				{ value: 48, label: "Encourage and support the recipient's efforts to build new social relationships." },
				{ value: 49, label: "Help the couple to make a list of the pleasurable activities that they would like to do together; solicit a promise from them to become involved in one activity together a week." },
				{ value: 50, label: "Assign the recipient to write a letter to the partner sharing feelings, and suggesting pleasurable activities they could engage in together during recovery." },
				{ value: 51, label: "None." },
			],
			interventionmodalityList: [
				{
					value: 1,
					label: "Discuss with family members the connection between living environment deficiencies and addictive behavior."
				},
				{
					value: 2,
					label: "In a family session, review what each member can do to assist the recipient in recovery."
				},
				{
					value: 3,
					label: "Direct the recipient's family to attend Self-Help meetings."
				},
				{
					value: 4,
					label: "Individual session."
				},
				{
					value: 5,
					label: "Group session."
				},
				{
					value: 6,
					label: "Family session."
				},
				{
					value: 7,
					label: "Spiritual session."
				}
			],
			questions: [
				{
					label: "Clinician's findings and conclusions in this functional area",
					name: "Family_Problem",
					placeholder: "Select Problem Statement",
					options: [
						{ key: 1, label: 'Admits to physical or verbal abuse of family members.' },
						{ key: 2, label: "Expresses feelings of anger, resentment, and fear of abandonment associated with impending divorce." },
						{ key: 3, label: "Expresses relationship stress as an excuse for addiction, which, in turn, exacerbates the relationship conflicts." },
						{ key: 4, label: "Lacks ability to establish and maintain meaningful, intimate family relationships." },
						{ key: 5, label: "Lacks communication with spouse or significant other." },
						{ key: 6, label: "Lives with an individual who is a regular user/abuser of alcohol and/or drugs." },
						{ key: 7, label: "Recipient Demonstrates poor communication skills, leading to an inability to solve family problems." },
						{ key: 8, label: "Recipient denies any history of domestic violence issues." },
						{ key: 9, label: "Recipient Describes a family that engages in repeated physical fights, verbal arguments, and/or unresolved disputes." },
						{ key: 10, label: "Recipient Describes a family that is not supportive to recovery." },
						{ key: 11, label: "Recipient reports an impending or recent divorce." },
						{ key: 12, label: "Recipient reports codependency issues." },
						{ key: 13, label: "Recipient reports compulsive gambling has negatively affected relationships." },
						{ key: 14, label: "Recipient reports history of domestic violence in current relationship." },
						{ key: 15, label: "Recipient reports history of domestic violence." },
						{ key: 16, label: "Recipient reports poor family relationships." },
						{ key: 17, label: "Recipient reports substance abuse has negatively affected relationships." },
						{ key: 18, label: "Reports stable supportive relationship with family/significant other." },
						{ key: 19, label: "Reports that family is angry or negative toward the addict and not supportive of a recovery program." },
						{ key: 20, label: "Separated from partner due to addictive behavior." },
					]
				},
				{
					label: "Recipient's identified needs in this functional area and level of motivation",
					name: "Family_Goal",
					placeholder: "Select Goal Statement",
					options: [
						{ key: 1, label: 'Decrease family conflict and increase mutually supportive interaction.' },
						{ key: 2, label: "Forgive family members' past misdeeds and begin a life of harmony with each family member." },
						{ key: 3, label: "Learn and demonstrate healthy communication and conflict resolution skills, leading to harmony within the family and the cessation of addiction." },
						{ key: 4, label: "No intervention necessary : no problem indicated" },
						{ key: 5, label: "Recipient will maintain a program of recovery that is free of addiction and family conflict." },
						{ key: 6, label: "Terminate addiction and implement more healthy coping behaviors to deal with conflicts within the family." },
						{ key: 7, label: "Terminate addiction and resolve the relationship conflicts that increase the risk of relapse." },
						{ key: 8, label: "Understand the relationship between addiction and partner relational conflicts." },
						{ key: 9, label: "Understand the relationship between addictive behavior and family conflicts." },
					]
				}
			]
		},
		{
			topic: "Spirituality/Religion",
			key: 'spirituality_type',
			objectivesList: [
				{ value: 1, label: "Teach the recipient about the 12-step recovery program's concept of a higher power, and how this can assist in recovery (e.g., attending religious activities, practicing regular prayer and meditation)." },
				{ value: 2, label: "Develop a plan to continue spiritual growth (e.g., church, recovery groups, counseling, meeting with a pastor, spiritual reading material)." },
				{ value: 3, label: "Explore spiritual journey, religious training, thoughts, and feelings toward a higher power, and current spiritual practices." },
				{ value: 4, label: "Accept powerlessness over spiritual confusion and addictive behavior, and that life is unmanageable." },
				{ value: 5, label: "Acknowledge how spiritual confusion contributed to addiction and a negative attitude toward recovery." },
				{ value: 6, label: "Identify how addiction led to spiritual confusion." },
				{ value: 7, label: "Explore the insanity of spiritual confusion and addictive behavior." },
				{ value: 8, label: "Acknowledge how negative attitudes toward spiritual matters make recovery difficult." },
				{ value: 9, label: "Learn about the 12-step recovery program's concept of \"God as we understand Him,\" and how this relates to spiritual confusion." },
				{ value: 10, label: "Explore how many different religions and cultures can implement a similar 12-step program of recovery." },
				{ value: 11, label: "Acknowledge that the higher power will forgive him/her for the wrongs committed." },
				{ value: 12, label: "Assign the recipient to read Addiction and Grace by May; process key ideas." },
				{ value: 13, label: "Explore the importance of a higher power in a 12-step program, and list many ways that a higher power can assist (e.g., attend regular religious activities, speak weekly with a spiritual advisor, practice regular prayer and meditation)." },
				{ value: 14, label: "Assign the recipient to read books on the process of forgiveness (e.g., Forgive and Forget by Smedes)." },
				{ value: 15, label: "Assign the recipient to read page 417 in the Alcoholics Anonymous Big Book; then, teach him/her how everything that happens in the world is a part of God's good plan." },
				{ value: 16, label: "Encourage the recipient to share thoughts and feelings about a higher power." },
				{ value: 17, label: 'Assign the recipient to read "How It Works" in the Alcoholics Anonymous Big Book and to discuss the three pertinent ideas that are outlined at the end of the chapter: (1) "We were alcoholic and could not manage our own lives;" (2) "Probably no human power could have relieved our alcoholism;" (3) "God could and would if He were sought."' },
				{ value: 18, label: "Make a written plan to continue spiritual journey." },
				{ value: 19, label: "Write a letter to a higher power, sharing thoughts and feelings." },
				{ value: 20, label: "Using a 12-step recovery program's Step Three exercise, teach the recipient how to turn problems over to a higher power." },
				{ value: 21, label: "Assign the recipient to read Chapter 11 in AA's Twelve Steps and Twelve Traditions. Teach the recipient how to pray (talk to God) and meditate (listen for God); then, assign him/her to pray and meditate at least once each day." },
				{ value: 22, label: "Keep a prayer journal, writing down prayers and new insights gained about the higher power's will for life." },
				{ value: 23, label: 'Ask God to come into life each day and then ask, "God, what is the next step in my relationship with you?" Have the recipient write down each insight gained from God, and share these with the primary therapist.' },
				{ value: 24, label: "Develop a personal recovery plan that includes regular attendance at recovery groups, getting a sponsor, helping others in recovery, and any other treatment that is necessary to recover from spiritual confusion and addiction." },
				{ value: 25, label: "Discuss with family members the connection between spiritual confusion and addictive behavior; outline the steps the recipient must take to successfully recover." },
				{ value: 26, label: "In a family session, review what each member can do to assist the recipient in recovery." },
				{ value: 27, label: "Learn about the concept of a higher power and how this can assist in recovery (e.g., God's power can assist in resisting temptation, regular prayer and meditation can reduce craving and stress)." },
				{ value: 28, label: 'Learn the concept of "turning it over," then assign turning over problems to a higher power each day; record the event and discuss the results.' },
				{ value: 29, label: "None." },
			],
			interventionmodalityList: [
				{
					value: 1,
					label: "Identify how addiction led to spiritual confusion."
				},
				{
					value: 2,
					label: "Individual session."
				},
				{
					value: 3,
					label: "Group session."
				},
				{
					value: 4,
					label: "Family session."
				},
				{
					value: 5,
					label: "Spiritual session."
				}
			],
			questions: [
				{
					label: "Clinician's findings and conclusions in this functional area",
					name: "Spiritual_Problem",
					placeholder: "Select Problem Statement",
					options: [
						{ key: 1, label: 'Anger at God leads to a rejection of any religious system or personal spiritual development.' },
						{ key: 2, label: "Recipient fears that God is angry, preventing a connection with a higher power." },
						{ key: 3, label: "Recipient is actively involved in a religious system that is not supportive of a twelve-step recovery program." },
						{ key: 4, label: "Recipient lacks understanding of the need for a higher power." },
						{ key: 5, label: "Recipient maintains spiritual beliefs that are negative toward the existence of a higher power." },
						{ key: 6, label: "Recipient refuses to seek conscious contact with God because of anger toward God." },
						{ key: 7, label: "Recipient upholds religious convictions that are negative toward addiction and toward a twelve-step program of recovery." },
						{ key: 8, label: "Recipient verbalizes confusion about spiritual matters, leading to a negative attitude about recovery." },
						{ key: 9, label: "Recipient has a positive spiritual outlook." },
						{ key: 10, label: "Has healthy religious/spiritual relationship with a Higher Power." },
					]
				},
				{
					label: "Recipient's identified needs in this functional area and level of motivation",
					name: "Spiritual_Goal",
					placeholder: "Select Goal Statement",
					options: [
						{ key: 1, label: 'No intervention necessary : no problem indicated' },
						{ key: 2, label: "Recipient will resolve spiritual conflicts, allowing for a meaningful relationship with a higher power." },
						{ key: 3, label: "Recipient will understand the relationship between spiritual confusion and addiction." },
						{ key: 4, label: "Recipient will accept that a higher power can assist in relieving addiction." },
						{ key: 5, label: "Recipient will learn the difference between religion and spirituality." },
						{ key: 6, label: "Recipient will develop a concept of a higher power that is loving and supportive to recovery." },
					]
				}
			]
		},
		{
			topic: "Educational",
			key: 'education_type',
			objectivesList: [
				{ value: 1, label: "Recipient will make an appointment for educational assessment." },
				{ value: 2, label: "Recipient will shortlist institutions to continue education." },
				{ value: 3, label: "Recipient will submit paperwork to institution for education." },
				{ value: 4, label: "Recipient will coordinate with school for assignments while currently in treatment." },
				{ value: 5, label: "Recipient will seek sober support while on educational campus." },
				{ value: 6, label: "None." },
			],
			interventionmodalityList: [
				{
					value: 1,
					label: "Individual session."
				},
				{
					value: 2,
					label: "Group session."
				},
				{
					value: 3,
					label: "Family session."
				},
				{
					value: 4,
					label: "Spiritual session."
				}
			],
			questions: [
				{
					label: "Clinician's findings and conclusions in this functional area",
					name: "Education_Problem",
					placeholder: "Select Problem Statement",
					options: [
						{ key: 1, label: 'Recipient is satisfied with level of education.' },
						{ key: 2, label: "Recipient expressed interest in exploring/furthering education." },
						{ key: 3, label: "Recipient is currently in school." },
						{ key: 4, label: "Reports difficulties with literacy skills." },
					]
				},
				{
					label: "Recipient's identified needs in this functional area and level of motivation",
					name: "Education_Goal",
					placeholder: "Select Goal Statement",
					options: [
						{ key: 1, label: 'No intervention necessary : no problem indicated.' },
						{ key: 2, label: "Explore educational options to improve educational status" },
						{ key: 3, label: "Explore and/or enroll in literacy classes." },
					]
				}
			]
		},
		{
			topic: "Employment",
			key: 'employment_type',
			objectivesList: [
				{ value: 1, label: "Identify patterns of interpersonal conflict that occur beyond the work setting; relate these patterns to current occupational problems." },
				{ value: 2, label: "Probe family-of-origin history for how the recipient may have learned dysfunctional relationship patterns; relate these patterns to current coworker/supervisor conflicts." },
				{ value: 3, label: "List behavioral changes that the recipient could make to resolve conflicts with coworkers and supervisors; assign implementation of these changes." },
				{ value: 4, label: "List times when addictive behavior led to problems at work." },
				{ value: 5, label: "List times that occupational problems led to addictive behavior." },
				{ value: 6, label: "Clarify emotions regarding vocational situation." },
				{ value: 7, label: "Explore why current employment is a high risk for relapse (e.g., coworker's addictions, job dissatisfaction, supervisor conflict, work hours too long, absence from family due to travel, ethical conflicts)." },
				{ value: 8, label: "Develop a written plan to resolve occupational problems and maximize recovery (e.g., regular attendance at recovery groups, regular drug testing, management monitors recovery plan, honesty with management and coworkers)." },
				{ value: 9, label: "Learn the skills necessary to remain abstinent in current work environment (e.g., honesty with management and coworkers, regular attendance at recovery group meetings, using a sponsor, eliciting the support of management, continued treatment)." },
				{ value: 10, label: "Develop skills to reduce job stress and improve employment satisfaction (e.g., time management; relaxation; exercise; assertiveness; reducing responsibilities, work hours, and/or travel time; realistic expectations of work performance)." },
				{ value: 11, label: "Accept the need to change jobs, to employment that will be more supportive to recovery." },
				{ value: 12, label: "Be honest with himself/herself, coworkers, and management about the negative impact of addictive behavior on job performance; list the negative consequences of addictive behavior on employment." },
				{ value: 13, label: "Make plans to engage in constructive activities (e.g., volunteering, hobbies, exercise, social contacts, special-interest groups, 12-step recovery program meetings, continuing education, religious involvement)." },
				{ value: 14, label: "Discuss with family members the connection between occupational problems and addictive behavior." },
				{ value: 15, label: "Develop a structured written plan for the recipient's emancipation that includes steady employment, paying own expenses, and independent housing." },
				{ value: 16, label: "None." },
			],
			interventionmodalityList: [
				{
					value: 1,
					label: "List times that occupational problems led to addictive behavior."
				},
				{
					value: 2,
					label: "Clarify emotions regarding vocational situation."
				},
				{
					value: 3,
					label: "Individual session."
				},
				{
					value: 4,
					label: "Group session."
				},
				{
					value: 5,
					label: "Family session."
				},
				{
					value: 6,
					label: "Spiritual session."
				}
			],
			questions: [
				{
					label: "Clinician's findings and conclusions in this functional area",
					name: "Employment_Problem",
					placeholder: "Select Problem Statement",
					options: [
						{ key: 1, label: 'Recipient reports satisfactory employment.' },
						{ key: 2, label: 'Recipient is fulltime childcare provided and not working at this time.' },
						{ key: 3, label: "Recipient is enrolled in school and not working." },
						{ key: 4, label: "Recipient expressed interest in exploring/furthering vocational opportunities." },
						{ key: 5, label: "Recipient is currently in treatment and unable to work." },
						{ key: 6, label: "Recipient has history of job loss related to substance abuse." },
						{ key: 7, label: "Recipient is unemployed and looking for work." },
						{ key: 8, label: "Recipient is currently on disability and unable to work." },
						{ key: 9, label: "Recipient experiences anxiety related to perceived or actual job jeopardy." },
						{ key: 10, label: "Recipient has a history of rebellion against and/or conflicts with authority figures in the employment situation." },
						{ key: 11, label: "Recipient is underemployed or unemployed due to the negative effects of addictive behavior on work performance and attendance." },
						{ key: 12, label: "Recipient lacks employer understanding of addiction or what is required for recovery." },
						{ key: 13, label: "Recipient reports feelings of inadequacy, fear, and failure following severe business losses." },
						{ key: 14, label: "Recipient reports that work environment is too stressful, leading to addictive behavior to escape." },
						{ key: 15, label: "Recipient retirement has led to feelings of loneliness, lack of meaning in life, and addictive behavior." },
						{ key: 16, label: "Recipient risks loss of job due to addictive behavior." },
						{ key: 17, label: "Recipient reports suspension of important social, recreational, or occupational activities because they interfere with using." },
						{ key: 18, label: "Recipient works with people who are alcohol and/or drug abusers and are supportive of addiction, increasing the risk for relapse." },
						{ key: 19, label: "Recipient currently in school and not working." },
					]
				},
				{
					label: "Recipient's identified needs in this functional area and level of motivation",
					name: "Employment_Goal",
					placeholder: "Select Goal Statement",
					options: [
						{ key: 1, label: 'No intervention necessary : no problem indicated.' },
						{ key: 2, label: "Recipient will maintain a program of recovery, free of addiction and occupational problems." },
						{ key: 3, label: "Recipient will educate employers and coworkers to be supportive of recovery." },
						{ key: 4, label: "Recipient will fill life with new interests, so retirement can be appreciated." },
						{ key: 5, label: "Recipient will understand the relationship between the stress of occupational problems and addiction." },
						{ key: 6, label: "Prepare resume and begin to look for jobs." },
						{ key: 7, label: "Upload resumes on internet job sites and attend job fairs." },
						{ key: 8, label: "Participate in mock interviews and go for actual job interviews." },
					]
				}
			]
		},
		{
			topic: "Legal",
			key: 'legal_type',
			objectivesList: [
				{
					value: 1,
					label: "Understand the relationship between addictive behavior and legal conflicts, and how these problems result in powerlessness and unmanageability."
				},
				{
					value: 2,
					label: "Identify and accept responsibility for the many decisions that resulted in addiction and legal problems without blaming others."
				},
				{
					value: 3,
					label: "Take responsibility for legal problems."
				},
				{
					value: 4,
					label: "Explore the relationship between legal problems and addictive behavior; solicit the patient's acknowledgment of this relationship."
				},
				{
					value: 5,
					label: "Learn the difference between antisocial and prosocial behaviors, identify antisocial behaviors and attitudes; develop prosocial plans for changes to be made in recovery (e.g., respect for the law, helping others, honesty, reliability, regular attendance at work or treatment)."
				},
				{
					value: 6,
					label: "Explore distorted thoughts and feelings that surround addictive behavior and legal problems."
				},
				{
					value: 7,
					label: "Write how each legal conflict has been related to addictive behavior."
				},
				{
					value: 8,
					label: "Identify positive, realistic thoughts to replace dysfunctional thinking that leads to addictive and illegal behaviors."
				},
				{
					value: 9,
					label: "Develop a plan to meet social, emotional, and financial needs in recovery without resorting to criminal activity or addictive behavior."
				},
				{
					value: 10,
					label: "Meet with an attorney to discuss plans for resolving legal conflicts."
				},
				{
					value: 11,
					label: "Understand need to obey the law in order to maintain abstinence from addictive behavior."
				},
				{
					value: 12,
					label: "Understand the importance of resolving legal conflicts honestly and legally; teach that honesty is the basis for trust."
				},
				{
					value: 13,
					label: "Discuss with family members the connection between legal problems and addictive behavior."
				},
				{
					value: 14,
					label: "None."
				}
			],
			interventionmodalityList: [
				{
					value: 1,
					label: "Individual session."
				},
				{
					value: 2,
					label: "Group session."
				},
				{
					value: 3,
					label: "Family session."
				},
				{
					value: 4,
					label: "Spiritual session."
				}
			],
			questions: [
				{
					label: "Clinician's findings and conclusions in this functional area",
					name: "Legal_Problem",
					placeholder: "Select Problem Statement",
					options: [
						{ key: 1, label: 'Expresses fear of the legal system adjudicating current problems.' },
						{ key: 2, label: "Has a history of arrests for addiction-related offenses (DUI/DWI, minor in possession, assault, possession/delivery of a controlled substance, shoplifting, breaking and entering)." },
						{ key: 3, label: "Has a history of repeated violations of the law related to buying, selling, or using illegal substances." },
						{ key: 4, label: "Is under a court order to seek treatment for addiction." },
						{ key: 5, label: "Patient reports family court mandate to attend treatment." },
						{ key: 6, label: "Presents with legal charges pending adjudication." },
						{ key: 7, label: "Recipient denies any legal issues." },
						{ key: 8, label: "Recipient has legal charges pending." },
						{ key: 9, label: "Recipient is on Parole" },
						{ key: 10, label: "Recipient is on Probation" },
						{ key: 11, label: "Unresolved legal problems are complicating recovery from addiction." },
					]
				},
				{
					label: "Recipient's identified needs in this functional area and level of motivation",
					name: "Legal_Goal",
					placeholder: "Select Goal Statement",
					options: [
						{ key: 1, label: 'Accept the responsibility for legal problems without blaming others.' },
						{ key: 2, label: "Achieve all recovery goals to resolve legal issues." },
						{ key: 3, label: "Consult with legal authorities (e.g., attorney, probation officer, police, court official) to make plans for adjudicating legal conflicts." },
						{ key: 4, label: "Maintain a program of recovery free from addiction and legal conflicts." },
						{ key: 5, label: "No intervention necessary : no problem indicated" },
						{ key: 6, label: "Understand the need to maintain abstinence to remain free of negative consequences, which include legal problems." },
					]
				}
			]
		}
	],
	// Pre-Assessment Intake
	PatientProblems: [
		{ label: 'Alcohol', value: '1'},
		{ label: 'Drug', value: '2'},
		{ label: 'Gambling', value: '3'},
		{ label: 'Family/Relationship', value: '4'},
		{ label: 'Mental Health/Psychiatric', value: '5' },
		{ label: 'Emotional/General', value: '6' },
		{ label: 'Screen Addiction', value: '7' },
		{ label: 'Lifestyle', value: '8' },
	],
	NonAddictPatientProblems: [
		{ label: 'Alcohol', value: '1', disabled: true},
		{ label: 'Drug', value: '2', disabled: true },
		{ label: 'Gambling', value: '3', disabled: true },
		{ label: 'Family/Relationship', value: '4', disabled: false },
		{ label: 'Mental Health/Psychiatric', value: '5', disabled: false },
		{ label: 'Emotional/General', value: '6', disabled: false },
		{ label: 'Screen Addiction', value: '7', disabled: false },
		{ label: 'Lifestyle', value: '8', disabled: false },
	],
	PreAddictionFormLabels: [
		{
			key: 'inpatient_rehab',
			label: 'Have you ever been to an Inpatient Rehab?',
		},
		{
			key: 'outpatient_program',
			label: 'Or an Outpatient Program?',
		},
		{
			key: 'therapist_visit',
			label: 'Or a Therapist?',
			input: {
				key: 'emotional_3',
				placeholder: 'Enter Therapist',
			},
		},
		{
			key: 'drug_8',
			label: 'Do you have any prior 12-step program experience?',
		},
		{
			key: 'longest_abstinence',
			label: 'What is your longest period of abstinence? When?',
			input: {
				key: 'drug_9',
				placeholder: 'Enter duration (e.g., 6 months)',
			},
		},
	],
	CageScreeningPre: [
		{
			key: "C",
			label: <p>Have you ever tried to <b>CUT DOWN</b> on your use of substances/gambling?</p>,
			answer: "CUT DOWN on use of substances/gambling",
			disable: false
		},
		{
			key: "A",
			label: <p>Did you ever get <b>ANGRY</b> if someone spoke to you about your substance/gambling use?</p>,
			answer: "feeling ANGRY if spoken to about use",
			disable: false
		},
		{
			key: "G",
			label: <p>Did you ever feel <b>GUILTY</b> about your use of substances/gambling?</p>,
			answer: "feeling GUILTY about use",
			disable: false
		},
		{
			key: "E",
			label: <p>Have you ever used substances/gambled <b>EARLY MORNING</b> in order to start the day?</p>,
			answer: "having used substances/gambled EARLY MORNING in order to start the day",
			disable: false
		},
		{
			key: "B",
			label: "Not Applicable",
			answer: "Not Applicable",
			disable: false
		},
	],
	OptionValidationMessage: "Please select at least one option.",
	LivingCondition: ['living alone', 'living with spouse/partner and children', 'living in traditional joint family with partner and parents and siblings', 'in live-in relationship', 'living with related persons', 'living with non-related persons'],
	IndividualRecoveryPlan: "Recovery Plan",
	DischargePlan: "Discharge Plan",
	GroupProgressNotes: "Group Progress Notes",
	IndividualRecoveryPlanType: [
		{
			value: 1,
			label: "To be Addressed"
		},
		{
			value: 2,
			label: "Deferred (give clinical reason)"
		},
		{
			value: 3,
			label: "Not Applicable"
		},
		{
			value: 4,
			label: "Achieved"
		},
	],
	RecoveryPlanLabel1:"Areas of concern as given in Comprehensive Evaluation:",
	RecoveryPlanLabel2:"Goal(s) or Deferral Information:",
	Objectives:"Objectives",
	InterventionModality:"Intervention/Modality",
	ObjectivesListEducational:[
		{
			value: 1,
			label: "Recipient will make an appointment for educational assessment."
		},
		{
			value: 2,
			label: "Recipient will shortlist institutions to continue education."
		},
		{
			value: 3,
			label: "Recipient will submit paperwork to institution for education."
		},
		{
			value: 4,
			label: "Recipient will coordinate with school for assignments while currently in treatment."
		},
		{
			value: 5,
			label: "Recipient will seek sober support while on educational campus."
		},
		{
			value: 6,
			label: "None"
		}
	],
	ObjectivesListEmployment:[
		{
			value: 1,
			label: "Identify patterns of interpersonal conflict that occur beyond the work setting; relate these patterns to current occupational problems."
		},
		{
			value: 2,
			label: "Probe family-of-origin history for how the recipient may have learned dysfunctional relationship patterns; relate these patterns to current coworker/supervisor conflicts."
		},
		{
			value: 3,
			label: "List behavioral changes that could make to resolve conflicts with coworkers and supervisors; assign implementation of these changes."
		},
		{
			value: 4,
			label: "List times when addictive behavior led to problems at work."
		},
		{
			value: 5,
			label: "List times that occupational problems led to addictive behavior."
		},
		{
			value: 6,
			label: "Clarify emotions regarding vocational situation."
		},
		{
			value: 7,
			label: "Explore why current employment is a high risk for relapse (e.g., coworker's addictions, job dissatisfaction, supervisor conflict, work hours too long, absence from family due to travel, ethical conflicts)."
		},
		{
			value: 8,
			label: "Develop a written plan to resolve occupational problems and maximize recovery (e.g., regular attendance at recovery groups, regular drug testing, management monitors recovery plan, honesty with management and coworkers)."
		},
		{
			value: 9,
			label: "Learn the skills necessary to remain abstinent in current work environment (e.g., honesty with management and coworkers, regular attendance at recovery group meetings, using a sponsor, eliciting the support of management, continued treatment)."
		},
		{
			value: 10,
			label: "Develop skills to reduce job stress and improve employment satisfaction (e.g., time management; relaxation; exercise; assertiveness; reducing responsibilities, work hours, and/or travel time; realistic expectations of work performance)."
		},
		{
			value: 11,
			label: "Accept the need to change jobs, to employment that will be more supportive to recovery."
		},
		{
			value: 12,
			label: "Be honest with himself/herself, coworkers, and management about the negative impact of addictive behavior on job performance; list the negative consequences of addictive behavior on employment."
		},
		{
			value: 13,
			label: "Make plans to engage in constructive activities (e.g., volunteering, hobbies, exercise, social contacts, special-interest groups, 12-step recovery program meetings, continuing education, religious involvement)."
		},
		{
			value: 14,
			label: "Discuss with family members the connection between occupational problems and addictive behavior."
		},
		{
			value: 15,
			label: "Develop a structured written plan for the recipient's emancipation that includes steady employment, paying own expenses, and independent housing."
		},
		{
			value: 16,
			label: "None"
		}
	],
	InterventionModalitySocial:[
		{
			value: 1,
			label: "Acknowledge the importance of getting pleasure out of life without using mood-altering substances."
		},
		{
			value: 2,
			label: "Establish a daily routine of physical exercise to build body stamina, self-esteem, and reduce depression."
		},
		{
			value: 3,
			label: "Individual session."
		},
		{
			value: 4,
			label: "Group session."
		},
		{
			value: 5,
			label: "Family session."
		},
		{
			value: 6,
			label: "Spiritual session."
		}
	],
	InterventionModalityCommunity:[
		{
			value: 1,
			label: "Recipient will find a sponsor and review the steps."
		},
		{
			value: 2,
			label: "Individual session."
		},
		{
			value: 3,
			label: "Group session."
		},
		{
			value: 4,
			label: "Family session."
		},
		{
			value: 5,
			label: "Spiritual session."
		}
	],
	InterventionModalityFamily:[
		{
			value: 1,
			label: "Discuss with family members the connection between living environment deficiencies and addictive behavior."
		},
		{
			value: 2,
			label: "In a family session, review what each member can do to assist the recipient in recovery."
		},
		{
			value: 3,
			label: "Direct the recipient's family to attend Self-Help meetings."
		},
		{
			value: 4,
			label: "Individual session."
		},
		{
			value: 5,
			label: "Group session."
		},
		{
			value: 6,
			label: "Family session."
		},
		{
			value: 7,
			label: "Spiritual session."
		}
	],
	ObjectivesListLegal:[
		{
			value: 1,
			label: "Understand the relationship between addictive behavior and legal conflicts, and how these problems result in powerlessness and unmanageability."
		},
		{
			value: 2,
			label: "Identify and accept responsibility for the many decisions that resulted in addiction and legal problems without blaming others."
		},
		{
			value: 3,
			label: "Take responsibility for legal problems."
		},
		{
			value: 4,
			label: "Explore the relationship between legal problems and addictive behavior; solicit the patient's acknowledgment of this relationship."
		},
		{
			value: 5,
			label: "Learn the difference between antisocial and prosocial behaviors, identify antisocial behaviors and attitudes; develop prosocial plans for changes to be made in recovery (e.g., respect for the law, helping others, honesty, reliability, regular attendance"
		},
		{
			value: 6,
			label: "Explore distorted thoughts and feelings that surround addictive behavior and legal problems."
		},
		{
			value: 7,
			label: "Write how each legal conflict has been related to addictive behavior."
		},
		{
			value: 8,
			label: "Identify positive, realistic thoughts to replace dysfunctional thinking that leads to addictive and illegal behaviors."
		},
		{
			value: 9,
			label: "Develop a plan to meet social, emotional, and financial needs in recovery without resorting to criminal activity or addictive behavior."
		},
		{
			value: 10,
			label: "Meet with an attorney to discuss plans for resolving legal conflicts."
		},
		{
			value: 11,
			label: "Understand need to obey the law in order to maintain abstinence from addictive behavior."
		},
		{
			value: 12,
			label: "Understand the importance of resolving legal conflicts honestly and legally; teach that honesty is the basis for trust."
		},
		{
			value: 13,
			label: "Discuss with family members the connection between legal problems and addictive behavior."
		},
		{
			value: 14,
			label: "None."
		}
	],
	ObjectivesListSpirituality:[
		{
			value: 1,
			label: "None."
		}
	],
	InterventionModalitySpirituality:[
		{
			value: 1,
			label: "Identify how addiction led to spiritual confusion."
		},
		{
			value: 2,
			label: "Individual session."
		},
		{
			value: 3,
			label: "Group session."
		},
		{
			value: 4,
			label: "Family session."
		},
		{
			value: 5,
			label: "Spiritual session."
		}
	],
	ObjectivesListAncillary:[
		{
			value: 1,
			label: "List high-risk situations of strong negative emotions, social pressure, interpersonal conflict, strong positive emotions, and testing personal control; discuss how anger, as a strong negative emotion, places him/her at a high risk for addiction."
		},
		{
			value: 2,
			label: "Identifying who to forgive, and educate self as to the long-term process that is involved in forgiveness versus a magical single event; recommend reading books on forgiveness (e.g., Forgive and Forget by Smedes)."
		},
		{
			value: 3,
			label: "Learn how the thoughts of abandonment and rejection trigger feelings of worthlessness, hurt, and then anger."
		},
		{
			value: 4,
			label: "Identify a list of distorted thoughts that trigger feelings of anger; learn to replace such thoughts with positive, realistic thoughts."
		},
		{
			value: 5,
			label: "Practice progressive relaxation skills, and encourage their utilization twice a day for 10 to 20 minutes."
		},
		{
			value: 6,
			label: "Review application of relaxation skills; reinforce success and redirect for failure."
		},
		{
			value: 7,
			label: "Explore benefits of regular physical exercise; assign a program of implementation."
		},
		{
			value: 8,
			label: "Develop a list of pleasurable leisure activities to reduce stress and increase enjoyment of life; engage in one or two such activities per week."
		},
		{
			value: 9,
			label: "List needs and wishes and the personal actions necessary to attain these, rather than being angry with others for not meeting needs and wishes."
		},
		{
			value: 10,
			label: "Learn the impulse control skill of 'top, look, listen, think, and plan' before reacting with anger."
		},
		{
			value: 11,
			label: "Stop the impulse to react with anger (e.g., relax muscles; use positive, comforting self-talk; implement a time out procedure; and speak softly in frustrating, threatening, or hurtful situations)."
		},
		{
			value: 12,
			label: "Read books on coping with anger (e.g., Of Course You're Angry by Rosellini and Worden; The Angry Book by Rubin; Anger Work-Out Book by Weisinger); process implementation of coping techniques, reinforcing success and redirecting for failure."
		},
		{
			value: 13,
			label: "None."
		}
	],
	GroupSessionList: [
		// { value: 1, label: "Family Group 1" },
		// { value: 2, label: "Family Group 2" },
		{ value: 3, label: "Graduate Group 1" },
		{ value: 4, label: "Graduate Group 2" },
		{ value: 5, label: "Immersion" },
		// { value: 6, label: "Immersion 2" },
		// { value: 15, label: "Immersion 3" },
		// { value: 16, label: "Immersion 4" },
		// { value: 17, label: "Immersion 5" },
		{ value: 7, label: "Process Group 1" },
		{ value: 8, label: "Process Group 2" },
		// { value: 18, label: "Process Group 3" },
		// { value: 19, label: "Process Group 4" },
		// { value: 20, label: "Process Group 5" },
		{ value: 9, label: "Pyschoed Group 1 (TSF)" },
		{ value: 10, label: "Pyschoed Group 2 (TSF)" },
		{ value: 11, label: "Stages of Change Group 1" },
		{ value: 12, label: "Stages of Change Group 2" },
		{ value: 13, label: "Trauma Group 1" },
		{ value: 14, label: "Trauma Group 2" },
	],
	GroupSessionCategories: {
		// "Family Group": [1, 2],
		"Graduate Group": [3, 4],
		"Immersion": [5, 6, 15, 16, 17],
		"Process Group": [7, 8, 18, 19, 20],
		"Pyschoed Group (TSF)": [9, 10],
		"Stages of Change Group": [11, 12],
		"Trauma Group": [13, 14],
	},
	GroupSession:"Group session",
	illnessOptions: [
		{ label: 'Low BP', value: 'Low BP' },
		{ label: 'High BP', value: 'High BP' },
		{ label: 'Diabetes', value: 'Diabetes' },
		{ label: 'Cholesterol', value: 'Cholesterol' },
		{label:"Pregnant",value:"pregnant"},
		{label:"Hearing Impairment",value:"hearing_impairment"},
		{label:"Mobility Impairment",value:"mobility_mpairment"},
		{label:"Speech Impairment",value:"speech_impairment"},
		{label:"Sight Impairment",value:"sight_impairment"},
		{ label: 'Other', value: 'Other' },
	],
	ResidenceType: ['Bungalow Ownership', 'Bungalow Rental', 'Flat/Apartment Ownership', 'Flat/Apartment Rental'],
	orientationOptions: [
		{ label: 'Ambivalent', value: '1' },
		{ label: 'Change Oriented', value: '2' },
		{ label: 'Planning Change', value: '3' },
		{ label: 'Active Early Recovery', value: '4' },
		{ label: 'Ongoing Recovery and Relapse Prevention', value: '5' }
	],
	// Screening Form
	ScreeningForm: "Screening Form",
	GAFScaleOptions: [
		{
			value: "100-91",
			score: "100-91",
			description: "Superior functioning in a wode range of activities, life's problems never seem to get out of hand, is sought out by others because of his or her ,amu positive qualities. No symptoms.",
		},
		{
			value: "90-81",
			score: "90-81",
			description: "Absent minimal symptoms (e.g. mild anxiety before an exam), good functioning in all areas, interested and invloved in a wild range of activities, socially effective, generally satisfied with life, no more than everyday problems or concerns (e.g., an occasional argument with family memebers).",
		},
		{
			value: "80-71",
			score: "80-71",
			description: "If symptoms are present, they are transient and expectable reactions to psychosocial stressors (e.g., difficulty concentrating after family argument); no more than slight impairment in social, occupational, or school functioning (e.g., temporarily falling behing in school work).",
		},
		{
			value: "70-61",
			score: "70-61",
			description: "Some mild symptoms (e.g., depressed mood and mild insomnia) OR some difficulty in social, occupational, or school functioning (e.g., occasional truancy, or theft within the household), but generally functioning pretty well, has some meaningful interpersonal relationships.",
		},
		{
			value: "60-51",
			score: "60-51",
			description: "Moderate symptoms (e.g., flat and circumstantial speech, occasional panic attacks) OR moderate difficulty in social occupational, or social functionong (E.g., few friends, conflicts with co-workers).",
		},
		{
			value: "50-41",
			score: "50-41",
			description: "Serious symptoms (e.g., suicidal ideation, severs obessional rituals, frequent shoplifing) OR any serious impairment in social, occupational or scholl functioning (e.g., no friends, unable to keep a job).",
		},
		{
			value: "40-31",
			score: "40-31",
			description: "Some impairment in reality testing or communication (e.g., speech is at times illogical, obscure, or irrelevant) PR major impairment in several areas, such as work or school, family relations, judgment, thinking. or mood (e.g., depressed man avoids friends, neglects family, and is unable to work, chils frequently beats up younger children, is defiant at home, and is failing at school).",
		},
		{
			value: "30-21",
			score: "30-21",
			description: "Behavior is considerably influenced by delusions or hallucinations OR serious impairment in communication or judgement (e.g., sometimes incoherent, acts grossly inappropriately, suicidal peroccupation) OR inability to funcation in almost all areas (e.g., stays in bed all day, no job, home, or friends).",
		},
		{
			value: "20-11",
			score: "20-11",
			description: "Some danger of hurting self or others (e.g., sucide attempts without clear expectation of death, frequently violent, manic excitement) OR occasionally fails to maintain minimal personal hygiene (e.g., smears feces) OR gross impairment in communication (e.g., largely incoherent or mute).",
		},
		{
			value: "10-1",
			score: "10-1",
			description: "Persistent danger of severely hurting self or others (e.g., recurrent violence) OR persistent inability to maintain minimal personal hygiene OR serious suicidal act with clear expectation of death.",
		},
		{
			value: "0",
			score: "0",
			description: "Inadequate Information",
		},
	],
	primarySecondaryTertiaryOptions: [
		{ value: "41", label: "Alcohol intoxication-303" },
		{ value: "120", label: "Alcohol intoxication, With mild use disorder (F10.129)", },
		{ value: "121", label: "Alcohol intoxication, With moderate or severe use disorder (F10.229)", },
		{ value: "122", label: "Alcohol intoxication, Without use disorder (F10.929)", },
		{ value: "1", label: "Alcohol use disorder-Mild-305.00 (F10.10)", },
		{ value: "2", label: "Alcohol use disorder-Moderate-303.90 (F10.20)", },
		{ value: "3", label: "Alcohol use disorder-Severe-303.90 (F10.20)", },
		{ value: "123", label: "Alcohol withdrawal-291.81", },
		{ value: "124", label: "Amphetamine or other stimulant intoxication-292.89", },
		{ value: "125", label: "Amphetamine or other stimulant withdrawal-292 (F15.23)", },
		{ value: "4", label: "Amphetamine-type substance use disorder-Mild-305.70 (F15.10)" , },
		{ value: "5", label: "Amphetamine-type substance use disorder-Moderate-304.40 (F15.20)", },
		{ value: "6", label: "Amphetamine-type substance use disorder-Severe-304.40 (F15.20)", },
		{ value: "126", label: "Caffeine intoxication-305.9 (F15.929)", },
		{ value: "127", label: "Caffeine withdrawal-292 (F15.93)", },
		{ value: '52', label: "Cannabis intoxication-292.89" },
		{ value: "53", label: "Cannabis use disorder, Mild-305.2 (F12.10)" },
		{ value: "54", label: "Cannabis use disorder, Moderate-304.3 (F12.20)" },
		{ value: "55", label: "Cannabis use disorder, Severe-304.3 (F12.20)" },
		{ value: "128", label: "Cannabis withdrawal-292 (F15.93)" },
		{ value: "57", label: "Cocaine intoxication-292.89", },
		{ value: "7", label: "Cocaine use disorder-Mild-305.60", },
		{ value: "8", label: "Cocaine use disorder-Moderate-304.20", },
		{ value: "9", label: "Cocaine use disorder-Severe-304.20", },
		{ value: "129", label: "Cocaine withdrawal-292 (F14.23)", },
		{ value: '59', label: "Gambling disorder-312.31 (F63.0)" },
		{ value: "60", label: "Inhalant intoxication-292.89", },
		{ value: "130", label: "Inhalant intoxication, With mild use disorder (F18.129)", },
		{ value: "131", label: "Inhalant intoxication, With moderate or severe use disorder (F18.229)", },
		{ value: "10", label: "Inhalant use disorder-Mild-305.90 (F18.10)", },
		{ value: "11", label: "Inhalant use disorder-Moderate-304.60 (F18.20)", },
		{ value: "12", label: "Inhalant use disorder-Severe-304.60 (F18.20)", },
		{ value: "63", label: "Opioid intoxication-292.89" },
		{ value: "64", label: "Opioid use disorder, Mild-305.5 (F11.10)" },
		{ value: "65", label: "Opioid use disorder, Moderate-304 (F11.20)" },
		{ value: "66", label: "Opioid use disorder, Severe-304 (F11.20)" },
		{ value: "153", label: "Opioid withdrawal-292 (F11.23)" },
		{ value: "68", label: "Other (or unknown) substance intoxication-292.89" },
		{ value: "132", label: "Other (or unknown) substance intoxication, With mild use disorder (F19.129)" },
		{ value: "133", label: "Other (or unknown) substance intoxication, With moderate or severe use disorder (F19.229)" },
		{ value: "134", label: "Other (or unknown) substance intoxication, Without use disorder (F19.929)" },
		{ value: "13", label: "Other (or unknown) substance use disorder-Mild-305.90 (F19.10)", },
		{ value: "14", label: "Other (or unknown) substance use disorder-Moderate-304.90 (F19.20)", },
		{ value: "15", label: "Other (or unknown) substance use disorder-Severe-304.90 (F19.20)", },
		{ value: "135", label: "Other (or unknown) substance withdrawal-292 (F19.239)", },
		{ value: "69", label: "Other hallucinogen intoxication-292.89", },
		{ value: "136", label: "Other hallucinogen intoxication, With mild use disorder (F16.129)", },
		{ value: "137", label: "Other hallucinogen intoxication, With moderate or severe use disorder (F16.229)", },
		{ value: "138", label: "Other hallucinogen intoxication, Without use disorder (F16.929)", },
		{ value: "16", label: "Other hallucinogen use disorder-Mild-305.30 (F16.10)", },
		{ value: "17", label: "Other hallucinogen use disorder-Moderate-304.50 (F16.20)", },
		{ value: "18", label: "Other hallucinogen use disorder-Severe-304.50 (F16.20)", },
		{ value: "19", label: "Other or unspecified stimulant use disorder, Mild-305.70 (F15.10)", },
		{ value: "20", label: "Other or unspecified stimulant use disorder, Moderate-304.40 (F15.20)", },
		{ value: "21", label: "Other or unspecified stimulant use disorder, Severe-304.40 (F15.20)", },
		{ value: "89", label: "Phencyclidine intoxication-292.89" },
		{ value: "139", label: "Phencyclidine intoxication, With mild use disorder (F16.129)" },
		{ value: "140", label: "Phencyclidine intoxication, With moderate or severe use disorder (F16.229)" },
		{ value: "141", label: "Phencyclidine intoxication, Without use disorder (F16.929)" },
		{ value: "91", label: "Phencyclidine use disorder, Mild-305.9 (F16.10)" },
		{ value: "92", label: "Phencyclidine use disorder, Moderate-304.6 (F16.20)" },
		{ value: "93", label: "Phencyclidine use disorder, Severe-304.6 (F16.20)" },
		{ value: "142", label: "Sedative, hypnotic, or anxiolytic intoxication-292.89", },
		{ value: "143", label: "Sedative, hypnotic, or anxiolytic intoxication, With mild use disorder (F13.129)", },
		{ value: "144", label: "Sedative, hypnotic, or anxiolytic intoxication, With moderate or severe use disorder (F13.229)", },
		{ value: "145", label: "Sedative, hypnotic, or anxiolytic intoxication, Without use disorder (F13.929)", },
		{ value: "22", label: "Sedative, hypnotic, or anxiolytic use disorder-Mild-305.40 (F13.10)", },
		{ value: "23", label: "Sedative, hypnotic, or anxiolytic use disorder-Moderate-304.10 (F13.20)", },
		{ value: "24", label: "Sedative, hypnotic, or anxiolytic use disorder-Severe-304.10 (F13.20)", },
		{ value: "146", label: "Sedative, hypnotic, or anxiolytic withdrawal-292 ", },
		{ value: "102", label: "Tobacco use disorder, Mild-305.1 (Z72.0)" },
		{ value: "103", label: "Tobacco use disorder, Moderate-305.1 (F17.200)" },
		{ value: "104", label: "Tobacco use disorder, Severe-305.1 (F17.200)" },
		{ value: "147", label: "Tobacco withdrawal-292 (F17.203)" },
		{ value: '106', label: "Unspecified alcohol-related disorder-291.9 (F10.99)" },
		{ value: '107', label: "Unspecified amphetamine or other stimulant-related disorder (F15.99)" },
		{ value: '111', label: "Unspecified caffeine-related disorder-292.9 (F15.99)" },
		{ value: '112', label: "Unspecified cannabis-related disorder-292.9 (F12.99)" },
		{ value: "113", label: "Unspecified cocaine-related disorder (F14.99)" },
		{ value: "148", label: "Unspecified hallucinogen-related disorder-292.9 (F16.99)" },
		{ value: "149", label: "Unspecified inhalant-related disorder-292.9 (F18.99)" },
		{ value: "116", label: "Unspecified opioid-related disorder-292.9 (F11.99)" },
		{ value: "150", label: "Unspecified other (or unknown) substance-related disorder-292.9 (F19.99)" },
		{ value: "117", label: "Unspecified phencyclidine-related disorder-292.9 (F16.99)" },
		{ value: "151", label: "Unspecified problem related to social environment-V62.9 (Z60.9)" },
		{ value: "152", label: "Unspecified sedative-, hypnotic-, or anxiolytic-related disorder-292.9 (F13.99)" },
		{ value: "118", label: "Unspecified stimulant-related disorder-292.9" },
		{ value: "119", label: "Unspecified tobacco-related disorder-292.9 (F17.209)" },
		{ value: "154", label: "Gaming Disorder Online (6C51.0)" },
		{ value: "155", label: "Gaming Disorder Offline (6C51.1)" },
		{ value: "156", label: "Gaming Disorder Unspecified (6C51.Z)" },
	],
	Otheroptions: [
		{ value: '1', label: "Academic or Educational problem-V62.3 (Z55.9)" },
		{ value: '2', label: "Acculturation difficulty-V62.4 (Z60.3)" },
		{ value: '126', label: "Conduct disorder, Unspecified onset-312.89 (F91.9)" },
		{ value: '127', label: "Extreme poverty-V60.2 (Z59.5)" },
		{ value: '128', label: "High expressed emotion level within family-V61.8 (Z63.8)" },
		{ value: '129', label: "Hoarding disorder-300.3 (F42)" },
		{ value: '130', label: "Homelessness-V60.0 (Z59.0)" },
		{ value: '131', label: "Imprisonment or other incarceration-V62.5 (Z65.1)" },
		{ value: '132', label: "Inadequate housing-V60.1 (Z59.1)" },
		{ value: '133', label: "Intermittent explosive disorder-312.34 (F63.81)" },
		{ value: '134', label: "Kleptomania-312.32 (F63.2)" },
		{ value: '135', label: "Lack of adequate food or safe drinking water-V60.2 (Z59.4)" },
		{ value: '136', label: "Language disorder-315.39 (F80.9)" },
		{ value: '137', label: "Low income-V60.2 (Z59.6)" },
		{ value: '138', label: "Malingering-V65.2 (Z76.5)" },
		{ value: '139', label: "Nightmare disorder-307.47 (F51.5)" },
		{ value: '140', label: "Nonadherence to medical treatment-V15.81 (Z91.19)" },
		{ value: '141', label: "Non-rapid eye movement sleep arousal disorders" },
		{ value: "78", label: "Other personal history of psychological trauma-V15.49 (Z91.49)", },
		{ value: "79", label: "Other personal risk factors-V15.89 (Z91.89)", },
		{ value: '142', label: "Other problem related to employment-V62.29 (Z56.9)" },
		{ value: '80', label: "Other problem related to psychosocial circumstances-V15.49 (Z65.8)" },
		{ value: '9', label: "Parent-Child relational problem-V61.20 (Z62.820)" },
		{ value: "85", label: "Personal history (past history) of neglect in childhood-V15.42 (Z62.812)" },
		{ value: "86", label: "Personal history (past history) of physical abuse in childhood-V15.41 (Z62.810)" },
		{ value: "87", label: "Personal history (past history) of psychological abuse in childhood-V15.42 (Z62.811)" },
		{ value: "88", label: "Personal history (past history) of sexual abuse in childhood-V15.41 (Z62.810)" },
		{ value: "89", label: "Personal history (past history) of spouse or partner neglect-V15.42 (Z91.412)" },
		{ value: "90", label: "Personal history (past history) of spouse or partner psychological abuse-V15.42 (Z91.411)" },
		{ value: "91", label: "Personal history (past history) of spouse or partner violence, Physical-V15.41 (Z91.410)" },
		{ value: "92", label: "Personal history (past history) of spouse or partner violence, Sexual-V15.41 (Z91.410)" },
		{ value: '143', label: "Phase of life problem-V62.89 (Z60.0)" },
		{ value: "99", label: "Problem related to lifestyle-V69.9 (Z72.9)" },
		{ value: "100", label: "Problem related to living alone-V60.3 (Z60.2)" },
		{ value: '144', label: "Problem related to living in a residential institution-V60.6 (Z59.3)" },
		{ value: '145', label: "Problems related to other legal circumstances-V62.5 (Z65.3)" },
		{ value: '12', label: "Relationship distress with spouse or Intimate partner-V61.10 (Z63.0)" },
		{ value: '13', label: "Religious or Spiritual problem-V62.89 (Z65.8)" },
		{ value: '146', label: "Social (pragmatic) communication disorder-315.39 (F80.89)" },
		{ value: '147', label: "Social exclusion or rejection-V62.4 (Z60.4)" },
		{ value: '148', label: "Somatic symptom disorder-300.82 (F45.1)" },
		{ value: '149', label: "Target of (perceived) adverse discrimination or persecution-V62.4 (Z60.5)" },
		{ value: '150', label: "Trichotillomania (hair-pulling disorder)-312.39 (F63.3)" },
		{ value: '151', label: "Uncomplicated bereavement-V62.82 (Z63.4)" },
		{ value: '152', label: "Housing or economic problem Unspecified-V60.9 (Z59.9)" },
		{ value: '153', label: "Problem related to social environment Unspecified-V62.9 (Z60.9)" },
		{ value: '154', label: "Problem related to unspecified psychosocial circumstances Unspecified-V62.9 (Z65.9)" },
		{ value: '155', label: "Victim of crime-V62.89 (Z65.4)" },
		{ value: '156', label: "Victim of terrorism or torture-V62.89 (Z65.4)" },
	],
	mentalHealthDiagOptions: [
		{ value: "55", label: 'Acute stress disorder-308.3 (F43.0)', },
		{ value: "1", label: "Adjustment disorder Unspecified-309.9 (F43.20)" },
		{ value: "2", label: "Adjustment disorder with anxiety-309.24 (F43.22)" },
		{ value: "3", label: "Adjustment disorder with depressed mood-309.0 (F43.21)" },
		{ value: "4", label: "Adjustment disorder with disturbance of conduct-309.3 (F43.24)" },
		{ value: "5", label: "Adjustment disorder with mixed anxiety and depressed mood-309.28 (F43.23)" },
		{ value: "6", label: "Adjustment disorder with mixed disturbance of emotions and conduct-309.4 (F43.25)" },
		{ value: "143", label: "Adult antisocial behavior-V71.01 (Z72.811)" },
		{ value: "144", label: "Alcohol intoxication delirium-291" },
		{ value: "145", label: "Alcohol intoxication delirium, With mild use disorder (F10.121)" },
		{ value: "146", label: "Alcohol intoxication delirium, With moderate or severe use disorder (F10.221)" },
		{ value: "147", label: "Alcohol intoxication delirium, Without use disorder (F10.921)" },
		{ value: "148", label: "Alcohol withdrawal delirium-291 (F10.231)" },
		{ value: "149", label: "Alcohol withdrawal, With perceptual disturbances (F10.232)" },
		{ value: "150", label: "Alcohol withdrawal, Without perceptual disturbances (F10.239)" },
		{ value: "151", label: "Alcohol-induced anxiety disorder-291.89" },
		{ value: "152", label: "Alcohol-induced anxiety disorder, With mild use disorder (F10.180)" },
		{ value: "153", label: "Alcohol-induced anxiety disorder, With moderate or severe use disorder (F10.280)" },
		{ value: "154", label: "Alcohol-induced anxiety disorder, Without use disorder (F10.980)" },
		{ value: "155", label: "Alcohol-induced bipolar and related disorder-291.89" },
		{ value: "156", label: "Alcohol-induced bipolar and related disorder, With mild use disorder (F10.14)" },
		{ value: "157", label: "Alcohol-induced bipolar and related disorder, With moderate or severe use disorder (F10.24)" },
		{ value: "158", label: "Alcohol-induced bipolar and related disorder, Without use disorder (F10.94)" },
		{ value: "159", label: "Alcohol-induced depressive disorder-291.89" },
		{ value: "160", label: "Alcohol-induced depressive disorder, With mild use disorder (F10.14)" },
		{ value: "161", label: "Alcohol-induced depressive disorder, With moderate or severe use disorder (F10.24)" },
		{ value: "162", label: "Alcohol-induced depressive disorder, Without use disorder (F10.94)" },
		{ value: "163", label: "Alcohol-induced major neurocognitive disorder, Amnestic confabulatory type-291.1" },
		{ value: "164", label: "Alcohol-induced major neurocognitive disorder, Amnestic confabulatory type, With moderate or severe use disorder (F10.26)" },
		{ value: "165", label: "Alcohol-induced major neurocognitive disorder, Amnestic confabulatory type, Without use disorder (F10.96)" },
		{ value: "166", label: "Alcohol-induced major neurocognitive disorder, Nonamnestic confabulatory type-291.2" },
		{ value: "167", label: "Alcohol-induced major neurocognitive disorder, Nonamnestic confabulatory type, With moderate or severe use disorder (F10.27)" },
		{ value: "168", label: "Alcohol-induced major neurocognitive disorder, Nonamnestic confabulatory type, Without use disorder (F10.97)" },
		{ value: "169", label: "Alcohol-induced mild neurocognitive disorder-291.89" },
		{ value: "170", label: "Alcohol-induced mild neurocognitive disorder, With moderate or severe use disorder (F10.288)" },
		{ value: "171", label: "Alcohol-induced mild neurocognitive disorder, Without use disorder (F10.988)" },
		{ value: "172", label: "Alcohol-induced psychotic disorder-291.9" },
		{ value: "173", label: "Alcohol-induced psychotic disorder, With mild use disorder (F10.159)" },
		{ value: "174", label: "Alcohol-induced psychotic disorder, With moderate or severe use disorder (F10.259)" },
		{ value: "175", label: "Alcohol-induced psychotic disorder, Without use disorder (F10.959)" },
		{ value: "176", label: "Alcohol-induced sexual dysfunction-291.89" },
		{ value: "177", label: "Alcohol-induced sexual dysfunction, With mild use disorder (F10.181)" },
		{ value: "178", label: "Alcohol-induced sexual dysfunction, With moderate or severe use disorder (F10.281)" },
		{ value: "179", label: "Alcohol-induced sexual dysfunction, Without use disorder (F10.981)" },
		{ value: "180", label: "Alcohol-induced sleep disorder-291.82" },
		{ value: "181", label: "Alcohol-induced sleep disorder, With mild use disorder (F10.182)" },
		{ value: "182", label: "Alcohol-induced sleep disorder, With moderate or severe use disorder (F10.282)" },
		{ value: "183", label: "Alcohol-induced sleep disorder, Without use disorder (F10.982)" },
		{ value: "184", label: "Amphetamine (or other stimulant) intoxication delirium, With mild use disorder (F15.121)" },
		{ value: "185", label: "Amphetamine (or other stimulant) intoxication delirium, With moderate or severe use disorder (F15.221)" },
		{ value: "186", label: "Amphetamine (or other stimulant) intoxication delirium, Without use disorder (F15.921)" },
		{ value: "187", label: "Amphetamine (or other stimulant)-induced anxiety disorder-292.89" },
		{ value: "188", label: "Amphetamine (or other stimulant)-induced anxiety disorder, With mild use disorder (F15.180)" },
		{ value: "189", label: "Amphetamine (or other stimulant)-induced anxiety disorder, With moderate or severe use disorder (F15.280)" },
		{ value: "190", label: "Amphetamine (or other stimulant)-induced anxiety disorder, Without use disorder (F15.980)" },
		{ value: "191", label: "Amphetamine (or other stimulant)-induced bipolar and related disorder-292.84" },
		{ value: "192", label: "Amphetamine (or other stimulant)-induced bipolar and related disorder, With mild use disorder (F15.14)" },
		{ value: "193", label: "Amphetamine (or other stimulant)-induced bipolar and related disorder, With moderate or severe use disorder (F15.24)" },
		{ value: "194", label: "Amphetamine (or other stimulant)-induced bipolar and related disorder, Without use disorder (F15.94)" },
		{ value: "195", label: "Amphetamine (or other stimulant)-induced delirium (F15.921)" },
		{ value: "196", label: "Amphetamine (or other stimulant)-induced depressive disorder-292.84" },
		{ value: "197", label: "Amphetamine (or other stimulant)-induced depressive disorder, With mild use disorder (F15.14)" },
		{ value: "198", label: "Amphetamine (or other stimulant)-induced depressive disorder, With moderate or severe use disorder (F15.24)" },
		{ value: "199", label: "Amphetamine (or other stimulant)-induced depressive disorder, Without use disorder (F15.94)" },
		{ value: "200", label: "Amphetamine (or other stimulant)-induced obsessive-compulsive and related disorder-292.89" },
		{ value: "201", label: "Amphetamine (or other stimulant)-induced obsessive-compulsive and related disorder, With mild use disorder (F15.188)" },
		{ value: "202", label: "Amphetamine (or other stimulant)-induced obsessive-compulsive and related disorder, With moderate or severe use disorder (F15.288)" },
		{ value: "203", label: "Amphetamine (or other stimulant)-induced obsessive-compulsive and related disorder, Without use disorder (F15.988)" },
		{ value: "204", label: "Amphetamine (or other stimulant)-induced psychotic disorder-292.9" },
		{ value: "205", label: "Amphetamine (or other stimulant)-induced psychotic disorder, With mild use disorder (F15.159)" },
		{ value: "206", label: "Amphetamine (or other stimulant)-induced psychotic disorder, With moderate or severe use disorder (F15.259)" },
		{ value: "207", label: "Amphetamine (or other stimulant)-induced psychotic disorder, Without use disorder (F15.959)" },
		{ value: "208", label: "Amphetamine (or other stimulant)-induced sexual dysfunction-292.89" },
		{ value: "209", label: "Amphetamine (or other stimulant)-induced sexual dysfunction, With mild use disorder (F15.181)" },
		{ value: "210", label: "Amphetamine (or other stimulant)-induced sexual dysfunction, With moderate or severe use disorder (F15.281)" },
		{ value: "211", label: "Amphetamine (or other stimulant)-induced sexual dysfunction, Without use disorder (F15.981)" },
		{ value: "212", label: "Amphetamine (or other stimulant)-induced sleep disorder-292.85" },
		{ value: "213", label: "Amphetamine (or other stimulant)-induced sleep disorder, With mild use disorder (F15.182)" },
		{ value: "214", label: "Amphetamine (or other stimulant)-induced sleep disorder, With moderate or severe use disorder (F15.282)" },
		{ value: "215", label: "Amphetamine (or other stimulant)-induced sleep disorder, Without use disorder (F15.982)" },
		{ value: "216", label: "Amphetamine or other stimulant intoxication, With perceptual disturbances, With mild use disorder (F15.122)" },
		{ value: "217", label: "Amphetamine or other stimulant intoxication, With perceptual disturbances, With moderate or severe use disorder (F15.222)" },
		{ value: "218", label: "Amphetamine or other stimulant intoxication, With perceptual disturbances, Without use disorder (F15.922)" },
		{ value: "219", label: "Amphetamine or other stimulant intoxication, Without perceptual disturbances" },
		{ value: "220", label: "Amphetamine or other stimulant intoxication, Without perceptual disturbances, With mild use disorder (F15.129)" },
		{ value: "221", label: "Amphetamine or other stimulant intoxication, Without perceptual disturbances, With moderate or severe use disorder (F15.229)" },
		{ value: "222", label: "Amphetamine or other stimulant intoxication, Without perceptual disturbances, Without use disorder (F15.929)" },
		{ value: '68', label: "Anorexia nervosa-307.1" },
		{ value: '62', label: "Anorexia nervosa, Binge-eating/purging type (F50.02)" },
		{ value: '63', label: "Anorexia nervosa, Restricting type (F50.01)" },
		{ value: "7", label: "Antisocial personality disorder-301.7 (F60.2)" },
		{ value: "223", label: "Anxiety disorder due to another medical condition-293.84 (F06.4)" },
		{ value: "8", label: "Attention-deficit/hyperactivity disorder, Combined presentation-314.01 (F90.2)" },
		{ value: "9", label: "Attention-deficit/hyperactivity disorder, Predominantly hyperactive/impulsive presentation-314.01 (F90.1)" },
		{ value: "10", label: "Attention-deficit/hyperactivity disorder, Predominantly inattentive presentation-314.00 (F90.0)" },
		{ value: "224", label: "Autism spectrum disorder-299 (F84.0)" },
		{ value: "11", label: "Avoidant personality disorder-301.82 (F60.6)" },
		{ value: "225", label: "Avoidant/restrictive food intake disorder-307.59 (F50.8)" },
		{ value: '64', label: "Binge-eating disorder-307.51 (F50.8)" },
		{ value: "226", label: "Bipolar and related disorder due to another medical condition-293.83" },
		{ value: "556", label: "Bipolar and related disorder due to another medical condition, With manic features (F06.33)" },
		{ value: "227", label: "Bipolar and related disorder due to another medical condition, With manic- or hypomanic-like episodes (F06.33)" },
		{ value: "228", label: "Bipolar and related disorder due to another medical condition, With mixed features (F06.34)" },
		{ value: "229", label: "Bipolar I disorder, Current or most recent episode depressed" },
		{ value: "230", label: "Bipolar I disorder, Current or most recent episode depressed, In full remission-296.56 (F31.76)" },
		{ value: "231", label: "Bipolar I disorder, Current or most recent episode depressed, In partial remission-296.55 (F31.75)" },
		{ value: "13", label: "Bipolar I disorder, Current or most recent episode depressed-Mild-296.51 (F31.31)" },
		{ value: "14", label: "Bipolar I disorder, Current or most recent episode depressed-Moderate-296.52 (F31.32)" },
		{ value: "15", label: "Bipolar I disorder, Current or most recent episode depressed-Severe-296.53 (F31.4)" },
		{ value: "16", label: "Bipolar I disorder, Current or most recent episode depressed-Unspecified-296.50 (F31.9)" },
		{ value: "12", label: "Bipolar I disorder, Current or most recent episode depressed, With psychotic features-296.54 (F31.5)" },
		{ value: "17", label: "Bipolar I disorder, Current or most recent episode hypomanic-296.40 (F31.0)" },
		{ value: "232", label: "Bipolar I disorder, Current or most recent episode hypomanic, In full remission-296.46 (F31.74)" },
		{ value: "233", label: "Bipolar I disorder, Current or most recent episode hypomanic, In partial remission-296.45 (F31.73)" },
		{ value: "234", label: "Bipolar I disorder, Current or most recent episode hypomanic, Unspecified-296.4 (F31.9)" },
		{ value: "235", label: "Bipolar I disorder, Current or most recent episode manic" },
		{ value: "236", label: "Bipolar I disorder, Current or most recent episode manic, In full remission-296.46 (F31.74)" },
		{ value: "237", label: "Bipolar I disorder, Current or most recent episode manic, In partial remission-296.45 (F31.73)" },
		{ value: "18", label: "Bipolar I disorder, Current or most recent episode manic-Mild-296.41" },
		{ value: "19", label: "Bipolar I disorder, Current or most recent episode manic-Moderate-296.42" },
		{ value: "20", label: "Bipolar I disorder, Current or most recent episode manic-Severe-296.43" },
		{ value: "238", label: "Bipolar I disorder, Current or most recent episode manic, Unspecified-296.4 (F31.9)" },
		{ value: "239", label: "Bipolar I disorder, Current or most recent episode manic, With psychotic features-296.44 (F31.2)" },
		{ value: "21", label: "Bipolar I disorder, Current or most recent episode unspecified-296.7 (F31.9)" },
		{ value: "22", label: "Bipolar II Disorder-296.89 (F31.81)" },
		{ value: '69', label: "Body dysmorphic disorder-300.7 (F45.22)" },
		{ value: "240", label: "Borderline intellectual functioning-V62.89 (R41.83)" },
		{ value: "23", label: "Borderline personality disorder-301.83 (F60.3)" },
		{ value: "241", label: "Brief psychotic disorder-298.8 (F23)" },
		{ value: '70', label: "Bulimia nervosa-307.51 (F50.2)" },
		{ value: "242", label: "Caffeine-induced anxiety disorder-292.89" },
		{ value: "243", label: "Caffeine-induced anxiety disorder, With mild use disorder (F15.180)" },
		{ value: "244", label: "Caffeine-induced anxiety disorder, With moderate or severe use disorder (F15.280)" },
		{ value: "245", label: "Caffeine-induced anxiety disorder, Without use disorder (F15.980)" },
		{ value: "246", label: "Caffeine-induced sleep disorder-292.85" },
		{ value: "247", label: "Caffeine-induced sleep disorder, With mild use disorder (F15.182)" },
		{ value: "248", label: "Caffeine-induced sleep disorder, With moderate or severe use disorder (F15.282)" },
		{ value: "249", label: "Caffeine-induced sleep disorder, Without use disorder (F15.982)" },
		{ value: "250", label: "Cannabis intoxication delirium-292.81" },
		{ value: "251", label: "Cannabis intoxication delirium, With mild use disorder (F12.121)" },
		{ value: "252", label: "Cannabis intoxication delirium, With moderate or severe use disorder (F12.221)" },
		{ value: "253", label: "Cannabis intoxication delirium, Without use disorder (F12.921)" },
		{ value: "254", label: "Cannabis intoxication, With perceptual disturbances, With mild use disorder (F12.122)" },
		{ value: "255", label: "Cannabis intoxication, With perceptual disturbances, With moderate or severe use disorder (F12.222)" },
		{ value: "256", label: "Cannabis intoxication, With perceptual disturbances, Without use disorder (F12.922)" },
		{ value: "257", label: "Cannabis intoxication, Without perceptual disturbances" },
		{ value: "258", label: "Cannabis intoxication, Without perceptual disturbances, With mild use disorder(F12.129)" },
		{ value: "259", label: "Cannabis intoxication, Without perceptual disturbances, With moderate or severe use disorder (F12.229)" },
		{ value: "260", label: "Cannabis intoxication, Without perceptual disturbances, Without use disorder (F12.929)" },
		{ value: "261", label: "Cannabis-induced anxiety disorder-292.89" },
		{ value: "262", label: "Cannabis-induced anxiety disorder, With mild use disorder (F12.180)" },
		{ value: "263", label: "Cannabis-induced anxiety disorder, With moderate or severe use disorder (F12.280)" },
		{ value: "264", label: "Cannabis-induced anxiety disorder, Without use disorder (F12.980)" },
		{ value: "265", label: "Cannabis-induced psychotic disorder-292.9" },
		{ value: "266", label: "Cannabis-induced psychotic disorder, With mild use disorder (F12.159)" },
		{ value: "267", label: "Cannabis-induced psychotic disorder, With moderate or severe use disorder (F12.259)" },
		{ value: "268", label: "Cannabis-induced psychotic disorder, Without use disorder (F12.959)" },
		{ value: "269", label: "Cannabis-induced sleep disorder-292.85" },
		{ value: "270", label: "Cannabis-induced sleep disorder, With mild use disorder (F12.188)" },
		{ value: "271", label: "Cannabis-induced sleep disorder, With moderate or severe use disorder (F12.288)" },
		{ value: "272", label: "Cannabis-induced sleep disorder, Without use disorder (F12.988)" },
		{ value: "273", label: "Central sleep apnea comorbid with opioid use-780.57 (G47.37)" },
		{ value: "274", label: "Child or adolescent antisocial behavior-V71.02 (Z72.810)" },
		{ value: "275", label: "Cocaine intoxication delirium, With mild use disorder (F14.121)" },
		{ value: "276", label: "Cocaine intoxication delirium, With moderate or severe use disorder (F14.221)" },
		{ value: "278", label: "Cocaine intoxication delirium, Without use disorder (F14.921)" },
		{ value: "279", label: "Cocaine intoxication, With perceptual disturbances, With mild use disorder (F14.122)" },
		{ value: "280", label: "Cocaine intoxication, With perceptual disturbances, With moderate or severe use disorder (F14.222)" },
		{ value: "281", label: "Cocaine intoxication, With perceptual disturbances, Without use disorder (F14.922)" },
		{ value: "282", label: "Cocaine intoxication, Without perceptual disturbances" },
		{ value: "283", label: "Cocaine intoxication, Without perceptual disturbances, With mild use disorder (F14.129)" },
		{ value: "284", label: "Cocaine intoxication, Without perceptual disturbances, With moderate or severe use disorder (F14.229)" },
		{ value: "285", label: "Cocaine intoxication, Without perceptual disturbances, Without use disorder (F14.929)" },
		{ value: "286", label: "Cocaine-induced anxiety disorder-292.89" },
		{ value: "287", label: "Cocaine-induced anxiety disorder, With mild use disorder (F14.180)" },
		{ value: "288", label: "Cocaine-induced anxiety disorder, With moderate or severe use disorder (F14.280)" },
		{ value: "289", label: "Cocaine-induced anxiety disorder, Without use disorder (F14.980)" },
		{ value: "290", label: "Cocaine-induced bipolar and related disorder-292.84" },
		{ value: "291", label: "Cocaine-induced bipolar and related disorder, With mild use disorder (F14.14)" },
		{ value: "292", label: "Cocaine-induced bipolar and related disorder, With moderate or severe use disorder (F14.24)" },
		{ value: "293", label: "Cocaine-induced bipolar and related disorder, Without use disorder (F14.94)" },
		{ value: "294", label: "Cocaine-induced depressive disorder-292.84" },
		{ value: "295", label: "Cocaine-induced depressive disorder, With mild use disorder (F14.14)" },
		{ value: "296", label: "Cocaine-induced depressive disorder, With moderate or severe use disorder (F14.24)" },
		{ value: "297", label: "Cocaine-induced depressive disorder, Without use disorder (F14.94)" },
		{ value: "298", label: "Cocaine-induced obsessive-compulsive and related disorder-292.89" },
		{ value: "299", label: "Cocaine-induced obsessive-compulsive and related disorder, With mild use disorder (F14.188)" },
		{ value: "300", label: "Cocaine-induced obsessive-compulsive and related disorder, With moderate or severe use disorder (F14.288)" },
		{ value: "301", label: "Cocaine-induced obsessive-compulsive and related disorder, Without use disorder (F14.988)" },
		{ value: "302", label: "Cocaine-induced psychotic disorder-292.9" },
		{ value: "303", label: "Cocaine-induced psychotic disorder, With mild use disorder (F14.159)" },
		{ value: "304", label: "Cocaine-induced psychotic disorder, With moderate or severe use disorder (F14.259)" },
		{ value: "305", label: "Cocaine-induced psychotic disorder, Without use disorder (F14.959)" },
		{ value: "306", label: "Cocaine-induced sexual dysfunction-292.89" },
		{ value: "307", label: "Cocaine-induced sexual dysfunction, With mild use disorder (F14.181)" },
		{ value: "308", label: "Cocaine-induced sexual dysfunction, With moderate or severe use disorder (F14.281)" },
		{ value: "309", label: "Cocaine-induced sexual dysfunction, Without use disorder (F14.981)" },
		{ value: "310", label: "Cocaine-induced sleep disorder-292.85" },
		{ value: "311", label: "Cocaine-induced sleep disorder, With mild use disorder (F14.182)" },
		{ value: "312", label: "Cocaine-induced sleep disorder, With moderate or severe use disorder (F14.282)" },
		{ value: "313", label: "Cocaine-induced sleep disorder, Without use disorder (F14.982)" },
		{ value: "314", label: "Delusional disorder-297.1 (F22)" },
		{ value: "24", label: "Dependent personality disorder-301.6 (F60.7)" },
		{ value: "315", label: "Depersonalization/derealization disorder-300.6 (F48.1)" },
		{ value: "316", label: "Depressive disorder due to another medical condition-293.83" },
		{ value: "317", label: "Depressive disorder due to another medical condition, With depressive features (F06.31)" },
		{ value: "318", label: "Depressive disorder due to another medical condition, With major depressive-like episode (F06.32)" },
		{ value: "319", label: "Depressive disorder due to another medical condition, With mixed features (F06.34)" },
		{ value: "320", label: "Disruptive mood dysregulation disorder-296.99 (F34.8)" },
		{ value: "321", label: "Dissociative amnesia-300.12 (F44.0)" },
		{ value: "322", label: "Dissociative amnesia, with dissociative fugue-300.13 (F44.1)" },
		{ value: "323", label: "Dissociative identity disorder-300.14 (F44.81)" },
		{ value: "25", label: "Generalized anxiety disorder-300.02 (F41.1)" },
		{ value: "324", label: "Hallucinogen persisting perception disorder-292.89 (F16.983)" },
		{ value: "26", label: "Histrionic personality disorder-301.50 (F60.4)" },
		{ value: "325", label: "Illness anxiety disorder-300.7 (F45.21)" },
		{ value: "326", label: "Inhalant intoxication delirium-292.81" },
		{ value: "327", label: "Inhalant intoxication delirium, With mild use disorder (F18.121)" },
		{ value: "328", label: "Inhalant intoxication delirium, With moderate or severe use disorder (F18.221)" },
		{ value: "329", label: "Inhalant intoxication delirium, Without use disorder (F18.921)" },
		{ value: "330", label: "Inhalant-induced anxiety disorder-292.89" },
		{ value: "331", label: "Inhalant-induced anxiety disorder, With mild use disorder (F18.180)" },
		{ value: "332", label: "Inhalant-induced anxiety disorder, With moderate or severe use disorder (F18.280)" },
		{ value: "333", label: "Inhalant-induced anxiety disorder, Without use disorder (F18.980)" },
		{ value: "334", label: "Inhalant-induced depressive disorder-292.84" },
		{ value: "335", label: "Inhalant-induced depressive disorder, With mild use disorder (F18.14)" },
		{ value: "336", label: "Inhalant-induced depressive disorder, With moderate or severe use disorder (F18.24)" },
		{ value: "337", label: "Inhalant-induced depressive disorder, Without use disorder (F18.94)" },
		{ value: "338", label: "Inhalant-induced major neurocognitive disorder-292.82" },
		{ value: "339", label: "Inhalant-induced major neurocognitive disorder, With mild use disorder (F18.17)" },
		{ value: "340", label: "Inhalant-induced major neurocognitive disorder, With moderate or severe use disorder (F18.27)" },
		{ value: "341", label: "Inhalant-induced major neurocognitive disorder, Without use disorder (F18.97)" },
		{ value: "342", label: "Inhalant-induced mild neurocognitive disorder-292.89" },
		{ value: "343", label: "Inhalant-induced mild neurocognitive disorder, With mild use disorder (F18.188)" },
		{ value: "344", label: "Inhalant-induced mild neurocognitive disorder, With moderate or severe use disorder (F18.288)" },
		{ value: "345", label: "Inhalant-induced mild neurocognitive disorder, Without use disorder (F18.988)" },
		{ value: "346", label: "Inhalant-induced psychotic disorder-292.9" },
		{ value: "347", label: "Inhalant-induced psychotic disorder, With mild use disorder (F18.159)" },
		{ value: "348", label: "Inhalant-induced psychotic disorder, With moderate or severe use disorder (F18.259)" },
		{ value: "349", label: "Inhalant-induced psychotic disorder, Without use disorder (F18.959)" },
		{ value: "86", label: "Insomnia disorder-780.52 (G47.00)", },
		{ value: "350", label: "Major depressive disorder, Recurrent episode" },
		{ value: "351", label: "Major depressive disorder, Recurrent episode, In full remission-296.36 (F33.42)" },
		{ value: "352", label: "Major depressive disorder, Recurrent episode, In partial remission-296.35 (F33.41)" },
		{ value: "353", label: "Major depressive disorder, Recurrent episode, Mild-296.31 (F33.0)" },
		{ value: "354", label: "Major depressive disorder, Recurrent episode, Moderate-296.32 (F33.1)" },
		{ value: "355", label: "Major depressive disorder, Recurrent episode, Severe-296.33 (F33.2)" },
		{ value: "356", label: "Major depressive disorder, Recurrent episode, Unspecified-296.3 (F33.9)" },
		{ value: "357", label: "Major depressive disorder, Recurrent episode, With psychotic features-296.34 (F33.3)" },
		{ value: "358", label: "Major depressive disorder, Single episode" },
		{ value: "359", label: "Major depressive disorder, Single episode, In full remission-296.26 (F32.5)" },
		{ value: "360", label: "Major depressive disorder, Single episode, In partial remission-F32.4 (F32.4)" },
		{ value: "27", label: "Major depressive disorder, Single episode, Unspecified-296.20(F32.9)" },
		{ value: "28", label: "Major depressive disorder, Single episode-Mild-296.21 (F32.0)" },
		{ value: "29", label: "Major depressive disorder, Single episode-Moderate-296.22 (F32.1)" },
		{ value: "30", label: "Major depressive disorder, Single episode-Severe-296.23 (F32.2)" },
		{ value: "361", label: "Major depressive disorder, Single episode, With psychotic features-296.24 (F32.3)" },
		{ value: "31", label: "Narcissistic personality disorder-301.81 (F60.81)" },
		{ value: "362", label: "Nonadherence to medical treatment-V15.81 (Z91.19)" },
		{ value: "363", label: "Obsessive-compulsive and related disorder due to another medical condition-294.8 (F06.8)" },
		{ value: "32", label: "Obsessive-compulsive disorder-303.3 (F42)" },
		{ value: "33", label: "Obsessive-compulsive personality disorder-301.4 (F60.5)" },
		{ value: "364", label: "Opioid intoxication delirium-292.81" },
		{ value: "365", label: "Opioid intoxication delirium, With mild use disorder (F11.121)" },
		{ value: "366", label: "Opioid intoxication delirium, With moderate or severe use disorder (F11.221)" },
		{ value: "367", label: "Opioid intoxication delirium, Without use disorder (F11.921)" },
		{ value: "368", label: "Opioid intoxication, With perceptual disturbances" },
		{ value: "369", label: "Opioid intoxication, With perceptual disturbances, With mild use disorder (F11.122)" },
		{ value: "370", label: "Opioid intoxication, With perceptual disturbances, With moderate or severe use disorder (F11.222)" },
		{ value: "371", label: "Opioid intoxication, With perceptual disturbances, Without use disorder (F11.922)" },
		{ value: "372", label: "Opioid intoxication, Without perceptual disturbances" },
		{ value: "373", label: "Opioid intoxication, Without perceptual disturbances, With mild use disorder (F11.129)" },
		{ value: "374", label: "Opioid intoxication, Without perceptual disturbances, With moderate or severe use disorder (F11.229)" },
		{ value: "375", label: "Opioid intoxication, Without perceptual disturbances, Without use disorder (F11.929)" },
		{ value: "376", label: "Opioid withdrawal delirium-292 (F11.23)" },
		{ value: "377", label: "Opioid-induced anxiety disorder-292.89" },
		{ value: "378", label: "Opioid-induced anxiety disorder, With mild use disorder (F11.188)" },
		{ value: "379", label: "Opioid-induced anxiety disorder, With moderate or severe use disorder (F11.288)" },
		{ value: "380", label: "Opioid-induced anxiety disorder, Without use disorder (F11.988)" },
		{ value: "381", label: "Opioid-induced delirium (F11.921)" },
		{ value: "382", label: "Opioid-induced depressive disorder-292.84" },
		{ value: "383", label: "Opioid-induced depressive disorder, With mild use disorder (F11.14)" },
		{ value: "384", label: "Opioid-induced depressive disorder, With moderate or severe use disorder (F11.24)" },
		{ value: "385", label: "Opioid-induced depressive disorder, Without use disorder (F11.94)" },
		{ value: "386", label: "Opioid-induced sexual dysfunction-292.89" },
		{ value: "387", label: "Opioid-induced sexual dysfunction, With mild use disorder (F11.181)" },
		{ value: "388", label: "Opioid-induced sexual dysfunction, With moderate or severe use disorder (F11.281)" },
		{ value: "389", label: "Opioid-induced sexual dysfunction, Without use disorder (F11.981)" },
		{ value: "390", label: "Opioid-induced sleep disorder-292.85" },
		{ value: "391", label: "Opioid-induced sleep disorder, With mild use disorder (F11.182)" },
		{ value: "392", label: "Opioid-induced sleep disorder, With moderate or severe use disorder (F11.282)" },
		{ value: "393", label: "Opioid-induced sleep disorder, Without use disorder (F11.982)" },
		{ value: "34", label: "Oppositional defiant disorder-313.81" },
		{ value: "394", label: "Other (or unknown) substance intoxication delirium-292.81" },
		{ value: "395", label: "Other (or unknown) substance intoxication delirium, With mild use disorder (F19.121)" },
		{ value: "396", label: "Other (or unknown) substance intoxication delirium, With moderate or severe use disorder (F19.221)" },
		{ value: "397", label: "Other (or unknown) substance intoxication delirium, Without use disorder (F19.921)" },
		{ value: "398", label: "Other (or unknown) substance withdrawal delirium-292 (F19.231)" },
		{ value: "399", label: "Other (or unknown) substance-induced anxiety disorder-292.89" },
		{ value: "400", label: "Other (or unknown) substance-induced anxiety disorder, With mild use disorder (F19.180)" },
		{ value: "401", label: "Other (or unknown) substance-induced anxiety disorder, With moderate or severe use disorder (F19.280)" },
		{ value: "402", label: "Other (or unknown) substance-induced anxiety disorder, Without use disorder (F19.980)" },
		{ value: "403", label: "Other (or unknown) substance-induced bipolar and related disorder-292.84" },
		{ value: "404", label: "Other (or unknown) substance-induced bipolar and related disorder, With mild use disorder (F19.14)" },
		{ value: "405", label: "Other (or unknown) substance-induced bipolar and related disorder, With moderate or severe use disorder (F19.24)" },
		{ value: "406", label: "Other (or unknown) substance-induced bipolar and related disorder, Without use disorder (F19.94)" },
		{ value: "407", label: "Other (or unknown) substance-induced delirium (F19.921)" },
		{ value: "408", label: "Other (or unknown) substance-induced depressive disorder-292.84" },
		{ value: "409", label: "Other (or unknown) substance-induced depressive disorder, With mild use disorder (F19.14)" },
		{ value: "410", label: "Other (or unknown) substance-induced depressive disorder, With moderate or severe use disorder (F19.24)" },
		{ value: "411", label: "Other (or unknown) substance-induced depressive disorder, Without use disorder (F19.94)" },
		{ value: "412", label: "Other (or unknown) substance-induced major neurocognitive disorder-292.82" },
		{ value: "413", label: "Other (or unknown) substance-induced major neurocognitive disorder, With mild use disorder (F19.17)" },
		{ value: "414", label: "Other (or unknown) substance-induced major neurocognitive disorder, With moderate or severe use disorder (F19.27)" },
		{ value: "415", label: "Other (or unknown) substance-induced major neurocognitive disorder, Without use disorder (F19.97)" },
		{ value: "416", label: "Other (or unknown) substance-induced mild neurocognitive disorder-292.89" },
		{ value: "417", label: "Other (or unknown) substance-induced mild neurocognitive disorder, With mild use disorder (F19.188)" },
		{ value: "418", label: "Other (or unknown) substance-induced mild neurocognitive disorder, With moderate or severe use disorder (F19.288)" },
		{ value: "419", label: "Other (or unknown) substance-induced mild neurocognitive disorder, Without use disorder (F19.988)" },
		{ value: "420", label: "Other (or unknown) substance-induced obsessive-compulsive and related disorder-292.89" },
		{ value: "421", label: "Other (or unknown) substance-induced obsessive-compulsive and related disorder, With mild use disorder (F19.188)" },
		{ value: "422", label: "Other (or unknown) substance-induced obsessive-compulsive and related disorder, With moderate or severe use disorder (F19.288)" },
		{ value: "423", label: "Other (or unknown) substance-induced obsessive-compulsive and related disorder, Without use disorder (F19.988)" },
		{ value: "424", label: "Other (or unknown) substance-induced psychotic disorder-292.9" },
		{ value: "425", label: "Other (or unknown) substance-induced psychotic disorder, With mild use disorder (F19.159)" },
		{ value: "426", label: "Other (or unknown) substance-induced psychotic disorder, With moderate or severe use disorder (F19.259)" },
		{ value: "427", label: "Other (or unknown) substance-induced psychotic disorder, Without use disorder (F19.959)" },
		{ value: "428", label: "Other (or unknown) substance-induced sexual dysfunction-292.89" },
		{ value: "429", label: "Other (or unknown) substance-induced sexual dysfunction, With mild use disorder (F19.181)" },
		{ value: "430", label: "Other (or unknown) substance-induced sexual dysfunction, With moderate or severe use disorder (F19.281)" },
		{ value: "431", label: "Other (or unknown) substance-induced sexual dysfunction, Without use disorder (F19.981)" },
		{ value: "432", label: "Other (or unknown) substance-induced sleep disorder-292.85" },
		{ value: "433", label: "Other (or unknown) substance-induced sleep disorder, With mild use disorder (F19.182)" },
		{ value: "434", label: "Other (or unknown) substance-induced sleep disorder, With moderate or severe use disorder (F19.282)" },
		{ value: "435", label: "Other (or unknown) substance-induced sleep disorder, Without use disorder (F19.982)" },
		{ value: "436", label: "Other hallucinogen intoxication delirium-292.81" },
		{ value: "437", label: "Other hallucinogen intoxication delirium, With mild use disorder (F16.121)" },
		{ value: "438", label: "Other hallucinogen intoxication delirium, With moderate or severe use disorder (F16.221)" },
		{ value: "439", label: "Other hallucinogen intoxication delirium, Without use disorder (F16.921)" },
		{ value: "440", label: "Other hallucinogen intoxication, With mild use disorder (F16.129)" },
		{ value: "441", label: "Other hallucinogen intoxication, With moderate or severe use disorder (F16.229)" },
		{ value: "442", label: "Other hallucinogen intoxication, Without use disorder (F16.929)" },
		{ value: "443", label: "Other hallucinogen-induced anxiety disorder-292.89" },
		{ value: "444", label: "Other hallucinogen-induced anxiety disorder, With mild use disorder (F16.180)" },
		{ value: "445", label: "Other hallucinogen-induced anxiety disorder, With moderate or severe use disorder (F16.280)" },
		{ value: "446", label: "Other hallucinogen-induced anxiety disorder, Without use disorder (F16.980)" },
		{ value: "447", label: "Other hallucinogen-induced bipolar and related disorder-292.84" },
		{ value: "448", label: "Other hallucinogen-induced bipolar and related disorder, With mild use disorder (F16.14)" },
		{ value: "449", label: "Other hallucinogen-induced bipolar and related disorder, With moderate or severe use disorder (F16.24)" },
		{ value: "450", label: "Other hallucinogen-induced bipolar and related disorder, Without use disorder (F16.94)" },
		{ value: "451", label: "Other hallucinogen-induced depressive disorder-292.84" },
		{ value: "452", label: "Other hallucinogen-induced depressive disorder, With mild use disorder (F16.14)" },
		{ value: "453", label: "Other hallucinogen-induced depressive disorder, With moderate or severe use disorder (F16.24)" },
		{ value: "454", label: "Other hallucinogen-induced depressive disorder, Without use disorder (F16.94)" },
		{ value: "455", label: "Other hallucinogen-induced psychotic disorder-292.9" },
		{ value: "456", label: "Other hallucinogen-induced psychotic disorder, With mild use disorder (F16.159)" },
		{ value: "457", label: "Other hallucinogen-induced psychotic disorder, With moderate or severe use disorder (F16.259)" },
		{ value: "458", label: "Other hallucinogen-induced psychotic disorder, Without use disorder (F16.959)" },
		{ value: "35", label: "Other specified anxiety disorder-300.09 (F41.8)" },
		{ value: "459", label: "Other specified attention-deficit/hyperactivity disorder-314.01 (F90.8)" },
		{ value: "36", label: "Other specified bipolar and related disorder-296.89" },
		{ value: "460", label: "Other specified delirium-780.09 (R41.0)" },
		{ value: "461", label: "Other specified depressive disorder-311 (F32.8)" },
		{ value: "462", label: "Other specified disruptive, impulse-control, and conduct disorder-312.89 (F91.8)" },
		{ value: "463", label: "Other specified dissociative disorder-300.15 (F44.89)" },
		{ value: "464", label: "Other specified feeding or eating disorder-307.59 (F50.8)" },
		{ value: "465", label: "Other specified mental disorder-300.9 (F99)" },
		{ value: "466", label: "Other specified mental disorder due to another medical condition-294.8 (F06.8)" },
		{ value: "467", label: "Other specified neurodevelopmental disorder-315.8 (F88)" },
		{ value: "468", label: "Other specified obsessive-compulsive and related disorder-300.3 (F42)" },
		{ value: "469", label: "Other specified personality disorder-301.89 (F60.89)" },
		{ value: "470", label: "Other specified schizophrenia spectrum and other psychotic disorder-298.8 (F28)" },
		{ value: "471", label: "Other specified trauma- and stressor-related disorder-309.89 (F43.8)" },
		{ value: '106', label: "Overweight or obesity-278.00 (E66.9)" },
		{ value: "37", label: "Panic disorder-300.01 (F41.0)" },
		{ value: "38", label: "Paranoid personality disorder-301.0 (F60.0)" },
		{ value: "39", label: "Persistent depressive disorder (dysthymia)-300.4 (F34.1)" },
		{ value: "40", label: "Personal history of self-harm-V15.59 (Z91.5)" },
		{ value: "", label: "Personal history of self-harm-V15.59 (Z91.5)" },
		{ value: "117", label: "Phencyclidine intoxication delirium-292.81" },
		{ value: "472", label: "Phencyclidine intoxication delirium, With mild use disorder (F16.121)" },
		{ value: "473", label: "Phencyclidine intoxication delirium, With moderate or severe use disorder (F16.221)" },
		{ value: "474", label: "Phencyclidine intoxication delirium, Without use disorder (F16.921)" },
		{ value: "475", label: "Phencyclidine-induced anxiety disorder-292.89" },
		{ value: "476", label: "Phencyclidine-induced anxiety disorder, With mild use disorder (F16.180)" },
		{ value: "477", label: "Phencyclidine-induced anxiety disorder, With moderate or severe use disorder (F16.280)" },
		{ value: "478", label: "Phencyclidine-induced anxiety disorder, Without use disorder (F16.980)" },
		{ value: "479", label: "Phencyclidine-induced bipolar and related disorder-292.84" },
		{ value: "480", label: "Phencyclidine-induced bipolar and related disorder, With mild use disorder (F16.14)" },
		{ value: "481", label: "Phencyclidine-induced bipolar and related disorder, With moderate or severe use disorder (F16.24)" },
		{ value: "482", label: "Phencyclidine-induced bipolar and related disorder, Without use disorder (F16.94)" },
		{ value: "483", label: "Phencyclidine-induced depressive disorder-292.84" },
		{ value: "484", label: "Phencyclidine-induced depressive disorder, With mild use disorder (F16.14)" },
		{ value: "485", label: "Phencyclidine-induced depressive disorder, With moderate or severe use disorder (F16.24)" },
		{ value: "486", label: "Phencyclidine-induced depressive disorder, Without use disorder (F16.94)" },
		{ value: "487", label: "Phencyclidine-induced psychotic disorder-292.9" },
		{ value: "488", label: "Phencyclidine-induced psychotic disorder, With mild use disorder (F16.159)" },
		{ value: "489", label: "Phencyclidine-induced psychotic disorder, With moderate or severe use disorder (F16.259)" },
		{ value: "490", label: "Phencyclidine-induced psychotic disorder, Without use disorder (F16.959)" },
		{ value: "41", label: "Posttraumatic stress disorder-309.81" },
		{ value: "491", label: "Psychotic disorder due to another medical condition" },
		{ value: "492", label: "Psychotic disorder due to another medical condition, With delusions-293.81 (F06.2)" },
		{ value: "493", label: "Psychotic disorder due to another medical condition, With hallucinations-293.82 (F06.0)" },
		{ value: "494", label: "Schizoaffective disorder, Bipolar type-295.7 (F25.0)" },
		{ value: "495", label: "Schizoaffective disorder, Depressive type-295.7 (F25.1)" },
		{ value: "42", label: "Schizoid Personality Disorder-301.20 (F60.1)" },
		{ value: "43", label: "Schizophrenia-295.90 (F20.9)" },
		{ value: "496", label: "Schizophreniform disorder-295.4 (F20.81)" },
		{ value: "44", label: "Schizotypal personality disorder-301.22 (F21)" },
		{ value: "497", label: "Sedative, hypnotic, or anxiolytic intoxication delirium-292.81" },
		{ value: "498", label: "Sedative, hypnotic, or anxiolytic intoxication delirium, With mild use disorder (F13.121)" },
		{ value: "499", label: "Sedative, hypnotic, or anxiolytic intoxication delirium, With moderate or severe use disorder (F13.221)" },
		{ value: "500", label: "Sedative, hypnotic, or anxiolytic intoxication delirium, Without use disorder (F13.921)" },
		{ value: "501", label: "Sedative, hypnotic, or anxiolytic withdrawal delirium-292 (F13.231)" },
		{ value: "502", label: "Sedative, hypnotic, or anxiolytic withdrawal, With perceptual disturbances (F13.232)" },
		{ value: "503", label: "Sedative, hypnotic, or anxiolytic withdrawal, Without perceptual disturbances (F13.239)" },
		{ value: "504", label: "Sedative-, hypnotic-, or anxiolytic-induced anxiety disorder-292.89" },
		{ value: "505", label: "Sedative-, hypnotic-, or anxiolytic-induced anxiety disorder, With mild use disorder(F13.180)" },
		{ value: "506", label: "Sedative-, hypnotic-, or anxiolytic-induced anxiety disorder, With moderate or severe use disorder (F13.280)" },
		{ value: "507", label: "Sedative-, hypnotic-, or anxiolytic-induced anxiety disorder, Without use disorder (F13.980)" },
		{ value: "508", label: "Sedative-, hypnotic-, or anxiolytic-induced bipolar and related disorder-292.84" },
		{ value: "509", label: "Sedative-, hypnotic-, or anxiolytic-induced bipolar and related disorder, With mild use disorder (F13.14)" },
		{ value: "510", label: "Sedative-, hypnotic-, or anxiolytic-induced bipolar and related disorder, With moderate or severe use disorder (F13.24)" },
		{ value: "511", label: "Sedative-, hypnotic-, or anxiolytic-induced bipolar and related disorder, Without use disorder (F13.94)" },
		{ value: "512", label: "Sedative-, hypnotic-, or anxiolytic-induced delirium (F13.921)" },
		{ value: "513", label: "Sedative-, hypnotic-, or anxiolytic-induced depressive disorder-292.84" },
		{ value: "514", label: "Sedative-, hypnotic-, or anxiolytic-induced depressive disorder, With mild use disorder (F13.14)" },
		{ value: "515", label: "Sedative-, hypnotic-, or anxiolytic-induced depressive disorder, With moderate or severe use disorder (F13.24)" },
		{ value: "516", label: "Sedative-, hypnotic-, or anxiolytic-induced depressive disorder, Without use disorder (F13.94)" },
		{ value: "517", label: "Sedative-, hypnotic-, or anxiolytic-induced major neurocognitive disorder-292.82" },
		{ value: "518", label: "Sedative-, hypnotic-, or anxiolytic-induced major neurocognitive disorder, With moderate or severe use disorder (F13.27)" },
		{ value: "519", label: "Sedative-, hypnotic-, or anxiolytic-induced major neurocognitive disorder, Without use disorder (F13.97)" },
		{ value: "520", label: "Sedative-, hypnotic-, or anxiolytic-induced mild neurocognitive disorder-292.89" },
		{ value: "521", label: "Sedative-, hypnotic-, or anxiolytic-induced mild neurocognitive disorder, With moderate or severe use disorder (F13.288)" },
		{ value: "522", label: "Sedative-, hypnotic-, or anxiolytic-induced mild neurocognitive disorder, Without use disorder (F13.988)" },
		{ value: "523", label: "Sedative-, hypnotic-, or anxiolytic-induced psychotic disorder-292.9" },
		{ value: "524", label: "Sedative-, hypnotic-, or anxiolytic-induced psychotic disorder, With mild use disorder (F13.159)" },
		{ value: "525", label: "Sedative-, hypnotic-, or anxiolytic-induced psychotic disorder, With moderate or severe use disorder (F13.259)" },
		{ value: "526", label: "Sedative-, hypnotic-, or anxiolytic-induced psychotic disorder, Without use disorder (F13.959)" },
		{ value: "527", label: "Sedative-, hypnotic-, or anxiolytic-induced sexual dysfunction-292.89" },
		{ value: "528", label: "Sedative-, hypnotic-, or anxiolytic-induced sexual dysfunction, With mild use disorder (F13.181)" },
		{ value: "529", label: "Sedative-, hypnotic-, or anxiolytic-induced sexual dysfunction, With moderate or severe use disorder (F13.281)" },
		{ value: "530", label: "Sedative-, hypnotic-, or anxiolytic-induced sexual dysfunction, Without use disorder (F13.981)" },
		{ value: "531", label: "Sedative-, hypnotic-, or anxiolytic-induced sleep disorder-292.85" },
		{ value: "532", label: "Sedative-, hypnotic-, or anxiolytic-induced sleep disorder, With mild use disorder (F13.182)" },
		{ value: "533", label: "Sedative-, hypnotic-, or anxiolytic-induced sleep disorder, With moderate or severe use disorder (F13.282)" },
		{ value: "534", label: "Sedative-, hypnotic-, or anxiolytic-induced sleep disorder, Without use disorder (F13.982)" },
		{ value: '129', label: "Separation anxiety disorder-309.21 (F93.0)" },
		{ value: "45", label: "Social anxiety disorder (social phobia)-300.23 (F40.10)" },
		{ value: "535", label: "Tobacco-induced sleep disorder-292.85" },
		{ value: "536", label: "Tobacco-induced sleep disorder, With moderate or severe use disorder (F17.208)" },
		{ value: "537", label: "Delirium Unspecified-780.09 (R41.0)" },
		{ value: "538", label: "Depressive disorder Unspecified-311 (F32.9)" },
		{ value: "539", label: "Disruptive, impulse-control, and conduct disorder Unspecified-312.9 (F91.9)" },
		{ value: "540", label: "Dissociative disorder Unspecified-300.15 (F44.9)" },
		{ value: "541", label: "Feeding or eating disorder Unspecified-307.5 (F50.9)" },
		{ value: "542", label: "Hallucinogen-related disorder Unspecified-292.9 (F16.99)" },
		{ value: "543", label: "Inhalant-related disorder Unspecified-292.9 (F18.99)" },
		{ value: "544", label: "Insomnia disorder Unspecified-780.52 (G47.00)" },
		{ value: "545", label: "Mental disorder Unspecified-300.9 (F99)" },
		{ value: "546", label: "Obsessive-compulsive and related disorder Unspecified-300.3 (F42)" },
		{ value: "547", label: "Opioid-related disorder Unspecified-292.9 (F11.99)" },
		{ value: "548", label: "Other (or unknown) substance-related disorder Unspecified-292.9 (F19.99)" },
		{ value: "549", label: "Personality disorder Unspecified-301.9 (F60.9)" },
		{ value: "550", label: "Phencyclidine-related disorder Unspecified-292.9 (F16.99)" },
		{ value: "551", label: "Schizophrenia spectrum and other psychotic disorder Unspecified-298.9 (F29)" },
		{ value: "552", label: "Sedative-, hypnotic-, or anxiolytic-related disorder Unspecified-292.9 (F13.99)" },
		{ value: "553", label: "Stimulant-related disorder Unspecified-292.9" },
		{ value: "554", label: "Tobacco-related disorder Unspecified-292.9 (F17.209)" },
		{ value: "555", label: "Trauma- and stressor-related disorder Unspecified-309.9 (F43.9)" },
		
	],
	RecommendationOptions: [
		{ value: "no_intervention_referred_out", label: "No Intervention necessary/Referred Out" },
		{ value: "intervention", label: "Intervention" },
		{ value: "medical_detox", label: "Medical Detox" },
		{ value: "inpatient_rehab", label: "Inpatient Rehab" },
		{ value: "stages_of_change_program", label: "Harm Reduction/Stages of change program" },
		{ value: "iop", label: "IOP/TSF (Intensive Outpatient/Twelve-Step Facilitation)" },
		{ value: "immersion", label: "7 days Immersion" },
		{ value: "retreat", label: "21 day Retreat" },
		{ value: "psychiatric_assessment", label: 'Psychiatric Assessment' },
		{ value: "psychological_test", label: 'Psychological Test' },
		{ value: "individual_counseling", label: "Individual Counseling" },
		{ value: "groups_1", label: "Groups" },
		{ value: "family_counseling_1", label: "Family Counseling" },
		{ value: "trauma_therapy_1", label: "Trauma Therapy" },
	],
	CommitmentToPrivacy: "Commitment to Privacy",
	Tests: "Tests",
	AgreementBasedFees: [
		{
			key: 1,
			service: "Individual",
			clientIndividual: "6",
			clientGroups: "",
			psychiatric: "",
			psychological: "",
			familyIndividual: "",
			familyGroups: "",
			totalINR: "36000",
			totalUSD: "400",
			totalINREdit: "",
			totalUSDEdit: "",
		},
		{
			key: 2,
			service: "Family Program",
			clientIndividual: "",
			clientGroups: "",
			psychiatric: "",
			psychological: "",
			familyIndividual: "10",
			familyGroups: "10",
			totalINR: "70000",
			totalUSD: "750",
			totalINREdit: "",
			totalUSDEdit: "",
		},
		{
			key: 3,
			service: "Harm Reduction",
			clientIndividual: "12",
			clientGroups: "",
			psychiatric: "",
			psychological: "",
			familyIndividual: "8",
			familyGroups: "",
			totalINR: "100000",
			totalUSD: "1100",
			totalINREdit: "",
			totalUSDEdit: "",
		},
		{
			key: 4,
			service: "IOP-TSF",
			clientIndividual: "36",
			clientGroups: "12",
			psychiatric: "2",
			psychological: "1",
			familyIndividual: "10",
			familyGroups: "10",
			totalINR: "300000",
			totalUSD: "4250",
			totalINREdit: "",
			totalUSDEdit: "",
		},
		{
			key: 5,
			service: "Immersion Goa",
			clientIndividual: "58",
			clientGroups: "12",
			psychiatric: "2",
			psychological: "1",
			familyIndividual: "10",
			familyGroups: "10",
			totalINR: "400000",
			totalUSD: "5300",
			totalINREdit: "",
			totalUSDEdit: "",
		},
		{
			key: 6,
			service: "Immersion Out",
			clientIndividual: "58",
			clientGroups: "12",
			psychiatric: "2",
			psychological: "1",
			familyIndividual: "10",
			familyGroups: "10",
			totalINR: "500000",
			totalUSD: "5300",
			totalINREdit: "",
			totalUSDEdit: "",
		},
		{
			key: 7,
			service: "Continued Care",
			clientIndividual: "10",
			clientGroups: "10",
			psychiatric: "",
			psychological: "",
			familyIndividual: "",
			familyGroups: "",
			totalINR: "70000",
			totalUSD: "750",
			totalINREdit: "",
			totalUSDEdit: "",
		},
		{
			key: 8,
			service: "Refresher",
			clientIndividual: "18",
			clientGroups: "",
			psychiatric: "1",
			psychological: "",
			familyIndividual: "10",
			familyGroups: "10",
			totalINR: "150000",
			totalUSD: "1600",
			totalINREdit: "",
			totalUSDEdit: "",
		},
	],
	ScreeningResultMessages: {
		cage: [
			{ min: 4, max: 4, message: "There is a 100% chance you're addicted to substance." },
			{ min: 3, max: 3, message: "There is a 99% chance you're addicted to substance." },
			{ min: 2, max: 2, message: "There is an 89% chance you're addicted to substance." },
			{ min: 1, max: 1, message: "There is an 80% chance you're addicted to substance." },
		],
		dast: [
			{ min: 0, max: 0, message: "No apparent problem" },
			{ min: 1, max: 2, message: "Monitor recipient and reassess later" },
			{ min: 3, max: 5, message: "Investigate substance use further" },
			{ min: 6, max: Infinity, message: "Address the problem immediately" },
		],
		gambling: [
			{ min: 8, max: 10, message: "Severe" },
			{ min: 6, max: 7, message: "Moderate" },
			{ min: 4, max: 5, message: "Mild" },
			{ min: -Infinity, max: 3, message: "Not applicable" },
		],
		mmmh: [
			{ min: 11, max: Infinity, message: "Full assessment needed" },
			{ min: 6, max: 9, message: "Assessment needed should be determined by treatment team" },
			{ min: -Infinity, max: 4, message: "No action necessary unless determined by treatment team" },
		],
	},
	BackToDashboard: 'Back to Dashboard',
	PotentialRecipient: "Potential Recipient",
	FollowUp: "Follow Up",
	AddClient: "Add Client",
	SelectAssociate: "Select an Associate",
	InstinctOptions: [
		{
			label: "Sex",
			options: [
				{
					label: "Connections",
					value: "Connections"
				},
				{
					label: "Relationships",
					value: "Relationships"
				}
			]
		},
		{
			label: "Social",
			options: [
				{
					label: "Fame",
					value: "Fame"
				},
				{
					label: "Popularity",
					value: "Popularity"
				},
				{
					label: "Self-esteem",
					value: "Self-esteem"
				}
			]
		},
		{
			label: "Survival",
			options: [
				{
					label: "Jobs",
					value: "Jobs"
				},
				{
					label: "Money",
					value: "Money"
				},
				{
					label: "Power",
					value: "Power"
				}
			]
		}
	],
	Billable: "Billable Notes",
	NonBillable: "Non-Billable Notes",
	QuestionsPreAssessment: [
		{
			title: "Gambling:",
			question: "Have you ever received any treatment or gone to GA?",
			name: "gambling_treat",
			yesValue: "yes",
			noValue: "no",
			responses: {
				yes: "Client reports history of gambling treatment or attending GA.",
				no: "Client denies history of gambling issues or treatment."
			}
		},
		{
			title: "Community:",
			question: "Do you have any sober support systems?",
			name: "community_support",
			yesValue: "yes",
			noValue: "no",
			responses: {
				yes: "Client reports having a healthy sober support system.",
				no: "Client lacks a sober support system."
			},
		},
		{
			title: "Mental/Emotional Health:",
			question: "Have you ever been diagnosed with or been treated for any Mental health or Emotional issues?",
			name: "mental_treat",
			yesValue: "yes",
			noValue: "no",
			responses: {
				yes: "Client reports history of MH issues.",
				no: "Client denies history of MH issues."
			}
		},
		{
			title: "Medical/Physical Health:",
			question: "Do you have any medical conditions/issues at this time?",
			name: "medical_6",
			yesValue: "illnesses/disease",
			noValue: "no illnesses/disease",
			responses: {
				"illnesses/disease": "Client reports medical issues.",
				"no illnesses/disease": "Client reports good health."
			}
		},
		{
			title: "Spirituality/Religion:",
			question: "Do you believe in God/Higher Power?",
			name: "spiritual_3",
			yesValue: "yes",
			noValue: "no",
			responses: {
				yes: "Client has a positive spiritual outlook.",
				no: "Client lacks a belief or reports confusion about spiritual matters."
			}
		},
	],
	AdditionalPreAssessmentSections: [
		{
			title: "Family:",
			fields: [
				{
					name: "family_3",
					format: (value, firstName) => value ? `${firstName} reports current living situation as ${value}.` : ""
				},
				{
					name: "supportive_family",
					condition: (formValues) => formValues?.family_3 && formValues?.family_3 !== 'living alone',
					responses: {
						yes: "reports stable supportive relationship with family/friends.",
						no: "reports non-supportive relationship with family/friends"
					}
				}
			]
		},
		{
			title: "Education:",
			fields: [
				{
					name: "family_10",
					format: (value, firstName, formValues) => {
						if (!value) return "";
						const educationOption = constants.EducationOptions.find(opt => opt.value === value);
						const educationLabel = educationOption ? educationOption.label : value;
						const details = formValues?.education_details ? ` (${formValues?.education_details})` : "";
						return `${firstName} reports educational background: ${educationLabel}${details}.`;
					}
				}
			]
		},
		{
			title: "Employment:",
			fields: [
				{
					name: "family_11",
					format: (value, firstName) => {
						if (!value) return "";
						const occupationOption = constants.OccupationOptions.find(opt => opt.value === value);
						const occupationLabel = occupationOption ? occupationOption.label : value;
						return `${firstName} is ${occupationLabel}.`;
					}
				}
			]
		},
		{
			title: "Legal:",
			fields: [
				{
					name: "family_8",
					responses: {
						current: "reports ongoing legal matters.",
						no: "denies any ongoing legal matters."
					}
				}
			]
		}
	],
	ForcedClosedReasons:[
		{
			value: "Became a client"
		},
		{
			value: "Called for referral only"
		},
		{
			value: "Lost to Contact"
		},
		{
			value: "Declined Services"
		}
	],
	AssessmentGroupNotesOptions: [
		{
			topic: "Engagement & Participation",
			options: [
				"actively participated in group discussions",
				"listened attentively to peers without interrupting",
				"shared personal experiences with honesty and openness",
				"avoided or resisted participation in group activities",
				"used humor or deflection to avoid emotional topics",
			],
		},
		{
			topic: "Insight & Self-Awareness",
			options: [
				"identified personal triggers and patterns",
				"acknowledged impact of substance use on self and others",
				"demonstrated insight into emotional responses",
				"blamed others or externalized responsibility",
				"minimized or denied substance-related consequences",
			],
		},
		{
			topic: "Coping & Recovery Skills",
			options: [
				"described use of healthy coping strategies",
				"reported abstinence or reduction in substance use",
				"followed through on recovery-related commitments",
				"struggled to apply coping tools outside group",
				"expressed ambivalence about change",
			],
		},
		{
			topic: "Interpersonal Behavior",
			options: [
				"showed empathy and support toward peers",
				"respected group boundaries and confidentiality",
				"displayed hostility, sarcasm, or withdrawal",
				"sought feedback and responded non-defensively",
				"dominated conversation or sought attention excessively",
			],
		},
		{
			topic: "Motivation & Readiness",
			options: [
				"set and pursued personal recovery goals",
				"expressed hope and commitment to change",
				"demonstrated resistance or avoidance",
				"showed fluctuating motivation or ambivalence",
				"responded positively to encouragement and structure",
			],
		},
	],
	LocatrAssessment:"LOCADTR Assessment",
	WelcomeSelfAssess: [<><h2 className='font-bold pb-2 text-xl text-sky-900'>Welcome to RoyCares</h2>
		<p className='pb-2'>
			You are about to complete a self-evaluation form. This should take around
			<strong> 20 minutes</strong>, and most questions will be answered with a
			simple <strong>yes</strong> or <strong>no</strong>.
		</p>
		<p className='pb-2'>
			We encourage you to sit with a loved one while answering, as they may help
			you recall details that aren't fully clear.
		</p>
		<p className='pb-2'>
			Thank you for taking the time.
		</p></>],
	DefaultBucketSectionList: [
		{
			"key": 1,
			"bucket": null,
			"example": "Buy a new phone or laptop",
			"table": "BucketList",
			"section": "Material Rewards",
		},
		{
			"key": 2,
			"bucket": null,
			"example": "Get a stylish watch or jewelry",
			"table": "BucketList",
			"section": "Material Rewards",
		},
		{
			"key": 3,
			"bucket": null,
			"example": "Treat myself to new clothes or shoes",
			"table": "BucketList",
			"section": "Material Rewards",
		},
		{
			"key": 4,
			"bucket": null,
			"example": "Save up for a luxury item (camera, bike)",
			"table": "BucketList",
			"section": "Material Rewards",
		},
		{
			"key": 5,
			"bucket": null,
			"example": "Redecorate my room or home",
			"table": "BucketList",
			"section": "Lifestyle Upgrades",
		},
		{
			"key": 6,
			"bucket": null,
			"example": "Invest in a comfortable bed/mattress",
			"table": "BucketList",
			"section": "Lifestyle Upgrades",
		},
		{
			"key": 7,
			"bucket": null,
			"example": "Get a gym membership or workout gear",
			"table": "BucketList",
			"section": "Lifestyle Upgrades",
		},
		{
			"key": 8,
			"bucket": null,
			"example": "Buy kitchen tools to make cooking easier",
			"table": "BucketList",
			"section": "Lifestyle Upgrades",
		},
		{
			"key": 9,
			"bucket": null,
			"example": "Plan a weekend getaway",
			"table": "BucketList",
			"section": "Travel & Experiences",
		},
		{
			"key": 10,
			"bucket": null,
			"example": "Book an international trip",
			"table": "BucketList",
			"section": "Travel & Experiences",
		},
		{
			"key": 11,
			"bucket": null,
			"example": "Try an adventure activity (trek, scuba)",
			"table": "BucketList",
			"section": "Travel & Experiences",
		},
		{
			"key": 12,
			"bucket": null,
			"example": "Go to a concert or festival",
			"table": "BucketList",
			"section": "Travel & Experiences",
		},
		{
			"key": 13,
			"bucket": null,
			"example": "Host a sober party",
			"table": "BucketList",
			"section": "Celebrations",
		},
		{
			"key": 14,
			"bucket": null,
			"example": "Have a fancy dinner at a favorite restaurant",
			"table": "BucketList",
			"section": "Celebrations",
		},
		{
			"key": 15,
			"bucket": null,
			"example": "Buy tickets for a sports or theater show",
			"table": "BucketList",
			"section": "Celebrations",
		},
		{
			"key": 16,
			"bucket": null,
			"example": "Get a tattoo or symbolic item",
			"table": "BucketList",
			"section": "Celebrations",
		},
		{
			"key": 17,
			"bucket": null,
			"example": "Open a savings account for rewards",
			"table": "BucketList",
			"section": "Financial Wins",
		},
		{
			"key": 18,
			"bucket": null,
			"example": "Buy stocks or invest in something",
			"table": "BucketList",
			"section": "Financial Wins",
		},
		{
			"key": 19,
			"bucket": null,
			"example": "Pay off a debt",
			"table": "BucketList",
			"section": "Financial Wins",
		},{
			"key": 20,
			"bucket": null,
			"example": "Save toward a dream car or bike",
			"table": "BucketList",
			"section": "Financial Wins",
		},
		{
			"key": 21,
			"bucket": null,
			"example": "Take a yoga or meditation course",
			"table": "BucketList",
			"section": "Spiritual Goals",
		},
		{
			"key": 22,
			"bucket": null,
			"example": "Visit a spiritual place (ashram, temple)",
			"table": "BucketList",
			"section": "Spiritual Goals",
		},
		{
			"key": 23,
			"bucket": null,
			"example": "Create a personal ritual or altar",
			"table": "BucketList",
			"section": "Spiritual Goals",
		},
		{
			"key": 24,
			"bucket": null,
			"example": "Join a spiritual group or satsang",
			"table": "BucketList",
			"section": "Spiritual Goals",
		}
	],
	BucketSections: {
		"Material Rewards": [
			"Buy a new phone or laptop",
			"Get a stylish watch or jewelry",
			"Treat myself to new clothes or shoes",
			"Save up for a luxury item (camera, bike)"
		],
		"Lifestyle Upgrades": [
			"Redecorate my room or home",
			"Invest in a comfortable bed/mattress",
			"Get a gym membership or workout gear",
			"Buy kitchen tools to make cooking easier"
		],
		"Travel & Experiences": [
			"Plan a weekend getaway",
			"Book an international trip",
			"Try an adventure activity (trek, scuba)",
			"Go to a concert or festival"
		],
		"Celebrations": [
			"Host a sober party",
			"Have a fancy dinner at a favorite restaurant",
			"Buy tickets for a sports or theater show",
			"Get a tattoo or symbolic item"
		],
		"Financial Wins": [
			"Open a savings account for rewards",
			"Buy stocks or invest in something",
			"Pay off a debt",
			"Save toward a dream car or bike"
		],
		"Spiritual Goals": [
			"Take a yoga or meditation course",
			"Visit a spiritual place (ashram, temple)",
			"Create a personal ritual or altar",
			"Join a spiritual group or satsang"
		]
	},
	WbVideoList:"Workbook Video List",
	Play:"Play",
	//client ids for whom we want to edit the locadtr assessment
	AllowedClientIds: [8, 224, 1, 221, 307],
	FollowUpData1: `WhatsApp message sent to `,
	FollowUpData2: `, as they have not been in contact for 2 weeks.`,
	FollowUpAssessment: "Has missed individual and/or group session(s).",
	FollowUpPlan: "Await client contact or follow-up in 2 weeks.",
	PlanOption: [
		{
			label: "Send follow up message to client.",
			value: "plan_follow_up"
		},
		{
			label: "Client to attend group next week.",
			value: "plan_attend_group"
		}
	],
	WorkbookType: "Workbook Type",
	DASTTest: "DAST",
	GamblingTest: "Gambling",
	MMMHTest: "MMMH",
	FamilyScreening: "Family Screening",
	CodependencyScreening: "Codependency Screening",
	SelfEvaluation: "Self Evaluation",
	ServicesRequiredFor: "Services are required for",
	YouAreCallingFor: "You are calling for",
	ChooseTheService: "Choose the service",
	Alcohol: "Alcohol",
	Drug: "Drug",
	EmotionalGeneral: "Emotional/General",
	MentalHealthPsychiatric: "Mental Health/Psychiatric",
	ScreenAddiction: "Screen Addiction",
	Lifestyle: "Lifestyle",
	ContactTimeOptions: [
		{ label: 'Morning — 9:00 AM to 11:00 AM', value: 1 },
		{ label: 'Afternoon — 2:00 PM to 4:00 PM', value: 2 },
		{ label: 'Evening — 6:00 PM to 8:00 PM', value: 3 },
	],
	ResetWbData:"Reset Workbook Data",
	AdmissionForm: "Admission Form",
	AdmissionAssessForm: "Admission Assessment Form",
	AdmissionAssessPara: "The recipient will be admitted to Outpatient Services based on the following criteria:",
	AdmissionCriteriaOptions: [
		{
			label: "The individual is determined to have a substance abuse disorder based on the criteria in the most recent version of the Diagnostic and Statistical Manual or the International Classification of Diseases.",
			value: "substance_abuse_disorder",
		},
		{
			label: "The recipient reports no known or suspected infectious disease.",
			value: "no_infectious_disease",
		},
		{
			label: "The individual appears not to be in need of acute hospital care, acute psychiatric care, a higher level of chemical dependency recovery services or other intensive services that cannot be provided in conjunction with outpatient care or would prevent him/her from participating in a chemical dependence outpatient service.",
			value: "no_acute_care_needed",
		},
		{
			label: "The individual is a significant other who manifests psychological, behavioral and/or emotional effects arising from another individual's chemical abuse or dependence and has been determined by the provider to be able to actively participate in and benefit from the recovery process.",
			value: "significant_other",
		},
	]
};
export default constants;
